import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from "jquery";
import angular from "angular";
import d3 from "d3";
import moment from "moment";
import { showCampaignResultsModal, initConfigureReportModal, hideCampaignResultsModal } from "./modalv2";
import "./directives/directive-mapping.js";
import "./modalv2";

//TO DO: Replace these with npm packages and remove .min.js files
import alertify from "./res/lib/alertifyjs/alertify.min.js";
import "./res/lib/fullcalendar/all-calendar-deps.min.js";
import "./res/lib/moment/moment-timezone-with-data-2012-2022.js";
import "./lib/jqueryemoji/js/jQueryEmoji.js";
import { react2angular } from 'react18-react2angular';
import AccountAnalyticsPage from "./components/analytics/account-analytics-page.jsx";
import EditAnalyticsReportContent from "./components/analytics/create-analytics-report-modal/edit-analytics-report-content.jsx";
import PlatformIcon from "./components/common/platform-icon.jsx";
import ReactDonutChart from "./components/analytics/donut-chart.jsx";
import TopPosts from "./components/analytics/top-posts.jsx";
import { registerApiFactory } from './api/api-factory';

window.$ = $;

var app = angular.module('demo-analytics-app', ['n3-line-chart',  'n3-pie-chart']);

registerApiFactory(app);

app.component('platformIcon', react2angular(PlatformIcon, ['platform', 'classes', 'styles']));
app.component('reactDonutChart', react2angular(ReactDonutChart, ['data', 'options']));

app.directive('authorizePlatformDirective', ['$sce', function($sce) {
	return {
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/authorize-platform-modal.html"),
	};
}]);

app.directive('accountHashtagAnalyticsDirective', ['$sce', function($sce) {
	return {
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/reports/account-hashtag-analytics.html"),
	};
}]);

app.directive('overviewHashtagAnalyticsDirective', ['$rootScope', '$sce', function($rootScope, $sce) {
	return {
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/reports/overview-hashtag-analytics.html"),
	};
}]);

app.directive('categoryAnalyticsDirective', ['$sce', function($sce) {
	return {
		scope: {
		  isOverview: '=',
		  fakeDataNotAllowed: '=',
		  data: '=', 
		  formatNumber: '=', 
		  formatInt: '=',
		  maxPostCount: '=',
		  maxAvgImpressions: '=',
		  maxAvgEngagement: '=',
		  numItemsLimit: '=',
		  postCountNumItemsLimit: '=',
		  avgImpressionsNumItemsLimit: '=',
		  avgEngagementNumItemsLimit: '=',
		  expandCategoryGraphLimitFn: '=',
		  collapseCategoryGraphLimitFn: '=',
		  alphaSortFn: '=',
		  statSortFn: '=',
		  isPdf: '='
	    },
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/reports/category-analytics.html"),
	};
}]);

app.directive('categoryCardInternalDirective', ['$sce', function($sce) {
	return {
		scope: {
		  isOverview: '=',
		  data: '=', 
		  formatNumFn: '=', 
		  maxStatVal: '=',
		  limit: '=',
		  expandCategoryGraphLimitFn: '=',
		  collapseCategoryGraphLimitFn: '=',
		  propertyName: '=',
		  legendText: '=',
		  isImpressions: '=',
		  platformType: '=',
		  collapseArgument: '=',
		  isPdf: '='
	    },
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/reports/category-card-internal.html"),
	};
}]);

app.directive('categoryCardDirective', [ '$sce', function($sce) {
	return {
		scope: {
		  isOverview: '=',
		  fakeDataNotAllowed: '=',
		  data: '=', 
		  formatNumFn: '=', 
		  maxStatVal: '=',
		  numItemsLimit: '=',
		  individualNumItemsLimit: '=',
		  expandCategoryGraphLimitFn: '=',
		  collapseCategoryGraphLimitFn: '=',
		  alphaSortFn: '=',
		  statSortFn: '=',
		  dataIsMocked: '=', 
		  propertyName: '=',
		  cardTitle: '=',
		  cardDescription: '=',
		  legendText: '=',
		  isImpressions: '=',
		  platformType: '=',
		  isPdf: '='
	    },
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/reports/category-card.html"),
	};
}]);

app.directive('analyticsInsightsDirective', ['$sce', function($sce) {
	return {
		scope: {
		  noData: '=',
		  mostEngagingName: '=', 
		  mostEngagingNumPosts: '=', 
		  percentMoreEngaging: '=',
		  analyticsTypeName: '='
	    },
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/reports/analytics-insights.html"),
	};
}]);

app.directive('addCampaignResultsModalDirective', ['$sce', function($sce) {
	return {
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/dashboard/add-campaign-results-modal.html"),
	};
}]);

app.component(
  "accountAnalyticsPage",
  react2angular(AccountAnalyticsPage, [
    "accountList",
    "isReportView",
		"selectedAccountId",
		"isPdfView",
		"clientReport"
  ])
);
app.component(
  "editAnalyticsReportContent",
  react2angular(EditAnalyticsReportContent, [
    "clientReport",
    "saveReportConfiguration",
    "savingReportConfiguration",
    "updateReportError",
    "onUpdateClientReport",
    "isLoading",
  ])
);

app.component("topPosts", react2angular(TopPosts, ["topPosts", "isPdf"]));

var monthNames = [
	"Jan", "Feb", "Mar",
	"Apr", "May", "Jun", "Jul",
	"Aug", "Sept", "Oct",
	"Nov", "Dec"
];

var fullMonthNames = [
	"January", "February", "March",
	"April", "May", "June", "July",
	"August", "September", "October",
	"November", "December"
];

var isPdfReportReady = false;

// Images loaded is zero because we're going to process a new set of images.
var imagesLoaded = 0;
// Total images is still the total number of <img> elements on the page.
var totalImages = 1;

//Videos loaded is zero because we're going to process a new set of videos.
var videosLoaded = 0;
// Total videos is still the total number of <video> elements on the page.
var totalVideos = 1;

// default load time to 50 seconds
// will be set by param
var maxLoadTime = 50;
var loadTime = 0;

function checkMaxTimeEllapsed(){
	return loadTime >= maxLoadTime;
}

function isPdfReady() {
	return (isPdfReportReady && areAllImagesLoaded() && areAllVideosLoaded()) || checkMaxTimeEllapsed() ;
}

function areAllImagesLoaded(){
	if (imagesLoaded == totalImages) {
		console.log("All Images Loaded");
		return true;
	}
	console.log("Only " + imagesLoaded + " images have loaded. There are "+totalImages+" total images.");
	return false;
}

function areAllVideosLoaded(){
	if (videosLoaded == totalVideos) {
		console.log("All Videos Loaded");
		return true;
	}
	console.log("Only " + videosLoaded + " videos have loaded. There are "+totalVideos+" total videos.");
	return false;
}

function prettyDate(date) {
  return monthNames[date.getUTCMonth()] + ' ' + date.getUTCDate() + ', ' + date.getUTCFullYear();
}

function prettyLocalDate(date) {
  return monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
}

function prettyMonth(date) {
  return fullMonthNames[date.getUTCMonth()] + ' ' + date.getUTCFullYear();
}

function formatNumberWithDecorator(number, decimals)
{
	if(number == undefined || number == 0) {
		return 0;
	}
	
	if(decimals == undefined) {
		decimals = 0;
	}
	
	if(number >= 1000000)
	{
		var millions = number / 1000000;
		return parseFloat(millions).toFixed(decimals) + "M";
	}
	else if(number >= 1000)
	{
		var thousands = number / 1000;
		return parseFloat(thousands).toFixed(decimals) + "k";
	}
	else if(number >= 100)
	{
		return parseFloat(number).toFixed(decimals)
	}
	else
	{
		return parseFloat(number).toFixed(1)
	}
}

function formatNumberWithCommas(number) {
	if(number == undefined || isNaN(number) || number == 0) {
		return number;
	}
	    	
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function formatNumber(number) {
	if(number == undefined || isNaN(number) || number == 0) {
		return number;
	}
	    	
    return number >= 10000 ? formatNumberWithDecorator(number, 1) : formatNumberWithCommas(number);
}

function formatPercent(number) {
	if(number == undefined || isNaN(number) || number == 0) {
		return number;
	}
	    	
	var percent = number * 100;
	return parseFloat(percent).toFixed(1) + "%";
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function finiteNumber(nanSubstitute, thousandsSeparator, decimalSeparator, scale, prefix, suffix){
	return { display: function ( data) {
			scale = scale === undefined ? 0 : scale
			prefix = prefix === undefined ? '' : prefix
			suffix = suffix === undefined ? '' : suffix
			return  data === null || data.length === 0 || !isFinite(data) ? prefix + nanSubstitute + suffix : number(thousandsSeparator, decimalSeparator, scale, prefix, suffix).display(data);
		}
	};
}

function number( thousands, decimal, precision, prefix, postfix ) {
	return {
		display: function ( value ) {
			if ( typeof value !== 'number' && typeof value !== 'string' ) {
				return value;
			}

			let negative = value < 0 ? '-' : '';
			let flo = parseFloat( value );

			if ( isNaN( flo ) ) {
				return value;
			}

			flo = flo.toFixed( precision );
			value = Math.abs( flo );

			let intPart = parseInt( value, 10 );
			let floatPart = precision ?
				decimal+(value - intPart).toFixed( precision ).substring( 2 ):
				'';

			return negative + (prefix||'') +
				intPart.toString().replace(
					/\B(?=(\d{3})+(?!\d))/g, thousands
				) +
				floatPart +
				(postfix||'');
		}
	};
}

var now = new Date();

String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

app.directive('editAnalyticsReportDirective', ['$sce', function($sce) {
	return {
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/dashboard/edit-analytics-report-modal_react.html"),
		compile : function() {
			initConfigureReportModal();
		}
	};
}]);

app.filter('formatNumber', function () {

    return function(text) { 
    	
    	if(text == undefined || text.length == 0) {
    		return text;
    	}

    	return formatNumber(text);       
    }
});

app.directive('whiteLabelAnalyticsReportDirective', ['$sce', function($sce) {
	return {
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/white-label/white-label-client-analytics-report.html"),
	};	
}]);

app.directive('analyticsReportDirective', ['$sce', function($sce) {
	return {
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/client-analytics-report.html"),
	};	
}]);

app.directive('updateAnalyticsReportCoverPageDirective', ['$sce', function($sce) {
	return {
		templateUrl: $sce.trustAsResourceUrl("https://d23ypky16g08sh.cloudfront.net/dashboard/update-analytics-report-cover-page-modal.html"),
	};
}]);

app.directive('jqdatatable', function () {
	return {
	        restrict: 'A',
	        link: function (scope, elem, attrs) {
	        	var options = {};

	        	// Start with the defaults. Change this to your defaults.
	        	options = {}

	        	// If dtOptions is defined in the controller, extend our default option.
	        	if (typeof scope.dtOptions !== 'undefined') {
	        		angular.extend(options, scope.dtOptions);
	        	}

	            // If dtoptions is not declared, check the other options
	            if (attrs['dtoptions'] === undefined) {
	            	throw "Data table options are not defined!";
	            } else {
	                // If dtoptions is declare, extend the current options with it. 
	                angular.extend(options, scope[attrs['dtoptions']]);
	            }   
	        	
//	        	// for Angular http inceptors
//	            if (typeof options['fnServerData'] === 'undefined') {
//	                options['fnServerData'] = function (sSource, aoData, resultCb) {
//	                    $http.get(sSource, aoData).then(function (result) {
//	                        resultCb(result.data);
//	                    });
//	                };
//	            }

	        	// Get the column options, put it in a aocolumn object.
	        	// Obviously, mdata is the only one required.
	        	// I personally just needed those 3, if you need other more feel free to add it.
	        	// mData also accepts a function; I'm sure there's a more elegant way but for now
	        	// it detects if it's a function, and if it is, do it.
	        	
	        	
	        	
	            var updateAll = function(_dtOptions) {
	            	let updatedOptions = {};
	            	
		        	// If dtOptions is defined in the controller, extend our default option.
		        	if (typeof scope.dtOptions !== 'undefined') {
		        		angular.extend(updatedOptions, scope.dtOptions);
		        	}

		            // If dtoptions is not declared, check the other options
		            if (attrs['dtoptions'] === undefined) {
		            	throw "Data table options are not defined!";
		            } else {
		                // If dtoptions is declare, extend the current options with it. 
		                angular.extend(updatedOptions, _dtOptions);
		            }   
	            	
		        	// Just some basic validation.
		        	if (typeof updatedOptions['data'] === 'undefined' && typeof options['ajax'] === 'undefined' ) {
		        		throw "Data Source not defined! Must set data property or ajax propery";
		        	} 
		        	if(typeof updatedOptions['columns'] === 'undefined' ){
		        		updatedOptions.columns = [];

			        	// Get the thead rows.
			        	$(elem).find('thead th').each(function() {
			        		var colattr = $(this).data();
			        		
			        		// Detects if it's a function. Must exist in scope.
			        		if (colattr.mdata.indexOf("()") > 1) {

			        			// Simple one-liner that removes the ending ()
			        			var fn = scope[colattr.mdata.substring(0, colattr.mdata.length - 2)];

			        			// Throw an error if it's not a function. 
			        			if (typeof fn === 'function') {

			        				updatedOptions.columns.push({
			    	      			data: fn
			    		      	});		

			        			} else {

			        				throw "mData function does not exist in $scope.";

			        			}
			        			
			        		} else {
			        			
			        			updatedOptions.columns.push({
			        				"name": colattr.mdata,
			        				"data": colattr.mdata
			    	      	});	

			        		}
			        	});
		        	}
	            	
	            	// Load the datatable! 
		        	$(elem).DataTable(updatedOptions);
		        	// console.log(options);
	              };
	

	              scope.$watch(attrs['dtoptions'], updateAll, true);


	        }
	    }
});

app.controller('DemoAnalyticsCtrl', ["$rootScope", "$scope", "ApiFactory", function($rootScope, $scope, ApiFactory) {
	$scope.hideCampaignResultsModal = hideCampaignResultsModal;
	// Object.assign() polyfill for IE11
	if (typeof Object.assign !== 'function') {
		// Must be writable: true, enumerable: false, configurable: true
		Object.defineProperty(Object, "assign", {
			value: function assign(target, varArgs) { // .length of function is 2
				'use strict';
				if (target === null || target === undefined) {
					throw new TypeError('Cannot convert undefined or null to object');
				}

			  var to = Object(target);
			  for (var index = 1; index < arguments.length; index++) {
				  var nextSource = arguments[index];
				  if (nextSource !== null && nextSource !== undefined) {
					  for (var nextKey in nextSource) {
					  // Avoid bugs when hasOwnProperty is shadowed
						  	if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
		      					to[nextKey] = nextSource[nextKey];
		      				}
		      			}
		      		}
			  	}
		      	return to;
		    },
		    writable: true,
		    configurable: true
		});
	}
	
	$rootScope.accountAnalytics = {};
	$rootScope.accountAnalytics.selectedAccount = {};
	$rootScope.adAccountAnalytics = {};
	$rootScope.adAccountAnalytics.selectedAccount = {};
	$rootScope.isDoneLoading = false;

	function makeMainContentFixed() {
		if ($("#main_content").length > 0) {
			$("#main_content").css("overflow-y", "hidden");
		}
	}

	function makeMainContentScrollable() {
		if ($("#main_content").length > 0) {
			$("#main_content").css("overflow-y", "scroll");
		}
	}

	$scope.showUpdateAnalyticsReportCoverPageModal = function () {
		$("#update_analytics_report_cover_page_directive").show();

		makeMainContentFixed();
	};

	$scope.hideUpdateAnalyticsReportCoverPageModal = function () {
		$("#update_analytics_report_cover_page_directive").hide();

		makeMainContentScrollable();
	};
	
	/** ** HELPER METHODS *** */
	// Is Undefined
	$scope.isUndefined = function(foo) {
		return (foo == undefined);
	}
	
	$scope.isDefined = function(foo) {
		return !$scope.isUndefined(foo);
	}
	
	// Is Empty
	$scope.isEmpty = function(foo) {
		return $scope.isUndefined(foo) || foo.length == 0;
	}
	
	$scope.isNotEmpty = function(foo) {
		return !$scope.isEmpty(foo);
	}
	
	/** ** GENERIC API METHODS *** */

	/* GET REQUEST */
	$scope.getRequest = function(url, callback, errorCallback) {
		ApiFactory.get(url)
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
	}
	
	/* PUT REQUEST */
	$scope.putRequest = function(url, requestData, callback, errorCallback) {
		ApiFactory.put(url, requestData)
		.then(response => callback(response.data))
		.catch(error => errorCallback(error));
	}
	
	// Generic Alert
	$scope.genericAlert = function(title, message) {
		alertify.set({
			labels : {
				ok : "Ok",
				cancel : "Cancel"
			}
		});
		// If it's a json response, extract the data
		if (!$scope.isUndefined(message.data)) {
			message = message.data;
		}
		// message = String(message).replace(/\n/g, "<br/>");
		alertify.alert("<h2>" + title
				+ "</h2><br/><p>" + message
				+ "<br/></p>");
	}
	
	var dayNames = [
        "Sunday", "Monday", "Tuesday",
        "Wednesday", "Thursday", "Friday",
        "Saturday"
      ];
      
	var monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sept", "Oct",
        "Nov", "Dec"
      ];
	
	$scope.graphColors = {};
	$scope.graphColors['TWITTER'] = "#00aced";
	$scope.graphColors['FACEBOOK'] = "#3b5998";
	$scope.graphColors['FACEBOOK_ADS'] = "#3b5998";
	$scope.graphColors['YOUTUBE'] = "#ff0000";
	$scope.graphColors['INSTAGRAM'] = "#e1306c";
	$scope.graphColors['LINKEDIN'] = "#007bb6";
	$scope.graphColors['GMB'] = "#df4b37";
	$scope.graphColors['THREADS'] = "#80ADE1";
	
	function prettyGraphDate(date) {
		  var year = date.getFullYear() == now.getFullYear() ? '' : ' ' + date.getFullYear();
		  return dayNames[date.getDay()] + ", " + monthNames[date.getMonth()] + ' ' + date.getDate() + year;
	}
	
	var dailyDateTooltipHook = function(d){
		if(d == undefined) {
			return;
		}
			
	    return {
	      abscissas: prettyGraphDate(d[0].row.x),
	      rows:  d.map(function(s){
	        return {
	          label: s.series.label,
	          value: s.row.y1,
	          color: s.series.color,
	          id: s.series.id  
	        }
	      })
	    }
	};
	
	$scope.getMin = function(min, value)
	{	
		return (value < min) ? value * 0.8 : min;
	}
	
	$scope.getMax = function(max, value)
	{	
		return (value > max) ? value * 1.15 : max;
	}
	
	var historicalTooltipHook = function(d){
			if($scope.isDefined(d))
			{
        		return {
        		 abscissas: $scope.tooltipTitle(d),
		          rows:  d.map(function(s){
		            return {
		              abscissas: $scope.tooltipTitle(s),
		              label: s.series.label,
		              value: s.row.y1,
		              color: s.series.color,
		              id: s.series.id  
					}
				})
			}
		}
	};
	
	$scope.tooltipTitle = function(d)
	{
		if($scope.isNotEmpty(d)) { 
			var data = d[0];
			if($scope.isDefined(data) && $scope.isDefined(data.row) && $scope.isDefined(data.row.x)) {
				var date = new Date(data.row.x);
				var formattedDate = prettyMonth(date);
				return formattedDate;
			}
		}
		return "";
	}
	
	String.prototype.capitalizeAll = function() {
		var finalWord = "";
		let wordParts = this.split(" ");
		for(var i = 0; i < wordParts.length; i++) {
			var wordPart = wordParts[i];
			finalWord += (i > 0 ? " " : "") + wordPart.charAt(0).toUpperCase() + wordPart.slice(1);
		}
		
		return finalWord;
	}
	
	$scope.formatNumFollowers = function(numFollowers)
	{
		var numFollowersFormatted;
		
		if(numFollowers / 1000000 >= 1)
		{
			var millionFollowers = numFollowers / 1000000;
			numFollowersFormatted = parseFloat(millionFollowers).toFixed(1) + "M";
		}
		else if(numFollowers / 1000 >= 1)
		{
			var thousandFollowers = numFollowers / 1000;
			numFollowersFormatted = parseFloat(thousandFollowers).toFixed(1) + "k";
		}
		else
		{
			numFollowersFormatted = numFollowers;
		}
		
		return numFollowersFormatted;
	}
	
	$rootScope.currencySymbolMap =
	{
		AED: "د.إ",
		AFN: "؋",
		ALL: "L",
		AMD: "֏",
		ANG: "ƒ",
		AOA: "Kz",
		ARS: "$",
		AUD: "$",
		AWG: "ƒ",
		AZN: "₼",
		BAM: "KM",
		BBD: "$",
		BDT: "৳",
		BGN: "лв",
		BHD: ".د.ب",
		BIF: "FBu",
		BMD: "$",
		BND: "$",
		BOB: "$b",
		BRL: "R$",
		BSD: "$",
		BTC: "฿",
		BTN: "Nu.",
		BWP: "P",
		BYN: "Br",
		BYR: "Br",
		BZD: "BZ$",
		CAD: "$",
		CDF: "FC",
		CHF: "CHF",
		CLP: "$",
		CNY: "¥",
		COP: "$",
		CRC: "₡",
		CUC: "$",
		CUP: "₱",
		CVE: "$",
		CZK: "Kč",
		DJF: "Fdj",
		DKK: "kr",
		DOP: "RD$",
		DZD: "دج",
		EEK: "kr",
		EGP: "£",
		ERN: "Nfk",
		ETB: "Br",
		ETH: "Ξ",
		EUR: "€",
		FJD: "$",
		FKP: "£",
		GBP: "£",
		GEL: "₾",
		GGP: "£",
		GHC: "₵",
		GHS: "GH₵",
		GIP: "£",
		GMD: "D",
		GNF: "FG",
		GTQ: "Q",
		GYD: "$",
		HKD: "$",
		HNL: "L",
		HRK: "kn",
		HTG: "G",
		HUF: "Ft",
		IDR: "Rp",
		ILS: "₪",
		IMP: "£",
		INR: "₹",
		IQD: "ع.د",
		IRR: "﷼",
		ISK: "kr",
		JEP: "£",
		JMD: "J$",
		JOD: "JD",
		JPY: "¥",
		KES: "KSh",
		KGS: "лв",
		KHR: "៛",
		KMF: "CF",
		KPW: "₩",
		KRW: "₩",
		KWD: "KD",
		KYD: "$",
		KZT: "лв",
		LAK: "₭",
		LBP: "£",
		LKR: "₨",
		LRD: "$",
		LSL: "M",
		LTC: "Ł",
		LTL: "Lt",
		LVL: "Ls",
		LYD: "LD",
		MAD: "MAD",
		MDL: "lei",
		MGA: "Ar",
		MKD: "ден",
		MMK: "K",
		MNT: "₮",
		MOP: "MOP$",
		MRO: "UM",
		MRU: "UM",
		MUR: "₨",
		MVR: "Rf",
		MWK: "MK",
		MXN: "$",
		MYR: "RM",
		MZN: "MT",
		NAD: "$",
		NGN: "₦",
		NIO: "C$",
		NOK: "kr",
		NPR: "₨",
		NZD: "$",
		OMR: "﷼",
		PAB: "B/.",
		PEN: "S/.",
		PGK: "K",
		PHP: "₱",
		PKR: "₨",
		PLN: "zł",
		PYG: "Gs",
		QAR: "﷼",
		RMB: "￥",
		RON: "lei",
		RSD: "Дин.",
		RUB: "₽",
		RWF: "R₣",
		SAR: "﷼",
		SBD: "$",
		SCR: "₨",
		SDG: "ج.س.",
		SEK: "kr",
		SGD: "$",
		SHP: "£",
		SLL: "Le",
		SOS: "S",
		SRD: "$",
		SSP: "£",
		STD: "Db",
		STN: "Db",
		SVC: "$",
		SYP: "£",
		SZL: "E",
		THB: "฿",
		TJS: "SM",
		TMT: "T",
		TND: "د.ت",
		TOP: "T$",
		TRL: "₤",
		TRY: "₺",
		TTD: "TT$",
		TVD: "$",
		TWD: "NT$",
		TZS: "TSh",
		UAH: "₴",
		UGX: "USh",
		USD: "$",
		UYU: "$U",
		UZS: "лв",
		VEF: "Bs",
		VND: "₫",
		VUV: "VT",
		WST: "WS$",
		XAF: "FCFA",
		XBT: "Ƀ",
		XCD: "$",
		XOF: "CFA",
		XPF: "₣",
		YER: "﷼",
		ZAR: "R",
		ZWD: "Z$"
	}
	
	$rootScope.getCurrencySymbol = function(currency)
	{
		if(currency == undefined){
			return "";
		}
		return ($rootScope.currencySymbolMap[currency] == undefined) ? currency : $rootScope.currencySymbolMap[currency];
	}
	
	$scope.formatLargeNumberWithDecimals = function(number) {
		if(number == undefined || number == 0) {
			return 0;
		}
		
		if(number >= 100000000)
		{
			var millions = number / 1000000;
			return parseFloat(millions).toFixed(0) + "M";
		}else if(number >= 10000000)
		{
			var millions = number / 1000000;
			return parseFloat(millions).toFixed(1) + "M";
		}else if(number >= 1000000)
		{
			var millions = number / 1000000;
			return parseFloat(millions).toFixed(2) + "M";
		}else if(number >= 100000)
		{
			var thousands = number / 1000;
			return parseFloat(thousands).toFixed(0) + "k";
		}
		else if(number >= 10000)
		{
			var thousands = number / 1000;
			return parseFloat(thousands).toFixed(1) + "k";
		}
		else if(number >= 100)
		{
			var parts = number.toFixed(0).split(".");
		    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		    return parts.join(".");
		}
		else
		{
			return number;
		}
	}
	
	$rootScope.formatNumWithCommas = function(x, d) {
		if (x === undefined || x === null){
			return undefined;
		}
		var parts = x.toFixed(d).split(".");
	    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    return parts.join(".");
	}
	$rootScope.formatCurrencyWithCommas = function(x, d, currencyCode) {
		return (x === undefined || x === null) ? $rootScope.getCurrencySymbol(currencyCode) + "-" : $rootScope.getCurrencySymbol(currencyCode) + $rootScope.formatNumWithCommas(x,d);
	}
	
	$rootScope.formatPercentageWithCommas = function(x,d){
		return (x === undefined || x === null) ? "-%" : $rootScope.formatNumWithCommas(x,d) + "%";
	}
	
	$scope.formatCurrency = function(number, formatAsLarge)
	{	
		if(number == undefined){
			return "-";
		}
		
		if(number == 0) {
			return 0;
		}
		
		if (formatAsLarge == undefined){
			formatAsLarge = true;
		}	
		if (number >= 100 && formatAsLarge){
			return $scope.formatLargeNumberWithDecimals(number);
		}
		else
		{
			return parseFloat(number).toFixed(2);
		}
	}
	
	$rootScope.formatInt= function(number, formatAsLarge)
	{	
		if(number == undefined || number == 0) {
			return 0;
		}
		if (formatAsLarge == undefined){
			formatAsLarge = true;
		}	
		if (number >= 100 && formatAsLarge){
			return $scope.formatLargeNumberWithDecimals(number);
		}
		else
		{
			return parseFloat(number).toFixed(0);
		}
	}
	
	$scope.formatNumber = function(number, formatAsLarge, decimals)
	{
		if (number == undefined || number == 0) {
			return 0;
		}
		if (formatAsLarge == undefined){
			formatAsLarge = true;
		}
		if (decimals == undefined){
			decimals = 1;
		}
		
		if (number >= 100 && formatAsLarge){
			return $scope.formatLargeNumber(number,decimals);
		}
		else
		{
			return parseFloat(number).toFixed(decimals);
		}
	}
	
	$scope.formatLargeNumber = function(number,decimals) {
		if(number == undefined || number == 0) {
			return 0;
		}
		
		decimals = (!decimals) ? 0 : decimals;
		
		if(number >= 1000000)
		{
			var millions = number / 1000000;
			return parseFloat(millions).toFixed(decimals) + "M";
		}
		else if(number >= 1000)
		{
			var thousands = number / 1000;
			return parseFloat(thousands).toFixed(decimals) + "k";
		}
		else if(number >= 100)
		{
			return parseFloat(number).toFixed(0)
		}
		else
		{
			return number;
		}
	}
	
	$scope.formatLargeNumberWithDecimals = function(number) {
		if(number == undefined || number == 0) {
			return 0;
		}
		
		
		if(number >= 100000000)
		{
			var millions = number / 1000000;
			return parseFloat(millions).toFixed(0) + "M";
		}else if(number >= 10000000)
		{
			var millions = number / 1000000;
			return parseFloat(millions).toFixed(1) + "M";
		}else if(number >= 1000000)
		{
			var millions = number / 1000000;
			return parseFloat(millions).toFixed(2) + "M";
		}else if(number >= 100000)
		{
			var thousands = number / 1000;
			return parseFloat(thousands).toFixed(0) + "k";
		}
		else if(number >= 10000)
		{
			var thousands = number / 1000;
			return parseFloat(thousands).toFixed(1) + "k";
		}
		else if(number >= 100)
		{
			var parts = number.toFixed(0).split(".");
		    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		    return parts.join(".");
		}
		else
		{
			return number;
		}
	}
	
	var colorIndex = -1;
	
	var colorPalette = [
		"#c0d6e4",
		"#fb9692",
		"#fab297",
		"#afd7b4",
		"#c0c0c0",
		"#f9dc26",
		"#fd9600",
		"#ffd1d1",
		"#8be0f6",
		"#eafbfa"
	];
	
	function nextColor()
	{
		colorIndex++;
		
		if(colorIndex > colorPalette.length)
		{
			colorIndex = 0;	
		}
		
		return colorPalette[colorIndex];
	}
	
	$scope.graphTrafficChannels = function(webAcquisition)
	{	
		$rootScope.trafficDistributionGraph = {};
		$rootScope.trafficDistributionGraph.options = {thickness: 200};
		$rootScope.trafficDistributionGraph.data = [];
		$rootScope.trafficDistributionGraph.legends = [];
		
		var organicCt = parseFloat(webAcquisition.thisPeriod.organic);
		var socialCt = parseFloat(webAcquisition.thisPeriod.social);
		var directCt = parseFloat(webAcquisition.thisPeriod.direct);
		
		var totalTraffic = 0;
		totalTraffic += isNaN(organicCt) ? 0 : organicCt;
		totalTraffic += isNaN(socialCt) ? 0 : socialCt;
		totalTraffic += isNaN(directCt) ? 0 : directCt;
		
		
		if (!isNaN(organicCt))
		{
			let trafficData = {};
			trafficData.label = "Organic";
			trafficData.value = organicCt;
			trafficData.percentFormatted = totalTraffic === 0 ? "-%" : $rootScope.formatPercentageWithCommas(organicCt / totalTraffic  * 100,2);
			trafficData.color = "#102635";
			trafficData.style = {'background-color': trafficData.color};
			$rootScope.trafficDistributionGraph.data.push(trafficData);
			$rootScope.trafficDistributionGraph.legends.push(trafficData);
		}
		
		if (!isNaN(socialCt))
		{
			let trafficData = {};
			trafficData.label = "Social";
			trafficData.value = socialCt;
			trafficData.percentFormatted = totalTraffic === 0 ? "-%" : $rootScope.formatPercentageWithCommas(socialCt / totalTraffic * 100,2);
			trafficData.color = "#1fa1b3";
			trafficData.style = {'background-color': trafficData.color};
			$rootScope.trafficDistributionGraph.data.push(trafficData);
			$rootScope.trafficDistributionGraph.legends.push(trafficData);
		}
		
		if (!isNaN(directCt))
		{
			let trafficData = {};
			trafficData.label = "Direct";
			trafficData.value = directCt;
			trafficData.percentFormatted = totalTraffic === 0 ? "-%" : $rootScope.formatPercentageWithCommas(directCt / totalTraffic * 100,2);
			trafficData.color = "#1A46A5";
			trafficData.style = {'background-color': trafficData.color};
			$rootScope.trafficDistributionGraph.data.push(trafficData);
			$rootScope.trafficDistributionGraph.legends.push(trafficData);
		}
		webAcquisition.thisPeriod.direct
	}
	
	$scope.graphSocialChannels = function(webAcquisition)
	{	
		$rootScope.socialDistributionGraph = {};
		$rootScope.socialDistributionGraph.options = {thickness: 200};
		$rootScope.socialDistributionGraph.data = [];
		$rootScope.socialDistributionGraph.legends = [];
				
		angular.forEach(webAcquisition.socialAttribution, function(socialChannel) {
			var socialDistro = {};
			socialDistro.label = socialChannel.channel;
			socialDistro.value = socialChannel.sessions;
			socialDistro.color = nextColor();
			socialDistro.style = {'background-color': socialDistro.color};
			
			$rootScope.socialDistributionGraph.data.push(socialDistro);
			$rootScope.socialDistributionGraph.legends.push(socialDistro);
		});
	}
	
	$scope.graphNewUsers = function(webTraffic)
	{	
		$rootScope.newUserGraph = {};
		$rootScope.newUserGraph.options = {thickness: 200};
		$rootScope.newUserGraph.data = [];
		$rootScope.newUserGraph.legends = [];
		
		var newUsersInfo = {};
		newUsersInfo.label = "New Users";
		newUsersInfo.value = webTraffic.thisPeriod.newUsers;
		newUsersInfo.color = "rgb(31, 119, 180)";
		newUsersInfo.style = {'background-color': newUsersInfo.color};
		newUsersInfo.percentFormatted = webTraffic.thisPeriod.users === 0 ? "-%" : $rootScope.formatPercentageWithCommas(webTraffic.thisPeriod.newUsers / webTraffic.thisPeriod.users * 100,2);
			
		$rootScope.newUserGraph.data.push(newUsersInfo);
		$rootScope.newUserGraph.legends.push(newUsersInfo);
		
		var returnUsers = webTraffic.thisPeriod.users - webTraffic.thisPeriod.newUsers;
		
		var userInfo = {};
		userInfo.label = "Return Users";
		userInfo.value = returnUsers;
		userInfo.color = "rgb(31, 189, 220)";
		userInfo.style = {'background-color': userInfo.color};
		userInfo.percentFormatted = webTraffic.thisPeriod.users === 0 ? "-%" : $rootScope.formatPercentageWithCommas(returnUsers / webTraffic.thisPeriod.users * 100,2);
			
		$rootScope.newUserGraph.data.push(userInfo);
		$rootScope.newUserGraph.legends.push(userInfo);
	}
	
	$scope.graphSocialHealth = function(socialTrafficScore)
	{	
		$rootScope.socialHealthGraph = {};
		$rootScope.socialHealthGraph.options = {thickness: 10, mode: "gauge", total: 100};
		$rootScope.socialHealthGraph.data = [{value: socialTrafficScore.socialTrafficScore.toFixed(0), color: "#0ba56a"}];
		$rootScope.socialHealthGraph.factors = socialTrafficScore.factors;
	}
	
	$rootScope.isLoadingPostAnalytics = true;
	
	var overviewGenderGraph = {};
	overviewGenderGraph.options = {thickness: 200};
	overviewGenderGraph.data = [];
	overviewGenderGraph.legends = [];
	
	$rootScope.overviewCommunityData = {};
	$rootScope.overviewCommunityData.genderGraph = overviewGenderGraph;
	$rootScope.overviewCommunityData.locations = [];
	$rootScope.overviewCommunityData.ages = [];
	
	$scope.graphCommunityInsights = function(data)
	{
		if($scope.isEmpty(data.platformAnalytics) || $scope.isEmpty(data.platformAnalytics.communityInsights))
		{
			return;
		}
		
		var communityInsights = data.platformAnalytics.communityInsights;
		
		// ADD LOCATION DISTRIBUTION
		angular.forEach(communityInsights.followerCities, function(location) {
			// check if there is already an entry for this location
			var foundMatch = false;
			angular.forEach($rootScope.overviewCommunityData.locations, function(existingLocation) {
				if(existingLocation.city == location.city)
				{
					foundMatch = true;
					existingLocation.followerCount += location.followerCount;
				}
			});
			
			if(!foundMatch)
			{
				$rootScope.overviewCommunityData.locations.push(location);
			}
		});
		
		// ADD AGE DISTRIBUTION
		angular.forEach(communityInsights.followerAges, function(age) {
			// check if there is already an entry for this location
			var foundMatch = false;
			angular.forEach($rootScope.overviewCommunityData.ages, function(existingAge) {
				if(existingAge.ageRange == location.ageRange)
				{
					foundMatch = true;
					existingAge.followerCount += age.followerCount;
				}
			});
			
			if(!foundMatch)
			{
				$rootScope.overviewCommunityData.ages.push(age);
			}
		});
		
		// ADD GENDER INFORMATION
		var overviewGenderGraph = $rootScope.overviewCommunityData.genderGraph;
						
		var foundMaleMatch = false;
		var foundFemaleMatch = false;
		var foundUnknownMatch = false;
			
		// check existing data for matches
		angular.forEach(overviewGenderGraph.data, function(data) {
			if(data.label == 'male')
			{
				data.value += communityInsights.maleCount;
				foundMaleMatch = true;
			}
			else if(data.label == 'female')
			{
				data.value += communityInsights.femaleCount;
				foundFemaleMatch = true;
			}
			else if(data.label == 'unknown')
			{
				data.value += communityInsights.unknownCount;
				foundUnknownMatch = true;
			}
		});
			
		if(!foundMaleMatch)
		{
			var socialDistro = {};
			socialDistro.label = 'male';
			socialDistro.value = communityInsights.maleCount;
			socialDistro.color = '#3299FF';
			overviewGenderGraph.data.push(socialDistro);
		}
			
		if(!foundFemaleMatch)
		{
			var socialDistro = {};
			socialDistro.label = 'female';
			socialDistro.value = communityInsights.femaleCount;
			socialDistro.color = '#FF748C';
			overviewGenderGraph.data.push(socialDistro);
		}

		if(!foundUnknownMatch)
		{
			var socialDistro = {};
			socialDistro.label = 'unknown';
			socialDistro.value = communityInsights.unknownCount;
			socialDistro.color = '#B088E0';
			overviewGenderGraph.data.push(socialDistro);
		}
		
	}
	
	$scope.graphPostInsights = function(data)
	{
		var accountId = data.accountId;
		var platformType = data.platformType;
		
		var platformAnalytics = {};
		var postTypeDistributionGraph = {};
		postTypeDistributionGraph.maxLikes = 1;
		postTypeDistributionGraph.maxComments = 1;
		postTypeDistributionGraph.maxShares = 1;
		postTypeDistributionGraph.noPostTypeData = true;
		postTypeDistributionGraph.options = {thickness: 20};
		postTypeDistributionGraph.data = [];
		
		var postTypeInsights = {};
		postTypeInsights.noData = true;
		
		var postTypeLikesGraph = {};
		postTypeLikesGraph.noPostTypeData = true;
		postTypeLikesGraph.options = {thickness: 20};
		postTypeLikesGraph.data = [];
		
		var postTypeCommentsGraph = {};
		postTypeCommentsGraph.noPostTypeData = true;
		postTypeCommentsGraph.options = {thickness: 20};
		postTypeCommentsGraph.data = [];
		
		var postTypeSharesGraph = {};
		postTypeSharesGraph.noPostTypeData = true;
		postTypeSharesGraph.options = {thickness: 20};
		postTypeSharesGraph.data = [];
		
		platformAnalytics.newFollowers = [];
		platformAnalytics.lostFollowers = [];
		platformAnalytics.followees = [];
		
		var postTypes = [];
		
		
		platformAnalytics = data.postInsights;
		
		if($scope.isUndefined(platformAnalytics)) {
			platformAnalytics = {};
			platformAnalytics.deltaFollowers = 0;
			platformAnalytics.numFollowers = 0;
		}
			
		var deltaFollowers = Number(platformAnalytics.deltaFollowers);
		platformAnalytics.newFollowers = deltaFollowers > 0 ? deltaFollowers : 0;
		platformAnalytics.lostFollowers = deltaFollowers < 0 ? (-1 * deltaFollowers) : 0;
			
		var numFollowers = Number(platformAnalytics.numFollowers);
			
		if(numFollowers / 1000000 >= 1)
		{
			var millionFollowers = numFollowers / 1000000;
			platformAnalytics.numFollowersFormatted = parseFloat(millionFollowers).toFixed(1) + "M";
		}
		else if(numFollowers / 1000 >= 1)
		{
			var thousandFollowers = numFollowers / 1000;
			platformAnalytics.numFollowersFormatted = parseFloat(thousandFollowers).toFixed(1) + "k";
		}
		else
		{
			platformAnalytics.numFollowersFormatted = numFollowers;
		}
			
			if($scope.isDefined(platformAnalytics.postTypeEngagementList) && platformAnalytics.postTypeEngagementList.notEmpty)
			{
				postTypeInsights.noData = false;
				postTypeInsights.mostEngagingPostType = platformAnalytics.postTypeEngagementList.mostEngagingPostType;
				postTypeInsights.recordedSince = platformAnalytics.postTypeEngagementList.recordedSince;
				postTypeInsights.recordedSinceFormatted = prettyDate(new Date(postTypeInsights.recordedSince));
				
				postTypeDistributionGraph.noPostTypeData = false;
				postTypeLikesGraph.noPostTypeData = false;
				var engagementList = platformAnalytics.postTypeEngagementList.postEngagementList;
				var count = 1;
				
				var red = 31;
				var green = 119;
				var blue = 180;
				
				angular.forEach(engagementList, function(value) {
					var postType = {};
					postType.label = "Post Type " + count++;
					postType.description = value.postCharacteristics.description;
					postType.value = value.averageEngagement.totalPosts;
					postType.color = "rgb(" + red + "," +  green + "," + blue + ")";
					postType.style = {'color': postType.color};
					postType.averageEngagement = value.averageEngagement;
					postType.bestTimeOfDayText = value.bestTimeOfDayText;
					
					postTypeDistributionGraph.data.push(postType);
					postTypes.push(postType);
					
					/* LIKES */
					var postTypeLikes = {};
					postTypeLikes.label = postType.label;
					postTypeLikes.value = value.averageEngagement.totalLikes;
					postTypeLikes.color = postType.color;
					
					if(value.averageEngagement.avgLikes > postTypeDistributionGraph.maxLikes)
					{
						postTypeDistributionGraph.maxLikes = value.averageEngagement.avgLikes;
					}
					
					postTypeLikesGraph.data.push(postTypeLikes);
					
					/* COMMENTS */
					var postTypeComments = {};
					postTypeComments.label = postType.label;
					postTypeComments.value = value.averageEngagement.totalComments;
					postTypeComments.color = postType.color;
					
					if(value.averageEngagement.avgComments > postTypeDistributionGraph.maxComments)
					{
						postTypeDistributionGraph.maxComments = value.averageEngagement.avgComments;
					}
					
					postTypeCommentsGraph.data.push(postTypeComments);
					
					/* SHARES */
					var postTypeShares = {};
					postTypeShares.label = postType.label;
					postTypeShares.value = value.averageEngagement.totalShares;
					postTypeShares.color = postType.color;
					
					if(value.averageEngagement.avgShares > postTypeDistributionGraph.maxShares)
					{
						postTypeDistributionGraph.maxShares = value.averageEngagement.avgShares;
					}
					
					postTypeSharesGraph.data.push(postTypeShares);
					
					green += 45;
					green = green % 230;								
				});
		}
		      
       $scope.updateAnalyticsData(accountId, "postTypes", postTypes);
       $scope.updateAnalyticsData(accountId, "platformAnalytics", platformAnalytics);
       $scope.updateAnalyticsData(accountId, "postTypeInsights", postTypeInsights);
       $scope.updateAnalyticsData(accountId, "postTypeDistributionGraph", postTypeDistributionGraph);
       $scope.updateAnalyticsData(accountId, "postTypeLikesGraph", postTypeLikesGraph);
       $scope.updateAnalyticsData(accountId, "postTypeCommentsGraph", postTypeCommentsGraph);
       $scope.updateAnalyticsData(accountId, "postTypeSharesGraph", postTypeSharesGraph);
	}
	
	$scope.graphIndividualHashtagAnalytics = function(data, level) {
		let individualHashtagGraphData = [];
		let hashtagMap = data.hashtagMap;
		let accountId = data.accountId;
		
		// check that there is hashtag data and copy map into an array
		if ($scope.isNotEmpty(hashtagMap.map) && Object.values(hashtagMap.map).length) {
			for (const[key, value] of Object.entries(hashtagMap.map)) {
				let hashtagMapCopy = Object.assign({}, value);
				hashtagMapCopy.name = key;		
				individualHashtagGraphData.push(hashtagMapCopy);
			}
		}
			
		let combinedHashtagData;
		switch (level) {
			case 'account':
				$scope.accountIndividualHashtagMaxPostCount = 0;
				$scope.accountIndividualHashtagMaxAvgImpressionsCount = 0;
				$scope.accountIndividualHashtagMaxAvgEngagementCount = 0;
				
				if (!$scope.accountIndividualHashtagMaxPostCounts){
					$scope.accountIndividualHashtagMaxPostCounts = {}	
				}
				$scope.accountIndividualHashtagMaxPostCounts[accountId] = 0;
				
				if (!$scope.accountIndividualHashtagMaxAvgImpressionsCounts){
					$scope.accountIndividualHashtagMaxAvgImpressionsCounts = {};
				}
				$scope.accountIndividualHashtagMaxAvgImpressionsCounts[accountId] = 0;
				
				if (!$scope.accountIndividualHashtagMaxAvgEngagementCounts){
					$scope.accountIndividualHashtagMaxAvgEngagementCounts = {};
				}
				$scope.accountIndividualHashtagMaxAvgEngagementCounts[accountId] = 0;
				
				combinedHashtagData = individualHashtagGraphData.reduce((accumulator, hashtag) => 
				{
					if ($scope.accountIndividualHashtagMaxPostCount < hashtag.postCount) {
						$scope.accountIndividualHashtagMaxPostCount = hashtag.postCount;
					}
					
					if ($scope.accountIndividualHashtagMaxPostCounts[accountId] < hashtag.postCount) {
						$scope.accountIndividualHashtagMaxPostCounts[accountId] = hashtag.postCount;
					}
					
					accumulator.postCountGraph.push({ name: hashtag.name, postCount: hashtag.postCount });
					
					if ($scope.accountIndividualHashtagMaxAvgImpressionsCount < hashtag.avgImpressions) {
						$scope.accountIndividualHashtagMaxAvgImpressionsCount = hashtag.avgImpressions;
					}
					
					if ($scope.accountIndividualHashtagMaxAvgImpressionsCounts[accountId] < hashtag.avgImpressions) {
						$scope.accountIndividualHashtagMaxAvgImpressionsCounts[accountId] = hashtag.avgImpressions;
					}
					
					accumulator.avgImpressionsGraph.push({ name: hashtag.name, avgImpressions: hashtag.avgImpressions });
					
					if ($scope.accountIndividualHashtagMaxAvgEngagementCount < hashtag.avgEngagement) {
						$scope.accountIndividualHashtagMaxAvgEngagementCount = hashtag.avgEngagement;
					}
					
					if ($scope.accountIndividualHashtagMaxAvgEngagementCounts[accountId] < hashtag.avgEngagement) {
						$scope.accountIndividualHashtagMaxAvgEngagementCounts[accountId] = hashtag.avgEngagement;
					}
					
					accumulator.avgEngagementGraph.push({ name: hashtag.name, avgEngagement: hashtag.avgEngagement });
					return accumulator;
				},{
					individualHashtagGraphData: individualHashtagGraphData,
					postCountGraph: [],
					avgImpressionsGraph: [],
					avgEngagementGraph: []
				});
				break;
			case 'overview':
				$scope.overviewIndividualHashtagMaxPostCount = 0;
				$scope.overviewIndividualHashtagMaxAvgImpressionsCount = 0;
				$scope.overviewIndividualHashtagMaxAvgEngagementCount = 0;
				
				combinedHashtagData = individualHashtagGraphData.reduce((accumulator, hashtag) => 
				{
					if ($scope.overviewIndividualHashtagMaxPostCount < hashtag.postCount) {
						$scope.overviewIndividualHashtagMaxPostCount = hashtag.postCount;
					}
					accumulator.postCountGraph.push({ name: hashtag.name, postCount: hashtag.postCount });
					if ($scope.overviewIndividualHashtagMaxAvgImpressionsCount < hashtag.avgImpressions) {
						$scope.overviewIndividualHashtagMaxAvgImpressionsCount = hashtag.avgImpressions;
					}
					accumulator.avgImpressionsGraph.push({ name: hashtag.name, avgImpressions: hashtag.avgImpressions });
					if ($scope.overviewIndividualHashtagMaxAvgEngagementCount < hashtag.avgEngagement) {
						$scope.overviewIndividualHashtagMaxAvgEngagementCount = hashtag.avgEngagement;
					}
					accumulator.avgEngagementGraph.push({ name: hashtag.name, avgEngagement: hashtag.avgEngagement });
					return accumulator;
				},{
					individualHashtagGraphData: individualHashtagGraphData,
					postCountGraph: [],
					avgImpressionsGraph: [],
					avgEngagementGraph: []
				});
				break;
		}
		
		combinedHashtagData.postCountGraph.sort((a, b) => b.postCount == a.postCount ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b.postCount - a.postCount);
		combinedHashtagData.avgImpressionsGraph.sort((a, b) => b.avgImpressions == a.avgImpressions ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b.avgImpressions - a.avgImpressions);
		combinedHashtagData.avgEngagementGraph.sort((a, b) => b.avgEngagement == a.avgEngagement ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b.avgEngagement - a.avgEngagement);
		
		return combinedHashtagData;
	}
	
	$scope.graphBucketHashtagAnalytics = function(data, level) {
		let bucketHashtagGraphData = [];
		let hashtagBucketMap = data.hashtagBucketMap;
		let noHashtagsUsed = false;
		let accountId = data.accountId;

		// check that there is hashtag data and copy map into an array
		if (hashtagBucketMap && Object.values(hashtagBucketMap).length) {
			for (const[key, value] of Object.entries(hashtagBucketMap.map)) {
				let hashtagBucketMapCopy = Object.assign({}, value);
				hashtagBucketMapCopy.name = key;
				hashtagBucketMapCopy.neverUsed = (value.postCount === 0 && value.avgImpressions === 0) || (value.postCount === 0 && value.avgEngagement === 0);
				if (Object.keys(hashtagBucketMap.map).length == 0 && key === "0" && value.postCount > 0 && (value.avgImpressions === 0 || value.avgImpressions === -1 || value.avgEngagement === 0)) {
					noHashtagsUsed = true;
				}
				bucketHashtagGraphData.push(hashtagBucketMapCopy);
			}
		}
			

		bucketHashtagGraphData.sort((a, b) => {
			// note: parseInt('31+') returns 31. parseInt('6-10') returns 6.
			return parseInt(b.name) - parseInt(a.name);
		});
		
		let combinedHashtagData;
		switch (level) {
			case 'account':
				$scope.accountBucketHashtagMaxPostCount = 0;
				$scope.accountBucketHashtagMaxAvgImpressionsCount = 0;
				$scope.accountBucketHashtagMaxAvgEngagementCount = 0;
				
				if (!$scope.accountBucketHashtagMaxPostCounts){
					$scope.accountBucketHashtagMaxPostCounts = {}	
				}
				$scope.accountBucketHashtagMaxPostCounts[accountId] = 0;
				
				if (!$scope.accountBucketHashtagMaxAvgImpressionsCounts){
					$scope.accountBucketHashtagMaxAvgImpressionsCounts = {};
				}
				$scope.accountBucketHashtagMaxAvgImpressionsCounts[accountId] = 0;
				
				if (!$scope.accountBucketHashtagMaxAvgEngagementCounts){
					$scope.accountBucketHashtagMaxAvgEngagementCounts = {};
				}
				$scope.accountBucketHashtagMaxAvgEngagementCounts[accountId] = 0;
				
				var combinedBucketHashtagData = bucketHashtagGraphData.reduce((accumulator, hashtag) => 
				{
					if ($scope.accountBucketHashtagMaxPostCount < hashtag.postCount) {
						$scope.accountBucketHashtagMaxPostCount = hashtag.postCount;
					}
					
					if ($scope.accountBucketHashtagMaxPostCounts[accountId] < hashtag.postCount) {
						$scope.accountBucketHashtagMaxPostCounts[accountId] = hashtag.postCount;
					}
						
					accumulator.postCountGraph.push({ name: hashtag.name, postCount: hashtag.postCount, neverUsed: hashtag.neverUsed });
					
					if ($scope.accountBucketHashtagMaxAvgImpressionsCount < hashtag.avgImpressions) {
						$scope.accountBucketHashtagMaxAvgImpressionsCount = hashtag.avgImpressions;
					}
					
					if ($scope.accountBucketHashtagMaxAvgImpressionsCounts[accountId] < hashtag.avgImpressions) {
						$scope.accountBucketHashtagMaxAvgImpressionsCounts[accountId] = hashtag.avgImpressions;
					}
					
					accumulator.avgImpressionsGraph.push({ name: hashtag.name, avgImpressions: hashtag.avgImpressions, neverUsed: hashtag.neverUsed });
					
					if ($scope.accountBucketHashtagMaxAvgEngagementCount < hashtag.avgEngagement) {
						$scope.accountBucketHashtagMaxAvgEngagementCount = hashtag.avgEngagement;
					}
					
					if ($scope.accountBucketHashtagMaxAvgEngagementCounts[accountId] < hashtag.avgEngagement) {
						$scope.accountBucketHashtagMaxAvgEngagementCounts[accountId] = hashtag.avgEngagement;
					}
					
					accumulator.avgEngagementGraph.push({ name: hashtag.name, avgEngagement: hashtag.avgEngagement, neverUsed: hashtag.neverUsed });
					return accumulator;
				},{
					bucketHashtagGraphData: bucketHashtagGraphData,
					postCountGraph: [],
					avgImpressionsGraph: [],
					avgEngagementGraph: [],
					noHashtagsUsed,
				});
				break;		
			case 'overview':
				$scope.overviewBucketHashtagMaxPostCount = 0;
				$scope.overviewBucketHashtagMaxAvgImpressionsCount = 0;
				$scope.overviewBucketHashtagMaxAvgEngagementCount = 0;

				combinedBucketHashtagData = bucketHashtagGraphData.reduce((accumulator, hashtag) => 
				{
					if ($scope.overviewBucketHashtagMaxPostCount < hashtag.postCount) {
						$scope.overviewBucketHashtagMaxPostCount = hashtag.postCount;
					}
					accumulator.postCountGraph.push({ name: hashtag.name, postCount: hashtag.postCount, neverUsed: hashtag.neverUsed });
					
					if ($scope.overviewBucketHashtagMaxAvgImpressionsCount < hashtag.avgImpressions) {
						$scope.overviewBucketHashtagMaxAvgImpressionsCount = hashtag.avgImpressions;
					}
					accumulator.avgImpressionsGraph.push({ name: hashtag.name, avgImpressions: hashtag.avgImpressions, neverUsed: hashtag.neverUsed });
					
					if ($scope.overviewBucketHashtagMaxAvgEngagementCount < hashtag.avgEngagement) {
						$scope.overviewBucketHashtagMaxAvgEngagementCount = hashtag.avgEngagement;
					}
					accumulator.avgEngagementGraph.push({ name: hashtag.name, avgEngagement: hashtag.avgEngagement, neverUsed: hashtag.neverUsed });
					return accumulator;
				},{
					bucketHashtagGraphData: bucketHashtagGraphData,
					postCountGraph: [],
					avgImpressionsGraph: [],
					avgEngagementGraph: [],
					noHashtagsUsed,
				});
			break;
		}
		return combinedBucketHashtagData;
	}
	
	$scope.getMockCategoryMapData = function(){
		let categoryMap = {
				map: {
					100: {
						categoryTitle: "Team",
						postCount: 37,
						avgImpressions: 111.4,
						avgEngagement: 11.0,
						avgLikes: 20.4,
						avgComments: 5.55,
						avgShares: 2.2234
					},
					101: {
						categoryTitle: "TeamTuesday",
						postCount: 15,
						avgImpressions: 3100.3,
						avgEngagement: 1102.222,
						avgLikes: 105.2,
						avgComments: 15.1,
						avgShares: 12.333
					}, 
					102: {
						categoryTitle: "PR (Press)",
						postCount: 59,
						avgImpressions: 191.0,
						avgEngagement: 123.8,
						avgLikes: 11.3,
						avgComments: 3.88,
						avgShares: 12.803
					},
					103: {
						categoryTitle: "Landing Pages",
						postCount: 29,
						avgImpressions: 2380,
						avgEngagement: 1301.1,
						avgLikes: 20.4,
						avgComments: 15.2,
						avgShares: 0
					},
					104: {
						categoryTitle: "Product Updates",
						postCount: 28,
						avgImpressions: 98,
						avgEngagement: 60.3,
						avgLikes: 1,
						avgComments: 0,
						avgShares: 0
					},
					105: {
						categoryTitle: "Mockups",
						postCount: 11,
						avgImpressions: 101,
						avgEngagement: 99.5,
						avgLikes: 11,
						avgComments: 3.666,
						avgShares: 1
					},
					106: {
						categoryTitle: "Videos",
						postCount: 2,
						avgImpressions: 8,
						avgEngagement: 6,
						avgLikes: 53,
						avgComments: 19.12,
						avgShares: 6
					},
					107: {
						categoryTitle: "Website",
						postCount: 29,
						avgImpressions: 503,
						avgEngagement: 7.6,
						avgLikes: 1,
						avgComments: 0,
						avgShares: 0
					},
					108: {
						categoryTitle: "Client Shout out",
						postCount: 51,
						avgImpressions: 569,
						avgEngagement: 200,
						avgLikes: 20,
						avgComments: 5,
						avgShares: 2
					},
					109: {
						categoryTitle: "Facebook Ad",
						postCount: 12,
						avgImpressions: 49,
						avgEngagement: 12.4,
						avgLikes: 16,
						avgComments: 7,
						avgShares: 4
					},
					110: {
						categoryTitle: "Job Listings",
						postCount: 5,
						avgImpressions: 21.333,
						avgEngagement: 10.33333,
						avgLikes: 8,
						avgComments: 15,
						avgShares: 7
					},
					111: {
						categoryTitle: "memes",
						postCount: 55,
						avgImpressions: 17,
						avgEngagement: 1,
						avgLikes: 200,
						avgComments: 102,
						avgShares: 92
					},
					112: {
						categoryTitle: "Newsletter",
						postCount: 18,
						avgImpressions: 2009,
						avgEngagement: 39,
						avgLikes: 33,
						avgComments: 15,
						avgShares: 8
					},
					113: {
						categoryTitle: "Blogs",
						postCount: 3,
						avgImpressions: 2152,
						avgEngagement: 382,
						avgLikes: 28,
						avgComments: 18,
						avgShares: 12.803
					},
					114: {
						categoryTitle: "Instagram posts",
						postCount: 28,
						avgImpressions: 171,
						avgEngagement: 1,
						avgLikes: 13,
						avgComments: 5,
						avgShares: 3
					},
					115: {
						categoryTitle: "Instagram monday",
						postCount: 33,
						avgImpressions: 324,
						avgEngagement: 101,
						avgLikes: 88,
						avgComments: 32,
						avgShares: 14
					},
					116: {
						categoryTitle: "Agency Spotlight",
						postCount: 3,
						avgImpressions: 31.23,
						avgEngagement: 32,
						avgLikes: 99,
						avgComments: 51,
						avgShares: 12
					},
					117: {
						categoryTitle: "Giveaway",
						postCount: 10,
						avgImpressions: 64,
						avgEngagement: 22,
						avgLikes: 61,
						avgComments: 55,
						avgShares: 41
					},
					118: {
						categoryTitle: "Wednesday Wisdom",
						postCount: 8,
						avgImpressions: 2133.3,
						avgEngagement: 1133,
						avgLikes: 28,
						avgComments: 27,
						avgShares: 4
					},
					119: {
						categoryTitle: "Q&A",
						postCount: 2,
						avgImpressions: 1,
						avgEngagement: 0,
						avgLikes: 87,
						avgComments: 105,
						avgShares: 17
					},
					120: {
						categoryTitle: "gifs",
						postCount: 24,
						avgImpressions: 103.5,
						avgEngagement: 10.5,
						avgLikes: 16,
						avgComments: 27,
						avgShares: 7.3
					}
				}
			}
		return categoryMap;
	}
	
	$scope.getMockCategoryInsightsData = function(){
		var categoryInsights = {
			categoryStats : {
				categoryTitle: "Landing Pages",
				postCount: 29,
				avgImpressions: 2380,
				avgEngagement: 1301.1,
				avgLikes: 20.4,
				avgComments: 15.2,
				avgShares: 0
			},
			percentMoreEngaging: 18.2
		}
		
		return categoryInsights;
	}
	
	$scope.getMockHashtagInsightsData = function(){

		var hashtagInsights = {
			hashtagStats : {
				postCount: 9,
				avgImpressions: 2633.3,
				avgEngagement: 1333
			},
			percentMoreEngaging: 8.3,
			hashtagName: "#beautiful"
		}

		return hashtagInsights;
	}
	
	$scope.graphIndividualCategoryAnalytics = function(data, level) {
		let categoryMapDataIsMocked = false;
		let individualCategoryGraphData = [];
		let categoryMap = data.categoryMap;
		let accountId = data.accountId;
		
		if (!categoryMap || !categoryMap.map || Object.keys(categoryMap.map).length === 0){
			categoryMap = $scope.getMockCategoryMapData();
			categoryMapDataIsMocked = true;
		}
		
		// check that there is category data and copy map into an array
		if ($scope.isNotEmpty(categoryMap.map) && Object.values(categoryMap).length) {
			for (const[key, value] of Object.entries(categoryMap.map)) {
				let categoryMapCopy = Object.assign({}, value);
				categoryMapCopy.id = key;		
				individualCategoryGraphData.push(categoryMapCopy);
			}
		}
		
		let combinedCategoryData;
		switch (level) {
			case 'account':
				$scope.accountIndividualCategoryMaxPostCount = 0;
				$scope.accountIndividualCategoryMaxAvgImpressionsCount = 0;
				$scope.accountIndividualCategoryMaxAvgEngagementCount = 0;
				$scope.accountIndividualCategoryMaxAvgLikesCount = 0;
				$scope.accountIndividualCategoryMaxAvgCommentsCount = 0;
				$scope.accountIndividualCategoryMaxAvgSharesCount = 0;
				if (!$scope.accountIndividualCategoryMaxPostCounts){
					$scope.accountIndividualCategoryMaxPostCounts = {};
				}
				$scope.accountIndividualCategoryMaxPostCounts[accountId] = 0;
				
				if (!$scope.accountIndividualCategoryMaxAvgImpressionsCounts){
					$scope.accountIndividualCategoryMaxAvgImpressionsCounts = {};
				}
				$scope.accountIndividualCategoryMaxAvgImpressionsCounts[accountId] = 0;
				
				if (!$scope.accountIndividualCategoryMaxAvgEngagementCounts){
					$scope.accountIndividualCategoryMaxAvgEngagementCounts = {};
				}
				$scope.accountIndividualCategoryMaxAvgEngagementCounts[accountId] = 0;
				
				combinedCategoryData = individualCategoryGraphData.reduce((accumulator, category) => 
				{
					if ($scope.accountIndividualCategoryMaxPostCount < category.postCount) {
						$scope.accountIndividualCategoryMaxPostCount = category.postCount;
					}
					
					if ($scope.accountIndividualCategoryMaxPostCounts[accountId] < category.postCount) {
						$scope.accountIndividualCategoryMaxPostCounts[accountId] = category.postCount;
					}
					
					accumulator.postCountGraph.push({ id: category.id, name: category.categoryTitle, postCount: category.postCount });
					
					if ($scope.accountIndividualCategoryMaxAvgImpressionsCount < category.avgImpressions) {
						$scope.accountIndividualCategoryMaxAvgImpressionsCount = category.avgImpressions;
					}
					
					if ($scope.accountIndividualCategoryMaxAvgImpressionsCounts[accountId] < category.avgImpressions) {
						$scope.accountIndividualCategoryMaxAvgImpressionsCounts[accountId] = category.avgImpressions;
					}
					
					accumulator.avgImpressionsGraph.push({ id: category.id, name: category.categoryTitle, avgImpressions: category.avgImpressions });
					
					if ($scope.accountIndividualCategoryMaxAvgEngagementCount < category.avgEngagement) {
						$scope.accountIndividualCategoryMaxAvgEngagementCount = category.avgEngagement;
					}
					
					if ($scope.accountIndividualCategoryMaxAvgEngagementCounts[accountId] < category.avgEngagement) {
						$scope.accountIndividualCategoryMaxAvgEngagementCounts[accountId] = category.avgEngagement;
					}
					
					accumulator.avgEngagementGraph.push({ id: category.id, name: category.categoryTitle, avgEngagement: category.avgEngagement });
					
					if ($scope.accountIndividualCategoryMaxAvgLikesCount < category.avgLikes) {
						$scope.accountIndividualCategoryMaxAvgLikesCount = category.avgLikes;
					}
					accumulator.avgLikesGraph.push({ id: category.id, name: category.categoryTitle, avgLikes: category.avgLikes });
					
					if ($scope.accountIndividualCategoryMaxAvgCommentsCount < category.avgComments) {
						$scope.accountIndividualCategoryMaxAvgCommentsCount = category.avgComments;
					}
					accumulator.avgCommentsGraph.push({ id: category.id, name: category.categoryTitle, avgComments: category.avgComments });
					
					if ($scope.accountIndividualCategoryMaxAvgSharesCount < category.avgShares) {
						$scope.accountIndividualCategoryMaxAvgSharesCount = category.avgShares;
					}
					accumulator.avgSharesGraph.push({ id: category.id, name: category.categoryTitle, avgShares: category.avgShares });
					
					return accumulator;
				},{
					individualCategoryGraphData: individualCategoryGraphData,
					postCountGraph: [],
					avgImpressionsGraph: [],
					avgEngagementGraph: [],
					avgLikesGraph: [],
					avgCommentsGraph: [],
					avgSharesGraph: []
				});
				break;
			case 'overview':
				$scope.overviewIndividualCategoryMaxPostCount = 0;
				$scope.overviewIndividualCategoryMaxAvgImpressionsCount = 0;
				$scope.overviewIndividualCategoryMaxAvgEngagementCount = 0;
				$scope.overviewIndividualCategoryMaxAvgLikesCount = 0;
				$scope.overviewIndividualCategoryMaxAvgCommentsCount = 0;
				$scope.overviewIndividualCategoryMaxAvgSharesCount = 0;
				
				combinedCategoryData = individualCategoryGraphData.reduce((accumulator, category) => 
				{
					if ($scope.overviewIndividualCategoryMaxPostCount < category.postCount) {
						$scope.overviewIndividualCategoryMaxPostCount = category.postCount;
					}
					accumulator.postCountGraph.push({ id: category.id, name: category.categoryTitle, postCount: category.postCount });
					
					if ($scope.overviewIndividualCategoryMaxAvgImpressionsCount < category.avgImpressions) {
						$scope.overviewIndividualCategoryMaxAvgImpressionsCount = category.avgImpressions;
					}
					accumulator.avgImpressionsGraph.push({ id: category.id, name: category.categoryTitle, avgImpressions: category.avgImpressions });
					
					if ($scope.overviewIndividualCategoryMaxAvgEngagementCount < category.avgEngagement) {
						$scope.overviewIndividualCategoryMaxAvgEngagementCount = category.avgEngagement;
					}
					accumulator.avgEngagementGraph.push({ id: category.id, name: category.categoryTitle, avgEngagement: category.avgEngagement });
					
					if ($scope.overviewIndividualCategoryMaxAvgLikesCount < category.avgLikes) {
						$scope.overviewIndividualCategoryMaxAvgLikesCount = category.avgLikes;
					}
					accumulator.avgLikesGraph.push({ id: category.id, name: category.categoryTitle, avgLikes: category.avgLikes });
					
					if ($scope.overviewIndividualCategoryMaxAvgCommentsCount < category.avgComments) {
						$scope.overviewIndividualCategoryMaxAvgCommentsCount = category.avgComments;
					}
					accumulator.avgCommentsGraph.push({ id: category.id, name: category.categoryTitle, avgComments: category.avgComments });
					
					if ($scope.overviewIndividualCategoryMaxAvgSharesCount < category.avgShares) {
						$scope.overviewIndividualCategoryMaxAvgSharesCount = category.avgShares;
					}
					accumulator.avgSharesGraph.push({ id: category.id, name: category.categoryTitle, avgShares: category.avgShares });
					
					return accumulator;
				},{
					individualCategoryGraphData: individualCategoryGraphData,
					postCountGraph: [],
					avgImpressionsGraph: [],
					avgEngagementGraph: [],
					avgLikesGraph: [],
					avgCommentsGraph: [],
					avgSharesGraph: []
				});
				break;
		}
		
		combinedCategoryData.postCountGraph.sort((a, b) => b.postCount == a.postCount ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b.postCount - a.postCount);
		combinedCategoryData.avgImpressionsGraph.sort((a, b) => b.avgImpressions == a.avgImpressions ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b.avgImpressions - a.avgImpressions);
		combinedCategoryData.avgEngagementGraph.sort((a, b) => b.avgEngagement == a.avgEngagement ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b.avgEngagement - a.avgEngagement);
		combinedCategoryData.avgLikesGraph.sort((a, b) => b.avgLikes == a.avgLikes ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b.avgLikes - a.avgLikes);
		combinedCategoryData.avgCommentsGraph.sort((a, b) => b.avgComments == a.avgComments ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b.avgComments - a.avgComments);
		combinedCategoryData.avgSharesGraph.sort((a, b) => b.avgShares == a.avgShares ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b.avgShares - a.avgShares);
		
		combinedCategoryData.dataIsMocked = categoryMapDataIsMocked;
		
		return combinedCategoryData;
	}
	
	$rootScope.enlargeGraph = function(graph)
	{
		if(graph.hasData)
		{
			$rootScope.showEnlargedGraph = true;
			$rootScope.enlargedGraph = graph;
		}		
	}
	
	$rootScope.hideGraph = function()
	{
		$rootScope.showEnlargedGraph = false;
	}
	
	$rootScope.historicalRoiSpendGraph = {};
	$rootScope.historicalRoiEngagementGraph = {};
	$rootScope.historicalRoiImpressionGraph = {};
	$rootScope.historicalRoiFollowerGraph = {};
	
	$scope.graphHistoricalRoiData = function(historicalRoiData)
	{			
    	var hasRoiSpend = false;
    	var hasCostPerEngagement = false;
    	var hasCostPerFollower = false;
    	var hasCostPerImpression = false;
    	
    	var maxRoiSpend = 1;
    	var maxCostPerE = 0;
    	var maxCostPerF = 0;
    	var maxCostPerI = 0;
    			
		angular.forEach(historicalRoiData, function(value) {
  			value.dateObj = new Date(value.date);
  			
  			hasRoiSpend |= (value.totalSpent > 0);
  			if(value.totalSpent > maxRoiSpend) {
  				maxRoiSpend = value.totalSpent;
  			}
  			
  			hasCostPerEngagement |= (value.costPerEngagement > 0);
  			if(value.costPerEngagement > maxCostPerE) {
  				maxCostPerE = value.costPerEngagement;
  			}
  			
  			hasCostPerFollower |= (value.costPerFollower > 0);
  			if(value.costPerFollower > maxCostPerF) {
  				maxCostPerF = value.costPerFollower;
  			}
  			
  			hasCostPerImpression |= (value.costPerImpression > 0);
  			if(value.costPerImpression > maxCostPerI) {
  				maxCostPerI = value.costPerImpression;
  			}
  			
		});
		
		// add 20% buffers
		maxRoiSpend *= 1.2;
    	maxCostPerE *= 1.2;
    	maxCostPerF *= 1.2;
    	maxCostPerI *= 1.2;
			
		if(hasRoiSpend) {
		
			$rootScope.historicalRoiSpendGraph.hasData = true;
			$rootScope.historicalRoiSpendGraph.data = historicalRoiData;
  			
			$rootScope.historicalRoiSpendGraph.options = {hideOverflow: false};
			$rootScope.historicalRoiSpendGraph.options.series = [];
	    	$rootScope.historicalRoiSpendGraph.options.axes = {x: {key: "dateObj", type: "date", zoomable: true}, y: {min: 0, max: maxRoiSpend}};
	    	$rootScope.historicalRoiSpendGraph.options.margin = { top: 10 };
				
			var totalSpendOptions = {
		            axis: "y",
		            dataset: "data",
		            key: "totalSpent",
		            label: "Marketing Spend",
		            color: "#1fa0b4",
		            type: ['area'],
		            id: 'total-spent-series',
		            interpolation: {mode: "bundle", tension: 1.2}
		     }
		        
		   $rootScope.historicalRoiSpendGraph.options.series.push(totalSpendOptions);
		   
		   $rootScope.historicalRoiSpendGraph.enlargedOptions = {};
		   $rootScope.historicalRoiSpendGraph.enlargedOptions.tooltipHook = historicalTooltipHook;
			$rootScope.historicalRoiSpendGraph.enlargedOptions.series = [];
	    	$rootScope.historicalRoiSpendGraph.enlargedOptions.axes = {x: {key: "dateObj", type: "date", zoomable: true}, y: {min: 0, max: maxRoiSpend}};
	    	$rootScope.historicalRoiSpendGraph.enlargedOptions.margin = { top: 10 };
	   		
		    var enlargedCostPerSpendOptions = {
		            axis: "y",
		            dataset: "data",
		            key: "totalSpent",
		            label: "Marketing Spend",
		            color: "#1fa0b4",
		            type: ['area', 'line'],
		            id: 'totalspent-enlarged-series',
		            interpolation: {mode: "cardinal", tension: 0.7}
		     }
		        
		   $rootScope.historicalRoiSpendGraph.enlargedOptions.series.push(enlargedCostPerSpendOptions);
	   }
	   
	   if(hasCostPerEngagement) {
	  		$rootScope.historicalRoiEngagementGraph.hasData = true;
	  		$rootScope.historicalRoiEngagementGraph.data = historicalRoiData;
			
			$rootScope.historicalRoiEngagementGraph.options = {};
			$rootScope.historicalRoiEngagementGraph.options.series = [];
	    	$rootScope.historicalRoiEngagementGraph.options.axes = {x: {key: "dateObj", type: "date", zoomable: true}, y: {min: 0, max: maxCostPerE}};
	    	$rootScope.historicalRoiEngagementGraph.options.margin = { top: 10 };
	    	
		   var costPerEngagementOptions = {
		            axis: "y",
		            dataset: "data",
		            key: "costPerEngagement",
		            label: "Cost Per Engagement",
		            color: "#1fa0b4",
		            type: ['area'],
		            id: 'costPerEngagement-series',
		            interpolation: {mode: "bundle", tension: 1.2}
		     }
		        
		   $rootScope.historicalRoiEngagementGraph.options.series.push(costPerEngagementOptions);
		   
		    $rootScope.historicalRoiEngagementGraph.enlargedOptions = {};
		    $rootScope.historicalRoiEngagementGraph.enlargedOptions.tooltipHook = historicalTooltipHook;
			$rootScope.historicalRoiEngagementGraph.enlargedOptions.series = [];
	    	$rootScope.historicalRoiEngagementGraph.enlargedOptions.axes = {x: {key: "dateObj", type: "date", zoomable: true}, y: {min: 0, max: maxCostPerE}};
	    	$rootScope.historicalRoiEngagementGraph.enlargedOptions.margin = { top: 10 };
	   		
		    var enlargedCostPerEngagementOptions = {
			  		margin: {top: 5},
		            axis: "y",
		            dataset: "data",
		            key: "costPerEngagement",
		            label: "Cost Per Engagement",
		            color: "#1fa0b4",
		            type: ['area', 'line'],
		            id: 'costPerEngagement-enlarged-series',
		            interpolation: {mode: "cardinal", tension: 0.7}
		     }
		        
		   $rootScope.historicalRoiEngagementGraph.enlargedOptions.series.push(enlargedCostPerEngagementOptions);
	   }
	   
	   if(hasCostPerImpression) {
	   		$rootScope.historicalRoiImpressionGraph.hasData = true;
	  		$rootScope.historicalRoiImpressionGraph.data = historicalRoiData;
			
			$rootScope.historicalRoiImpressionGraph.options = {};
			$rootScope.historicalRoiImpressionGraph.options.series = [];
	    	$rootScope.historicalRoiImpressionGraph.options.axes = {x: {key: "dateObj", type: "date", zoomable: true}, y: {min: 0, max: maxCostPerI}};
	    	$rootScope.historicalRoiImpressionGraph.options.margin = { top: 10 };
	   		
		   var costPerImpressionOptions = {
		   			mode: "thumbnail",
		            axis: "y",
		            dataset: "data",
		            key: "costPerImpression",
		            label: "Cost Per Exposure",
		            color: "#1fa0b4",
		            type: ['area'],
		            id: 'costPerImpression-series',
		            interpolation: {mode: "bundle", tension: 1.2}
		     }
		        
		   $rootScope.historicalRoiImpressionGraph.options.series.push(costPerImpressionOptions);
		   
		    $rootScope.historicalRoiImpressionGraph.enlargedOptions = {};
		    $rootScope.historicalRoiImpressionGraph.enlargedOptions.tooltipHook = historicalTooltipHook;
			$rootScope.historicalRoiImpressionGraph.enlargedOptions.series = [];
	    	$rootScope.historicalRoiImpressionGraph.enlargedOptions.axes = {x: {key: "dateObj", type: "date", zoomable: true}, y: {min: 0, max: maxCostPerI}};
	    	$rootScope.historicalRoiImpressionGraph.enlargedOptions.margin = { top: 10 };
	   		
		    var enlargedCostPerImpressionOptions = {
			  		margin: {top: 5},
		            axis: "y",
		            dataset: "data",
		            key: "costPerImpression",
		            label: "Cost Per Exposure",
		            color: "#1fa0b4",
		            type: ['area', 'line'],
		            id: 'costPerImpression-enlarged-series',
		            interpolation: {mode: "cardinal", tension: 0.7}
		     }
		        
		   $rootScope.historicalRoiImpressionGraph.enlargedOptions.series.push(enlargedCostPerImpressionOptions);
	   }
	   
	   if(hasCostPerFollower) {
	   		$rootScope.historicalRoiFollowerGraph.hasData = true;
	  		$rootScope.historicalRoiFollowerGraph.data = historicalRoiData;
			
			$rootScope.historicalRoiFollowerGraph.options = {};
			$rootScope.historicalRoiFollowerGraph.options.series = [];
	    	$rootScope.historicalRoiFollowerGraph.options.axes = {x: {key: "dateObj", type: "date", zoomable: true}, y: {min: 0, max: maxCostPerF}};
	    	$rootScope.historicalRoiFollowerGraph.options.margin = { top: 10 };
	   		
		    var costPerFollowerOptions = {
		            axis: "y",
		            dataset: "data",
		            key: "costPerFollower",
		            label: "Cost Per Follower",
		            color: "#1fa0b4",
		            type: ['area'],
		            id: 'costPerFollower-series',
		            interpolation: {mode: "bundle", tension: 1.2}
		     }
		        
		   $rootScope.historicalRoiFollowerGraph.options.series.push(costPerFollowerOptions);
		   
		    $rootScope.historicalRoiFollowerGraph.enlargedOptions = {};
		    $rootScope.historicalRoiFollowerGraph.enlargedOptions.tooltipHook = historicalTooltipHook;
			$rootScope.historicalRoiFollowerGraph.enlargedOptions.series = [];
	    	$rootScope.historicalRoiFollowerGraph.enlargedOptions.axes = {x: {key: "dateObj", type: "date", zoomable: true}, y: {min: 0, max: maxCostPerF}};
	    	$rootScope.historicalRoiFollowerGraph.enlargedOptions.margin = { top: 10 };
	   		
		    var enlargedCostPerFollowerOptions = {
			  		margin: {top: 5},
		            axis: "y",
		            dataset: "data",
		            key: "costPerFollower",
		            label: "Cost Per Follower",
		            color: "#1fa0b4",
		            type: ['area', 'line'],
		            id: 'costPerFollower-series',
		            interpolation: {mode: "cardinal", tension: 0.7}
		     }
		        
		   $rootScope.historicalRoiFollowerGraph.enlargedOptions.series.push(enlargedCostPerFollowerOptions);
	   }
	   
	}
	
	$rootScope.historicalWebTraffic = {};
	
	$scope.graphHistoricalWebAnalytics = function(historicalWebAnalytics)
	{	
		var graphData = {};
		
		graphData.data = historicalWebAnalytics;
			
		graphData.options = {};
		graphData.options.series = [];
    	
    	var maxValue = 1;
		
		angular.forEach(historicalWebAnalytics, function(value) {
  			value.dateObj = new Date(value.date);
  			
  			if(value.pageviews > maxValue) {
  				maxValue = value.pageviews;
  			}
  			
  			if(value.sessions > maxValue) {
  				maxValue = value.sessions;
  			}
  			
  			if(value.users > maxValue) {
  				maxValue = value.users;
  			}
		});
		
		maxValue *= 1.2;
		
		graphData.options.axes = {x: {key: "dateObj", type: "date", zoomable: true}, y: {min: 0, max: maxValue}};
    	graphData.options.margin = { top: 10 };
			
		var pageviewsOptions = {
		  		margin: {top: 5},
	            axis: "y",
	            dataset: "data",
	            key: "pageviews",
	            label: "Pageviews",
	            color: "#1f77b4",
	            type: ['area', 'line'],
	            id: 'pageviews-series'
	        }
	        
	   graphData.options.series.push(pageviewsOptions);
	   
	   var sessionsOptions = {
		  		margin: {top: 5},
	            axis: "y",
	            dataset: "data",
	            key: "sessions",
	            label: "Sessions",
	            color: "#1fa0b4",
	            type: ['area', 'line'],
	            id: 'sessions-series'
	        }
	        
	   graphData.options.series.push(sessionsOptions);
	   
	    var usersOptions = {
		  		margin: {top: 5},
	            axis: "y",
	            dataset: "data",
	            key: "users",
	            label: "Users",
	            color: "#1845a5",
	            type: ['area', 'line'],
	            id: 'users-series'
	        }
	        
	   graphData.options.series.push(usersOptions);
	        
		$rootScope.historicalWebTraffic = graphData;
	}
	
	var followerRed = 31;
	var followerGreen = 119;
	var followerBlue = 180;
	var oddRun = true;
	
	$scope.graphHistoricalPostAnalytics = function(data)
	{	
		var graphData = {};
		graphData.title = data.accountName + " " + data.platformType.toLowerCase().capitalize() + "  Historical Post Performance";
		graphData.noHistoricalPostAnalytics = data.hasHistoricalPostAnalytics;
		
		if(data.hasHistoricalPostAnalytics)
		{
			graphData.postAnalytics = data.historicalPostAnalytics;
			graphData.numLikes = 0;
			graphData.numComments = 0;
			graphData.numShares = 0;
			graphData.totalPosts = 0;
			graphData.totalReach = 0;
			graphData.numClicks = 0;
			graphData.numPostsWithReachData = 0;
			graphData.reachData = [];
			
			graphData.options = {};
			graphData.options.tooltipHook = historicalTooltipHook;
			graphData.options.series = [];
			graphData.options.stacks = [];
			var stack = {axis: "y", series: []};
			graphData.options.stacks.push(stack);
			graphData.options.lineMode = "cardinal";
    		graphData.options.axes = {x: {key: "date", type: "date", zoomable: true}, y: {min: 0}};
    		graphData.options.margin = { top: 10 };
		
			angular.forEach(data.historicalPostAnalytics, function(value) {
  				value.date = new Date(value.postDate);
  				graphData.numLikes += value.numLikes;
				graphData.numComments += value.numComments;
				graphData.numShares += value.numShares;
				graphData.totalPosts += value.postCount;
				
				$rootScope.highlevelAnalytics.totalHistoricalPosts += value.postCount;
				
				if(value.totalReach >= 0)
				{
					if(graphData.totalReach < 0)
					{
						graphData.totalReach = 0;
					}
					graphData.totalReach += value.totalReach;
					graphData.numPostsWithReachData++;
					graphData.reachData.push(value);
				}
				
				var totalEngagement = 0;
				
				if(value.numLikes >= 0)
				{
					totalEngagement += value.numLikes;
					$rootScope.highlevelAnalytics.numHistoricalLikes += value.numLikes;
				}
				
				if(value.numComments >= 0)
				{
					totalEngagement += value.numComments;
					$rootScope.highlevelAnalytics.numHistoricalComments += value.numComments;
				}
				
				if(value.numShares >= 0)
				{
					totalEngagement += value.numShares;
					$rootScope.highlevelAnalytics.numHistoricalShares += value.numShares;
				}
				
				if(value.numClicks >= 0)
				{
					graphData.numClicks += value.numClicks;
					totalEngagement += value.numClicks;
					$rootScope.highlevelAnalytics.numHistoricalClicks += value.numClicks;
				}
				
				var totalReach = value.totalReach >= 0 ? value.totalReach : 0;
				
				$rootScope.highlevelAnalytics.totalHistoricalImpressions += totalReach;
				$rootScope.highlevelAnalytics.totalHistoricalEngagement += totalEngagement;
								
				// see if we already have an entry with a matching date.  If so, join them
	  			var foundMatch = false;
	  				
	  			var existingEntries = $rootScope.highlevelAnalytics.postAnalyticsGraph.historicalPostAnalytics;
	  			var twoDays = 2 * 24 * 1000 * 60 * 60;
	  			
	  			for(var k = 0; k < existingEntries.length; k++)
	  			{
	  				var entry = existingEntries[k];
	  				
	  				if(entry.postDate + twoDays > value.postDate && entry.postDate - twoDays < value.postDate)
	  				{
	  					entry.engagement += totalEngagement;
	  					entry.reach += totalReach;
	  					foundMatch = true;
	  					break;
	  				}
	  				
	  				if(entry.postDate + twoDays > value.postDate)
	  				{
	  					value.engagement = totalEngagement;
	  					value.reach = totalReach;
	  					$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalPostAnalytics.splice(k, 0, value);
	  					foundMatch = true;
	  					break;
	  				}
	  			}
	  			
	  			if(!foundMatch)
	  			{
	  				value.engagement = totalEngagement;
	  				value.reach = totalReach;
					$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalPostAnalytics.push(value);
	  			}
	  			
			});
						
			var likeOptions = {
			  		margin: {top: 5},
	                axis: "y",
	                dataset: "postAnalytics",
	                key: "numLikes",
	                label: "Likes",
	                color: "#1f77b4",
	                type: ['column'],
	                id: 'historicalLikeSeries-' + data.accountId
	        }
	        
	       graphData.options.series.push(likeOptions);
	       stack.series.push(likeOptions.id);
	        
	        var commentOptions = {
	        		margin: {top: 5},
	                axis: "y",
	                dataset: "postAnalytics",
	                key: "numComments",
	                label: "Comments",
	                color: "#17c4d1",
	                type: ['column'],
	                id: 'historicalCommentsSeries-' + data.accountId
	        }
	        
	        graphData.options.series.push(commentOptions);
	        stack.series.push(commentOptions.id);
	        
	         var shareOptions = {
	         		margin: {top: 5},
	                axis: "y",
	                dataset: "postAnalytics",
	                key: "numShares",
	                label: "Shares",
	                color: "#0ba56a",
	                type: ['column'],
	                id: 'historicalSharesSeries-' + data.accountId
	        }
	        
	        graphData.options.series.push(shareOptions);
	        stack.series.push(shareOptions.id);
	        
	        if(graphData.reachData.length > 0)
	        {
		         var reachOptions = {
		                axis: "y2",
		                dataset: "reachData",
		                key: "totalReach",
		                label: "Impressions",
		                color: "#ffa500a1",
	    	            type: ['line', 'area'],
		                id: 'historicalReachSeries-' + data.accountId,
		                interpolation: {mode: "bundle", tension: 0.95}
		        }
		        
		        graphData.options.series.push(reachOptions);
	        }
	        
	      	graphData.totalPosts = $scope.formatNumFollowers(graphData.totalPosts);
	      	$rootScope.highlevelAnalytics.totalHistoricalPostsFormatted = $scope.formatNumFollowers($rootScope.highlevelAnalytics.totalHistoricalPosts);
        }
       
        var accountId = data.accountId;
        
        $scope.updateAnalyticsData(accountId, "historicalPostAnalyticsGraph", graphData);
	}
	
	$scope.graphPostAnalytics = function(data)
	{	
		var graphData = {};
		graphData.title = data.accountName + " " + data.platformType.toLowerCase().capitalize() + " Post Performance";
		graphData.noPostAnalytics = (data.postAnalytics.length == 0);
		
		if(data.postAnalytics.length > 0)
		{
			graphData.postAnalytics = data.postAnalytics;
			graphData.numLikes = 0;
			graphData.numComments = 0;
			graphData.numShares = 0;
			graphData.totalReach = 0;
			graphData.numClicks = 0;
			graphData.numPostsWithReachData = 0;
			graphData.reachData = [];
			
			graphData.options = {};
			graphData.options.series = [];
			graphData.options.stacks = [];
			var stack = {axis: "y", series: []};
			graphData.options.stacks.push(stack);
			graphData.options.lineMode = "cardinal";
    		graphData.options.axes = {x: {key: "date", type: "date", zoomable: true}, y: {min: 0}};
    		graphData.options.margin = { top: 10 };
		
			angular.forEach(data.postAnalytics, function(value) {
  				value.date = new Date(value.postDate);
  				graphData.numLikes += value.numLikes;
				graphData.numComments += value.numComments;
				graphData.numShares += value.numShares;
				
				if(value.totalReach >= 0)
				{
					if(graphData.totalReach < 0)
					{
						graphData.totalReach = 0;
					}
					graphData.totalReach += value.totalReach;
					graphData.numPostsWithReachData++;
					graphData.reachData.push(value);
				}
				
				var totalEngagement = 0;
				
				if(value.numLikes >= 0)
				{
					totalEngagement += value.numLikes;
					$rootScope.highlevelAnalytics.numLikes += value.numLikes;
				}
				
				if(value.numComments >= 0)
				{
					totalEngagement += value.numComments;
					$rootScope.highlevelAnalytics.numComments += value.numComments;
				}
				
				if(value.numShares >= 0)
				{
					totalEngagement += value.numShares;
					$rootScope.highlevelAnalytics.numShares += value.numShares;
				}
				
				if(value.numClicks >= 0)
				{
					totalEngagement += value.numClicks;
					graphData.numClicks += value.numClicks;
					$rootScope.highlevelAnalytics.numClicks += value.numClicks;
				}
				
				var totalReach = value.totalReach >= 0 ? value.totalReach : 0;
				
				$rootScope.highlevelAnalytics.totalImpressions += totalReach;
				$rootScope.highlevelAnalytics.totalEngagement += totalEngagement;
				
				$rootScope.highlevelAnalytics.totalPosts++;
				
				// see if we already have an entry with a matching date.  If so, join them
	  			var foundMatch = false;
	  				
	  			var existingEntries = $rootScope.highlevelAnalytics.postAnalyticsGraph.postAnalytics;
	  			var sixHours = 12 * 1000 * 60 * 60;
	  			
	  			for(var k = 0; k < existingEntries.length; k++)
	  			{
	  				var entry = existingEntries[k];
	  				
	  				if(entry.postDate + sixHours > value.postDate && entry.postDate - sixHours < value.postDate)
	  				{
	  					entry.engagement += totalEngagement;
	  					entry.reach += totalReach;
	  					foundMatch = true;
	  					break;
	  				}
	  				
	  				if(entry.postDate + sixHours > value.postDate)
	  				{
	  					value.engagement = totalEngagement;
	  					value.reach = totalReach;
	  					$rootScope.highlevelAnalytics.postAnalyticsGraph.postAnalytics.splice(k, 0, value);
	  					foundMatch = true;
	  					break;
	  				}
	  			}
	  			
	  			if(!foundMatch)
	  			{
	  				value.engagement = totalEngagement;
	  				value.reach = value.totalReach >= 0 ? value.totalReach : 0;
					$rootScope.highlevelAnalytics.postAnalyticsGraph.postAnalytics.push(value);
	  			}
			});
			
			var likeOptions = {
			  		margin: {top: 5},
	                axis: "y",
	                dataset: "postAnalytics",
	                key: "numLikes",
	                label: "Likes",
	                color: "#1f77b4",
	                type: ['column'],
	                id: 'likeSeries-' + data.accountId
	        }
	        
	       graphData.options.series.push(likeOptions);
	       stack.series.push(likeOptions.id);
	        
	        var commentOptions = {
	        		margin: {top: 5},
	                axis: "y",
	                dataset: "postAnalytics",
	                key: "numComments",
	                label: "Comments",
	                color: "#17c4d1",
	                type: ['column'],
	                id: 'commentsSeries-' + data.accountId
	        }
	        
	        graphData.options.series.push(commentOptions);
	        stack.series.push(commentOptions.id);
	        
	         var shareOptions = {
	         		margin: {top: 5},
	                axis: "y",
	                dataset: "postAnalytics",
	                key: "numShares",
	                label: "Shares",
	                color: "#0ba56a",
	                type: ['column'],
	                id: 'sharesSeries-' + data.accountId
	        }
	        
	        graphData.options.series.push(shareOptions);
	        stack.series.push(shareOptions.id);
	        
	        if(graphData.reachData.length > 0)
	        {
		         var reachOptions = {
		                axis: "y2",
		                dataset: "reachData",
		                key: "totalReach",
		                label: "Impressions",
		                color: "#ffa500a1",
	    	            type: ['line', 'area'],
		                id: 'reachSeries-' + data.accountId,
		                interpolation: {mode: "bundle", tension: 0.95}
		        }
		        
		        graphData.options.series.push(reachOptions);
	        }
        }
       
        var accountId = data.accountId;
        
        $scope.updateAnalyticsData(accountId, "postAnalyticsGraph", graphData);
        
        // re-calculate cost per impression and engagement
        $scope.formatCostPerImpression();
        
        $scope.formatCostPerEngagement();
        
        $rootScope.highlevelAnalytics.totalPostsFormatted = $scope.formatNumFollowers($rootScope.highlevelAnalytics.totalPosts);
	}
	
	function AdObjectiveGraphData(){
		this.accountId = "";
		this.levelType = "";
		this.levelId = "";
		this.currency = "";
		this.numOfChildren = 0;
		this.keyMetricDesc = "";
		this.totalKeyMetrics = 0;
		this.totalSpend = 0;
		this.avgCostPerKeyMetric = 0;
		this.totalClicks = 0;
		this.totalReactions = 0;
		this.totalComments = 0;
		this.totalEngagement = 0;
		this.totalImpressions = 0;
		this.totalReach = 0;
		this.selected = true;
		this.title = "Key Metric Performance";
		this.hasAdAnalytics = false;	
	}
	
	$scope.setUpPDFDataTable = function(dataSet, currency){
		//set up ad table
		let PDFTableOptions = {
				data: dataSet,
		        columns: [
							{data:"campaign", name:"campaign", title:"Campaign"},
							{data:"adSetName", name:"adSetName", title:"Ad Set Name"},
		        			{data:"level", name:"level", title:"Ad Name"},
				        	{data:"keyMetricDesc", name:"keyMetricDesc", title:"Key Metric Name"},
				        	{data:"totalSpend", name:"totalSpend", className:"sum", title:"Spend", render: number( ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
				        	{data:"totalKeyMetrics", name:"totalKeyMetrics", className:"sum", title:"Key Metric", render: number( ',', '.', 0)},
				        	{data:"avgCostPerKeyMetric", name:"avgCostPerKeyMetric", title:"Cost Per Key Metric", render: finiteNumber('-', ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
							{data:"totalClicks", name:"totalClicks", className:"sum", title:"Clicks", render: number( ',', '.', 0)},
							{data:"avgCpc", name:"avgCpc", title:"CPC", render: finiteNumber('-', ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
							{data:"avgCtr", name:"avgCtr", title:"CTR", render: finiteNumber('-', ',', '.', 4, '', "%")},
//							{data:"totalEngagement", name:"totalEngagement", className:"sum", title:"Engage&shy;ment", render: $.fn.dataTable.render.number( ',', '.', 0)},
//							{data:"avgCostPerEngagement", name:"avgCostPerEngagement", title:"CP Engage&shy;ment", render: $.fn.dataTable.render.number( ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
//							{data:"totalReach", name:"totalReach", className:"sum", title:"Reach", render: $.fn.dataTable.render.number( ',', '.', 0)},
//							{data:"avgCostPerReach", name:"avgCostPerReach", title:"CP 1k Reach", render: $.fn.dataTable.render.number( ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
//							{data:"avgFrequency", name:"avgFrequency", title:"Freq", render: $.fn.dataTable.render.number( ',', '.', 4)},
							{data:"totalImpressions", name:"totalImpressions", className:"sum", title:"Impr", render: number( ',', '.', 0)},
							{data:"avgCostPerImpression", name:"avgCostPerImpression", title:"CPM", render: finiteNumber('-', ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
						],
			    columnDefs: [
					        { targets: [0], visible: false}
					    ],
				responsive: false,
				info: false,
				paging: false,
				rowGroup: {
					startRender: null,
		            endRender: function ( rows, group, level ) {
	                	// Remove the formatting to get value data for summation
			            let numVal = function ( i ) {
			                return typeof i === 'string' ?
			                    i.replace(/[^\d.]/g, ''):
			                    typeof i === 'number' ?
			                        i : 0;
			            }
			            
		                let spendSum = rows
		                    .data()
		                    .pluck('totalSpend')
		                    .reduce( function (a, b) {
		                        return numVal(a) + numVal(b);
		                    }, 0);
		                
		                const spendSumFormatted = $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( spendSum );
		 
		                let keyMetricSum = rows
		                    .data()
		                    .pluck('totalKeyMetrics')
		                    .reduce( function (a, b) {
		                    	return numVal(a) + numVal(b);
		                    }, 0);	                
		                const keyMetricSumFormatted = $.fn.dataTable.render.number(',', '.', 0).display( keyMetricSum );  
		                
		                let clickSum = rows
	                    .data()
	                    .pluck('totalClicks')
	                    .reduce( function (a, b) {
	                    	return numVal(a) + numVal(b);
	                    }, 0);
		                const clickSumFormatted = $.fn.dataTable.render.number(',', '.', 0).display( clickSum );
		                
//		                let engagementSum = rows
//	                    .data()
//	                    .pluck('totalEngagement')
//	                    .reduce( function (a, b) {
//	                    	return numVal(a) + numVal(b);
//	                    }, 0);	                
//		                const engagementSumFormatted = $.fn.dataTable.render.number(',', '.', 0).display( engagementSum ); 
		                
//		                let reachSum = rows
//	                    .data()
//	                    .pluck('totalReach')
//	                    .reduce( function (a, b) {
//	                    	return numVal(a) + numVal(b);
//	                    }, 0);	                
//		                const reachSumFormatted = $.fn.dataTable.render.number(',', '.', 0).display( reachSum );   
		                
		                let impressionSum = rows
	                    .data()
	                    .pluck('totalImpressions')
	                    .reduce( function (a, b) {
	                    	return numVal(a) + numVal(b);
	                    }, 0);	                
		                const impressionSumFormatted = $.fn.dataTable.render.number(',', '.', 0).display( impressionSum );                   
		                
		                const avgCostPerKeyMetric = spendSum / keyMetricSum;	
		                const avgCostPerKeyMetricFormatted = finiteNumber('-', ',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( avgCostPerKeyMetric );
		                                   		   
		                const avgCPC = spendSum / clickSum;
		                const avgCPCFormatted = !isFinite(avgCPC) ? $rootScope.getCurrencySymbol(currency) + '-' : $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( avgCPC );
		                
		                const avgCTR = (clickSum / impressionSum) * 100;
		                const avgCTRFormatted = !isFinite(avgCTR) ? '-%' :$.fn.dataTable.render.number(',', '.', 4, '', '%').display( avgCTR );
		                
//		                const avgCostPerEngagement = spendSum / engagementSum;
//		                const avgCostPerEngagementFormatted = $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( avgCostPerEngagement );
//		                 
//		                const avgCostPerReach = (spendSum / reachSum) * 1000;
//		                const avgCostPerReachFormatted = $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( avgCostPerReach );
//		                
//		                const avgFrequency = impressionSum / reachSum;
//		                const avgFrequencyFormatted = $.fn.dataTable.render.number(',', '.', 4).display( avgFrequency );
		                
		                const avgCPM = (spendSum / impressionSum) * 1000;
		                const avgCPMFormatted = !isFinite(avgCPM) ? $rootScope.getCurrencySymbol(currency) + '-' : $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( avgCPM );
		                
		                
		                let elemToReturn = $('<tr/>')
		                .append( '<td colspan="3" style="text-align:left">Campaign - ' + group + ' Total</td>' )
		                .append( '<td colspan="1">' + spendSumFormatted + '</td>' )
		                .append( '<td colspan="1">' + keyMetricSumFormatted + '</td>' )
		                .append( '<td colspan="1">' + avgCostPerKeyMetricFormatted + '</td>' )
		                .append( '<td colspan="1">' + clickSumFormatted + '</td>' )
		                .append( '<td colspan="1">' + avgCPCFormatted + '</td>' )
		                .append( '<td colspan="1">' + avgCTRFormatted + '</td>' )
//		                .append( '<td colspan="1">' + engagementSumFormatted + '</td>' )
//		                .append( '<td colspan="1">' + avgCostPerEngagementFormatted + '</td>' )
//		                .append( '<td colspan="1">' + reachSumFormatted + '</td>' )
//		                .append( '<td colspan="1">' + avgCostPerReachFormatted + '</td>' )
//		                .append( '<td colspan="1">' + avgFrequencyFormatted + '</td>' )
		                .append( '<td colspan="1">' + impressionSumFormatted + '</td>' )
		                .append( '<td colspan="1">' + avgCPMFormatted + '</td>' );
		 
		                return elemToReturn
		                    
		            },
		            "dataSrc": ["campaign"]
		        },
		        order: [[ 0, "asc" ],[ 1, "asc" ]],
		        ordering: false,
		        searching: false,
		        retrieve: true,
				footerCallback: function ( tfoot, data, start, end, display ) {
					var api = this.api();
					
		            let numVal = function ( i ) {
		                return typeof i === 'string' ?
		                    i.replace(/[^\d.]/g, ''):
		                    typeof i === 'number' ?
		                        i : 0;
		            }
					
					//get each row pluck specific column to aggregate	
		            
		            let rows = api.rows();
	
	                let spendSum = rows
	                .data()
	                .pluck('totalSpend')
	                .reduce( function (a, b) {
	                    return numVal(a) + numVal(b);
	                }, 0);
                
		            const spendSumFormatted = $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( spendSum );
		 
		                let keyMetricSum = rows
		                    .data()
		                    .pluck('totalKeyMetrics')
		                .reduce( function (a, b) {
		                	return numVal(a) + numVal(b);
		                }, 0);	                
		            const keyMetricSumFormatted = $.fn.dataTable.render.number(',', '.', 0).display( keyMetricSum );  
		            
		            let clickSum = rows
		            .data()
		            .pluck('totalClicks')
		            .reduce( function (a, b) {
		            	return numVal(a) + numVal(b);
		            }, 0);
		            const clickSumFormatted = $.fn.dataTable.render.number(',', '.', 0).display( clickSum );
		            
//		            let engagementSum = rows
//		            .data()
//		            .pluck('totalEngagement')
//		            .reduce( function (a, b) {
//		            	return numVal(a) + numVal(b);
//		            }, 0);	                
//		            const engagementSumFormatted = $.fn.dataTable.render.number(',', '.', 0).display( engagementSum ); 
//		            
//		            let reachSum = rows
//		            .data()
//		            .pluck('totalReach')
//		            .reduce( function (a, b) {
//		            	return numVal(a) + numVal(b);
//		            }, 0);	                
//		            const reachSumFormatted = $.fn.dataTable.render.number(',', '.', 0).display( reachSum );   
		            
		            let impressionSum = rows
		            .data()
		            .pluck('totalImpressions')
		            .reduce( function (a, b) {
		            	return numVal(a) + numVal(b);
		            }, 0);	                
		            const impressionSumFormatted = $.fn.dataTable.render.number(',', '.', 0).display( impressionSum );                   
		            
		            const avgCostPerKeyMetric = spendSum / keyMetricSum;	
		            const avgCostPerKeyMetricFormatted = !isFinite(avgCostPerKeyMetric) ? $rootScope.getCurrencySymbol(currency) + '-' : $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( avgCostPerKeyMetric );
		                               		   
		            const avgCPC = spendSum / clickSum;
		            const avgCPCFormatted = !isFinite(avgCPC) ? $rootScope.getCurrencySymbol(currency) + '-' : $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( avgCPC );
		            
		            const avgCTR = (clickSum / impressionSum) * 100;
		            const avgCTRFormatted = !isFinite(avgCTR) ? '-%' : $.fn.dataTable.render.number(',', '.', 4, '', '%').display( avgCTR );
		            
//		            const avgCostPerEngagement = spendSum / engagementSum;
//		            const avgCostPerEngagementFormatted = $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( avgCostPerEngagement );
//		             
//		            const avgCostPerReach = (spendSum / reachSum) * 1000;
//		            const avgCostPerReachFormatted = $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( avgCostPerReach );
//		            
//		            const avgFrequency = impressionSum / reachSum;
//		            const avgFrequencyFormatted = $.fn.dataTable.render.number(',', '.', 4).display( avgFrequency );
		            
		            const avgCPM = (spendSum / impressionSum) * 1000;
		            const avgCPMFormatted = !isFinite(avgCPM) ? $rootScope.getCurrencySymbol(currency) + '-' : $.fn.dataTable.render.number(',', '.', 2, $rootScope.getCurrencySymbol(currency)).display( avgCPM );
                	
		            let currentPosition = -1;
		            
		            currentPosition = api.colReorder.transpose( api.column("totalSpend:name").index());
					$( api.column( currentPosition ).footer() ).html( spendSumFormatted ); 
					
					currentPosition = api.colReorder.transpose( api.column("totalKeyMetrics:name").index());
					$( api.column( currentPosition ).footer() ).html( keyMetricSumFormatted ); 
					
					currentPosition = api.colReorder.transpose( api.column("totalClicks:name").index());
					$( api.column( currentPosition ).footer() ).html( clickSumFormatted ); 
					
//					currentPosition = api.colReorder.transpose( api.column("totalEngagement:name").index());
//					$( api.column( currentPosition ).footer() ).html( engagementSumFormatted ); 
//					
//					currentPosition = api.colReorder.transpose( api.column("totalReach:name").index());
//					$( api.column( currentPosition ).footer() ).html( reachSumFormatted );  
					
					currentPosition = api.colReorder.transpose( api.column("totalImpressions:name").index());
					$( api.column( currentPosition ).footer() ).html( impressionSumFormatted ); 
					
					currentPosition = api.colReorder.transpose( api.column("avgCostPerKeyMetric:name").index());
					$( api.column( currentPosition ).footer() ).html( avgCostPerKeyMetricFormatted ); 
					
					currentPosition = api.colReorder.transpose( api.column("avgCpc:name").index());
					$( api.column( currentPosition ).footer() ).html( avgCPCFormatted ); 
					
					currentPosition = api.colReorder.transpose( api.column("avgCtr:name").index());
					$( api.column( currentPosition ).footer() ).html( avgCTRFormatted ); 
					
//					currentPosition = api.colReorder.transpose( api.column("avgCostPerEngagement:name").index());
//					$( api.column( currentPosition ).footer() ).html( avgCostPerEngagementFormatted ); 
//					
//					currentPosition = api.colReorder.transpose( api.column("avgCostPerReach:name").index());
//					$( api.column( currentPosition ).footer() ).html( avgCostPerReachFormatted ); 
//					
//					currentPosition = api.colReorder.transpose( api.column("avgFrequency:name").index());
//					$( api.column( currentPosition ).footer() ).html( avgFrequencyFormatted ); 
					
					currentPosition = api.colReorder.transpose( api.column("avgCostPerImpression:name").index());
					$( api.column( currentPosition ).footer() ).html( avgCPMFormatted );      
		        }
		};
		
		return PDFTableOptions;
	}
	
	$scope.setUpPDFGrandDataTable = function(dataSet, currency){
		//set up ad table
		let PDFTableOptions = {
				data: dataSet,
				info: false,
				paging: false,
		        ordering: false,
		        searching: false,
		        retrieve: true,
		        columns: [
		        	{data:null, defaultContent:"Grand Total", title:""},
		        	{data:"totalSpend", className:"sum", title:"Spend", render: number(',', '.', 2, $rootScope.getCurrencySymbol(currency))},
					{data:"totalKeyMetrics", className:"sum key-metric", title:"Key Metric", render: number( ',', '.', 0)},
					{data:"avgCostPerKeyMetric", className:"key-metric", title:"Cost Per Key Metric", render: finiteNumber('-', ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
					{data:"totalClicks", className:"sum clicks", title:"Clicks", render: number( ',', '.', 0)},
					{data:"avgCpc", className:"clicks", title:"CPC", render: finiteNumber('-', ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
					{data:"avgCtr", className:"clicks", title:"CTR", render: finiteNumber('-', ',', '.', 4, '', "%")},
//					{data:"totalEngagement", className:"sum", title:"Engage&shy;ment", render: $.fn.dataTable.render.number( ',', '.', 0)},
//					{data:"avgCostPerEngagement", title:"CP Engage&shy;ment", render: $.fn.dataTable.render.number( ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
//					{data:"totalReach", className:"sum", title:"Reach", render: $.fn.dataTable.render.number( ',', '.', 0)},
//					{data:"avgCostPerReach", title:"CP 1k Reach", render: $.fn.dataTable.render.number( ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
//					{data:"avgFrequency", title:"Freq", render: $.fn.dataTable.render.number( ',', '.', 4)},
					{data:"totalImpressions", className:"impr", title:"Impr", render: number( ',', '.', 0)},
					{data:"avgCostPerImpression", className:"sum impr", title:"CPM", render: finiteNumber('-', ',', '.', 2, $rootScope.getCurrencySymbol(currency))},
		        ]
		};
		
		return PDFTableOptions;
	}
	
	$scope.graphAdAccountAnalytics = function(data, accountId, accountTimeZone, key)
	{
		//No child data. Reached the end of chain! Return!
		if($scope.isEmpty(data.childAdLevelAnalytics)){
			return;
		}
		
		let parentGraphData = new AdObjectiveGraphData();
		parentGraphData.childGraphData = [];
		let totalNumOfChildren = 0;

		if(!$scope.isUndefined(data.childAdLevelAnalytics)){
			angular.forEach(data.childAdLevelAnalytics, function(childData) {
				childData.currency = data.currency;
				totalNumOfChildren += childData.numOfChildren;
				let childGraphData = new AdObjectiveGraphData();		
				$scope.graphChildAdAccountAnalytics(childGraphData, childData, data, accountId, accountTimeZone)
				parentGraphData.childGraphData.push(childGraphData);
				//recurse through child accounts
				let dataKey = key + "-" + childGraphData.levelType + "-" + childGraphData.levelId;
				$scope.graphAdAccountAnalytics(childData, accountId, accountTimeZone, dataKey)
			});
		}
		
		$scope.graphParentAdAccountAnalytics(parentGraphData, data, accountId, accountTimeZone);
		
		parentGraphData.numOfChildren = totalNumOfChildren;
		
		//key needs to be generated based on parent and child levels need to pass in key prefix and build
		$scope.updateAdAnalyticsData(accountId, key, parentGraphData);
	}
	
	$scope.graphAdAccountAnalyticsPDF = function(data, accountId, accountTimeZone, key)
	{
			
		let parentGraphData = new AdObjectiveGraphData();
		parentGraphData.childGraphData = [];
		parentGraphData.adTableOptions = {};
		let adData = {};

		if(!$scope.isUndefined(data.childAdLevelAnalytics))
		{
			angular.forEach(data.childAdLevelAnalytics, function(childData) 
			{
				parentGraphData.childGraphData.push($scope.graphChildAdAnalyticsRecursive(data, childData, accountId, accountTimeZone));
				
				$scope.extractAllAdLevelData(adData, childData);
			});
		}
		
		//Comparer Function    
		let getSortOrder = function () { // With ES6 we could use the spread operator like let getSortOrder = function(...props)
			const props = Array.prototype.slice.call(arguments); // Without ES6 we can do this. "arguments" is the default array-like object for functions  
			
			return function(a, b) { 
				
				for (let i = 0; i < props.length; i++)
				{
					let prop = props[i];
					if(a[prop] === undefined || a[prop] === null){
						return 0;
					}
					
					if(b[prop] === undefined || b[prop] === null){
						return 0;
					}
					
					if (a[prop] > b[prop]) {    
			            return 1;    
			        } else if (a[prop] < b[prop]) {    
			            return -1;    
			        } 
					
					// evaluate next prop   
				}
				
				return 0;     
		    }    
		}    
		
		$scope.graphParentAdAccountAnalytics(parentGraphData, data, accountId, accountTimeZone);
		    
		//add each table to
		Object.keys(adData).forEach(function(key) {
			
			adData[key].sort(getSortOrder("campaign"));
			parentGraphData.adTableOptions[key] = $scope.setUpPDFDataTable(adData[key], parentGraphData.currency);
			
		});
		
		
		
		var parentGraphDataTotals = new AdObjectiveGraphData();
		$scope.mapAdDataTotals(parentGraphDataTotals,data);
		
		let parentGraphDataTotalsArr = [];
		parentGraphDataTotalsArr.push(parentGraphDataTotals);
		
		
		parentGraphData.adTableOptionsTotals = $scope.setUpPDFGrandDataTable(parentGraphDataTotalsArr, parentGraphDataTotals.currency);
		
		//key needs to be generated based on parent and child levels need to pass in key prefix and build
		$scope.updateAdAnalyticsData(accountId, key, parentGraphData);
	}
	
	$scope.extractAllAdLevelData = function(adList, data)
	{
		//No child data. Reached the end of chain! push this data
		if($scope.isEmpty(data.childAdLevelAnalytics))
		{
			if(data.levelType.toLowerCase() === 'ad')
			{
				let graphData = new AdObjectiveGraphData();
				$scope.mapAdDataTotals(graphData, data)
				//create objective list
				if (!(data.adAnalyticsTotals.objective.toLowerCase() in adList))
				{
					adList[data.adAnalyticsTotals.objective.toLowerCase()] = [];
				}
				//check if objective list is defined
				//if so push graph data to that specific objective list			
				adList[data.adAnalyticsTotals.objective.toLowerCase()].push(graphData);
			}
			return;
		} 
		
		if(!$scope.isUndefined(data.childAdLevelAnalytics))
		{
			angular.forEach(data.childAdLevelAnalytics, function(childData) 
			{				
				$scope.extractAllAdLevelData(adList,childData);
			});
		}
		
	}
	
	$scope.graphChildAdAnalyticsRecursive = function(rootData, data, accountId, accountTimeZone)
	{
		
		let graphData = new AdObjectiveGraphData();
		$scope.graphChildAdAccountAnalytics(graphData, data, rootData, accountId, accountTimeZone);
		
		//No child data. Reached the end of chain! Return!
		if($scope.isEmpty(data.childAdLevelAnalytics))
		{
			return graphData;
		}
		
	
		if(!$scope.isUndefined(data.childAdLevelAnalytics)){
			graphData.childGraphData = [];
			angular.forEach(data.childAdLevelAnalytics, function(childData) {

				let childGraphData = $scope.graphChildAdAnalyticsRecursive(rootData, childData, accountId, accountTimeZone);
				
				graphData.childGraphData.push(childGraphData);
				//recurse through child accounts
			});
		}
		
		return graphData;
	}
	
	
	$scope.returnUndefinedGraphData = function(value)
	{
		return (value.y1 !== undefined && value.y1 !== null);
	}
	
	$scope.mapAdDataTotals = function(graphData, data)
	{
		graphData.hasAdAnalytics = (data.adAnalytics.length > 0);
		graphData.level = data.level;
		graphData.currency = data.currency;
		graphData.levelType = data.levelType.toLowerCase();
		//used for sectionID
		if ($scope.isUndefined(data.levelId))
		{
			graphData.levelId = graphData.level.replace(" ", "");
		} else 
		{
			graphData.levelId = data.levelId;
		}
		
		graphData.parentLevelId = data.parentLevelId;
		
		if (!$scope.isUndefined(data.adAnalyticsTotals.adsetName))
				{
			graphData.adSetName = data.adAnalyticsTotals.adsetName;
		}
		if (!$scope.isUndefined(data.adAnalyticsTotals.campaignName))
		{
			graphData.campaign = data.adAnalyticsTotals.campaignName;
		}
		if (!$scope.isUndefined(data.adAnalyticsTotals.objective))
		{
			graphData.objective = data.adAnalyticsTotals.objective;
		}
		
		graphData.numOfChildren = data.numOfChildren;
		graphData.keyMetricDesc = (data.adAnalyticsTotals.keyMetricDesc == undefined) ? "Key Metric" : data.adAnalyticsTotals.keyMetricDesc.capitalizeAll();
		graphData.totalKeyMetrics = data.adAnalyticsTotals.adMetrics.keyMetric;
		graphData.totalSpend =  data.adAnalyticsTotals.adMetrics.spend;
		graphData.avgCostPerKeyMetric = data.adAnalyticsTotals.adMetrics.costPerKeyMetric;
		graphData.totalClicks = data.adAnalyticsTotals.adMetrics.clicks;
		graphData.avgCpc = data.adAnalyticsTotals.adMetrics.costPerClick;
		graphData.avgCtr = data.adAnalyticsTotals.adMetrics.clickThruRate;
		graphData.totalReactions = data.adAnalyticsTotals.adMetrics.reactions;
		graphData.avgCostPerReaction = data.adAnalyticsTotals.adMetrics.costPerReaction;
		graphData.totalComments = data.adAnalyticsTotals.adMetrics.comments;
		graphData.totalEngagement = data.adAnalyticsTotals.adMetrics.postEngagement;
		graphData.avgCostPerEngagement = data.adAnalyticsTotals.adMetrics.costPerPostEngagement;
		graphData.totalImpressions = data.adAnalyticsTotals.adMetrics.impressions;
		graphData.avgCostPerImpression = data.adAnalyticsTotals.adMetrics.costPerImpression;
		graphData.totalReach = data.adAnalyticsTotals.adMetrics.reach;
		graphData.avgCostPerReach = data.adAnalyticsTotals.adMetrics.costPerReach;
		graphData.avgFrequency = data.adAnalyticsTotals.adMetrics.frequency;
	}
	
	$scope.graphParentAdAccountAnalytics = function(graphData, data, accountId, accountTimeZone){
		
		$scope.mapAdDataTotals(graphData, data);
		graphData.accountId = accountId;
		//switch level name based on child account level
		if(!$scope.isEmpty(data.childAdLevelAnalytics)){
			switch(data.childAdLevelAnalytics[0].levelType.toLowerCase()) {
			  case "objective":
				  graphData.level = "All Objectives";
			    break;
			  case "campaign":
				  graphData.level = "All Campaigns";
			    break;
			  case "ad":
				  graphData.level = "All Ads";
			    break;
			  default:
				  graphData.level = data.level;
			}
		}
		// set up the ad graph
		graphData.adAnalytics = data.adAnalytics;
		
		graphData.mainGraphTitle = (data.adAnalyticsTotals.keyMetricDesc == undefined) ? "Key Metric Count" : data.adAnalyticsTotals.keyMetricDesc.capitalizeAll() + " Count";
		graphData.mainGraphOptions = {};
		graphData.mainGraphOptions.series = [];
		graphData.mainGraphOptions.axes = {x: {key: "graphDate", type: "date"}, y: {min: 0, max: 100}};
		graphData.mainGraphOptions.tooltipHook = dailyDateTooltipHook;
		
		if(data.adAnalytics.length > 0)
		{			
			let numTicks = data.adAnalytics.length > 12 ? 12 : data.adAnalytics.length;
			
			graphData.mainGraphOptions = {};
			graphData.mainGraphOptions.series = [];
    		graphData.mainGraphOptions.tooltipHook = dailyDateTooltipHook;
    		
    		let yMin = 99999;
    		let yMax = 0;
    		
    		let costMin = 99999;
    		let costMax = 0;
    			
			angular.forEach(data.adAnalytics, function(value) {
				//get Account TimeZone offset
				let actZoneOffset = moment.tz.zone(accountTimeZone).utcOffset(value.dateStart); 
				let dateStart = new Date(value.dateStart);
				value.graphDate = new Date(dateStart.getTime() + ((dateStart.getTimezoneOffset()-actZoneOffset) * 60 * 1000));
				//flatten data
				Object.assign(value, value.adMetrics);
				
				// set mins and maxes to allow for margins
				yMin = $scope.getMin(yMin, value.keyMetric);
				yMax = $scope.getMax(yMax, value.keyMetric);
				
				costMin = $scope.getMin(costMin, value.costPerKeyMetric);
				costMax = $scope.getMax(costMax, value.costPerKeyMetric);	
			});
			
			graphData.mainGraphOptions.axes = {
					x: {key: "graphDate", type: "date", ticks: numTicks}, 
					y2: {
							min: costMin, 
							max: costMax,
						    tickFormat: function(value, index) {
						        return $rootScope.getCurrencySymbol(data.currency) + $scope.formatCurrency(value, true);
						    }
						}, 
					y: {min: yMin, 
						max: yMax,
						tickFormat: function(value, index) {
					        	return $scope.formatLargeNumberWithDecimals(value);
					    	}
						}
					};
			
			let color = $scope.graphColors[data.appType]; 
			color = $scope.isDefined(color) ? color : "#1f77b4";
		    let costColor = "#27CB02";
		       
			let keyMetricOptions = 
			{
		                axis: "y",
		                thickness: '3px',
		                dataset: "adAnalytics",
		                key: "keyMetric",
		                label: (data.adAnalyticsTotals.keyMetricDesc == undefined) ? "Key Metric Count" : data.adAnalyticsTotals.keyMetricDesc.capitalizeAll() + " Count",
		                defined: $scope.returnUndefinedGraphData,
		                color: color,
		                type: ['line', 'area']
			}
			        
			graphData.mainGraphOptions.series.push(keyMetricOptions);
			
			
			let cPKeyMetricOptions = 
			{
		                axis: "y2",
		                thickness: '1px',
		                dataset: "adAnalytics",
		                key: "costPerKeyMetric",
		                label: (data.adAnalyticsTotals.keyMetricDesc == undefined) ? "Cost Per Key Metric" : "Cost Per " + data.adAnalyticsTotals.keyMetricDesc.capitalizeAll(),
		                defined: $scope.returnUndefinedGraphData,
		                color: costColor,
		                type: ['line', 'dot']
			}
			
			graphData.mainGraphOptions.series.push(cPKeyMetricOptions);
        }
	}
	
	$scope.graphChildAdAccountAnalytics = function(childGraphData, childData, data, accountId, accountTimeZone){
		
		$scope.mapAdDataTotals(childGraphData, childData);
		
		childGraphData.accountId = accountId;
		childGraphData.currency = data.currency;
		
		childGraphData.ad = {};
		if(childData.ad != undefined){
			childGraphData.ad = childData.ad;
			if($scope.isEmpty(childData.ad.adCreatives)){
				childGraphData.adCreatives = [];
				childGraphData.hasCreative = false;
			} else{
				childGraphData.adCreatives = childGraphData.ad.adCreatives;
				delete childGraphData.ad.adCreatives;
				childGraphData.hasCreative = true;
			}
		}
		
		angular.forEach(childGraphData.adCreatives, function(adCreative) {
			adCreative.hasVideo = !$scope.isEmpty(adCreative.videoUrl);
			adCreative.hasImage = !$scope.isEmpty(adCreative.mediaUrl);
			adCreative.hasActorInfo = !$scope.isEmpty(adCreative.profilePicUrl);
		});
		
		// set up the ad graph
		childGraphData.adAnalytics = childData.adAnalytics;
		
		childGraphData.mainGraphTitle = (childData.adAnalyticsTotals.keyMetricDesc == undefined) ? "Key Metric" : childData.adAnalyticsTotals.keyMetricDesc.capitalizeAll();
		childGraphData.mainGraphOptions = {};
		childGraphData.mainGraphOptions.margin = {top: 5};

		childGraphData.mainGraphOptions.series = [];
		childGraphData.mainGraphOptions.axes = {x: {key: "graphDate", type: "date"}, y: {min: 0, max: 100}};
		childGraphData.mainGraphOptions.tooltipHook = dailyDateTooltipHook;
		
		if(childData.adAnalytics.length > 0)
		{			
			let numTicks = childData.adAnalytics.length > 12 ? 12 : childData.adAnalytics.length;
			
			childGraphData.mainGraphOptions = {};
			childGraphData.mainGraphOptions.series = [];
			childGraphData.mainGraphOptions.tooltipHook = dailyDateTooltipHook;
    		
    		let yMin = 99999;
    		let yMax = 0;
    		
    		let costMin = 99999;
    		let costMax = 0;
    		
    		let i = 0;
    		
    		while (i < data.adAnalytics.length){
    			if (i >= childData.adAnalytics.length || data.adAnalytics[i].dateStart != childData.adAnalytics[i].dateStart){
    				// if not equal push new empty adAnalytic with top ad start date to child adAnalytics. increment top ad list
    				let adAnalytic = {};
    				//get Account TimeZone offset
    				let actZoneOffset = moment.tz.zone(accountTimeZone).utcOffset(data.adAnalytics[i].dateStart); 
    				let dateStart = new Date(data.adAnalytics[i].dateStart);
    				adAnalytic.graphDate = new Date(dateStart.getTime() + ((dateStart.getTimezoneOffset()-actZoneOffset) * 60 * 1000));
    				adAnalytic.dateStart = data.adAnalytics[i].dateStart;
    				childData.adAnalytics.splice(i,0,adAnalytic);
    			} 
    			else
    			{
    				// if equal update date flatten calc min and max increment child
    				let actZoneOffset = moment.tz.zone(accountTimeZone).utcOffset(data.adAnalytics[i].dateStart); 
    				let dateStart = new Date(childData.adAnalytics[i].dateStart);
    				
    				childData.adAnalytics[i].graphDate = new Date(dateStart.getTime() + ((dateStart.getTimezoneOffset()-actZoneOffset) * 60 * 1000));
    				//flatten data
    				Object.assign(childData.adAnalytics[i], childData.adAnalytics[i].adMetrics);
    				
    				// set mins and maxes to allow for margins
    				yMin = $scope.getMin(yMin, childData.adAnalytics[i].keyMetric);
    				yMax = $scope.getMax(yMax, childData.adAnalytics[i].keyMetric);
    				
    				costMin = $scope.getMin(costMin, childData.adAnalytics[i].costPerKeyMetric);
    				costMax = $scope.getMax(costMax, childData.adAnalytics[i].costPerKeyMetric);
    			}
    			i++;
    		}
    		
			//childGraphData.mainGraphOptions.axes = {x: {key: "graphDate", type: "date", ticks: numTicks}, y: {}};
    		
			childGraphData.mainGraphOptions.axes = {
					x: {key: "graphDate", type: "date", ticks: numTicks}, 
					y2: {
							min: costMin, 
							max: costMax,
						    tickFormat: function(value, index) {
						        return $rootScope.getCurrencySymbol(data.currency) + $scope.formatCurrency(value, true);
						    }
						}, 
					y: {min: yMin, 
						max: yMax,
						tickFormat: function(value, index) {
					        	return $scope.formatLargeNumberWithDecimals(value);
					    	}
						}
					};
			
			let color = $scope.graphColors[childData.appType]; 
			color = $scope.isDefined(color) ? color : "#1f77b4";
		    let costColor = "#27CB02";
			
			let keyMetricOptions = 
			{
		                axis: "y",
		                thickness: '3px',
		                dataset: "adAnalytics",
		                key: "keyMetric",
		                label: (childData.adAnalyticsTotals.keyMetricDesc == undefined) ? "Key Metric Count" : childData.adAnalyticsTotals.keyMetricDesc.capitalizeAll() + " Count",
		                defined: $scope.returnUndefinedGraphData,
		                color: color,
		                type: ['line', 'area']
			}
			        
			childGraphData.mainGraphOptions.series.push(keyMetricOptions);
			
			let cPKeyMetricOptions = 
			{
		                axis: "y2",
		                thickness: '1px',
		                dataset: "adAnalytics",
		                key: "costPerKeyMetric",
		                label: (childData.adAnalyticsTotals.keyMetricDesc == undefined) ? "Cost Per Key Metric" : "Cost Per " + childData.adAnalyticsTotals.keyMetricDesc.capitalizeAll(),
		                defined: $scope.returnUndefinedGraphData,
		                color: costColor,
		                type: ['line', 'dot']
			}
			
			childGraphData.mainGraphOptions.series.push(cPKeyMetricOptions);
        }
		
	}
	
	$rootScope.showCampaign = function(campaign)
	{
		$rootScope.selectedCampaign = campaign;
		var comments = $scope.isEmpty(campaign.comments) ? "" : campaign.comments;
		
		$("#campaign_comments_text").text(comments);
	}
	
	$rootScope.hasData = function(data)
	{
		return $scope.isNotEmpty(data);
	}
	
	$rootScope.recalculateRoiMetrics = function()
	{
		// format amount spent
		$scope.formatAmountSpent();
		
		// re-calculate cost per impression and engagement
        $scope.formatCostPerImpression();
        
        $scope.formatCostPerEngagement();
	}

	$rootScope.onUpdateClientReport = function(clientReport)
	{
		if (clientReport.hasWebsiteAnalytics && clientReport.showWebAnalytics && $scope.analyticsView == 3) {
			$rootScope.webViewsChanged();
		} else {
			$rootScope.viewsChanged();
		}
		$rootScope.clientReport = clientReport;
		const phase = $rootScope.$root.$$phase;
		if (phase !== '$apply' && phase !== '$digest') {
			$rootScope.$apply();
		}
	}

	$rootScope.saveReportConfiguration = function(clientReport) {
		$rootScope.savingReportConfiguration = true;
		$rootScope.updateReportError = ""

		var phase = $rootScope.$root.$$phase;
		if (phase !== '$apply' && phase !== '$digest') {
			$rootScope.$apply();
		}

		$scope.putRequest(
			"/rest/analytics/report",
			clientReport,
			$scope.saveReportConfigurationCallback,
			$scope.saveReportConfigurationErrorCallback
		);
	}
	
	$scope.saveReportConfigurationCallback = function() {
		$rootScope.savingReportConfiguration = false;

		$("#update-report-config-button").text("Saved!");
		$("#update-report-config-button").addClass('content-saved');

		setTimeout(function(){
			$("#update-report-config-button").text("Save");
		}, 2000);

		var phase = $rootScope.$root.$$phase;
		if (phase !== '$apply' && phase !== '$digest') {
			$rootScope.$apply();
		}
	}
	
	$scope.saveReportConfigurationErrorCallback = function(error) {
		$rootScope.savingReportConfiguration = false;
		console.error("Failed to update report config", error);
		$rootScope.updateReportError = "Failed to update configuration.  Please contact support if the issue persists.";

		var phase = $rootScope.$root.$$phase;
		if (phase !== '$apply' && phase !== '$digest') {
			$rootScope.$apply();
		}
	}
	
	$scope.analyticsView = 0;
	$scope.sectionTab = 0;
	$scope.webAnalyticsView = 0;
	$scope.adAnalyticsView = 0;
	
	$rootScope.setAdAnalyticsView = function(val)
	{
		$scope.adAnalyticsView = val;
	}
	
	$rootScope.webViewsChanged = function()
	{
		if($rootScope.clientReport.showWebAnalyticsTraffic)
		{
			$scope.webAnalyticsView = 0;
		}
		else if($rootScope.clientReport.showWebAnalyticsSocial)
		{
			$scope.webAnalyticsView = 1;
		}
	}
	
	$rootScope.viewsChanged = function()
	{
		if($rootScope.clientReport.showOrganicAnalytics){
			if($rootScope.clientReport.showOverview)
			{
				$scope.sectionTab = 0;
				$scope.analyticsView = 0;
			}
			else if($rootScope.clientReport.showAccounts)
			{
				$scope.sectionTab = 0;
				$scope.analyticsView = 1;
			}
			else if($rootScope.clientReport.showInsights)
			{
				$scope.sectionTab = 0;
				$scope.analyticsView = 2;
			} 
			else if($rootScope.clientReport.showHashtagAnalytics)
			{
				$scope.sectionTab = 0;
				$scope.analyticsView = 6;
			}
			else if($rootScope.clientReport.showCategoryAnalytics)
			{
				$scope.sectionTab = 0;
				$scope.analyticsView = 7;
			}
		}
		else if($rootScope.clientReport.showAdAnalytics)
		{
			$scope.sectionTab = 1;
			$scope.analyticsView = 5;
		}
		else if($rootScope.clientReport.showWebAnalytics)
		{
			$scope.sectionTab = 2;
			$scope.analyticsView = 3;
		}
		else if($rootScope.clientReport.campaigns?.length > 0)
		{
			$scope.sectionTab = 3;
			$scope.analyticsView = 4;
		}
	}
	
	$scope.formatCostPerImpression = function()
	{
		if($rootScope.highlevelAnalytics.totalImpressions == 0)
        {
        	$rootScope.clientReport.costPerImpression = "N/A";
        }
        else
        {
        	$rootScope.clientReport.costPerImpression = $rootScope.clientReport.totalSpent / $rootScope.highlevelAnalytics.totalImpressions;
        	$rootScope.clientReport.costPerImpression = $rootScope.clientReport.costPerImpression > .1 ? $rootScope.clientReport.costPerImpression.toFixed(2) : ( $rootScope.clientReport.costPerImpression < .01 ? $rootScope.clientReport.costPerImpression.toFixed(4) : $rootScope.clientReport.costPerImpression.toFixed(3));
        }
	}
	
	$scope.formatCostPerEngagement = function()
	{
		if($rootScope.highlevelAnalytics.totalEngagement == 0)
        {
        	$rootScope.clientReport.costPerEngagement = "N/A";
        }
        else
        {
        	$rootScope.clientReport.costPerEngagement = $rootScope.clientReport.totalSpent / $rootScope.highlevelAnalytics.totalEngagement;
        	$rootScope.clientReport.costPerEngagement =  $rootScope.clientReport.costPerEngagement > .1 ?  $rootScope.clientReport.costPerEngagement.toFixed(2) : (  $rootScope.clientReport.costPerEngagement < .01 ? $rootScope.clientReport.costPerEngagement.toFixed(4) :  $rootScope.clientReport.costPerEngagement.toFixed(3));
        }
	}
	
	$scope.graphFollowerData = function(data)
	{			
		if($scope.isUndefined(data.followerAnalytics)) {
			data.followerAnalytics = [];
		}
		
		var graphData = {};
		graphData.title = data.accountName + " " + data.platformType.toLowerCase().capitalize() + " Followers";
		graphData.noData = (data.followerAnalytics.length == 0);
		
		graphData.newFollowerCount = 0;
		graphData.lostFollowerCount = 0;
		graphData.deltaFollowerCount = 0;
		graphData.deltaFollowerPercent = 0;
		graphData.totalFollowersFormatted = 0;
		graphData.totalFollowers = 0;
		var hasFollowerData = false;
		
		if(data.followerAnalytics.length > 0)
		{			
			if($scope.isUndefined($rootScope.highlevelAnalytics.followersGraph.followerAnalytics))
			{
				$rootScope.highlevelAnalytics.followersGraph.followerAnalytics = [];
			}
			
			graphData.followerAnalytics = [];
			graphData.platformAnalyticsDeltas = [];
			graphData.annotations = [];
			
			var numTicks = data.followerAnalytics.length > 12 ? 12 : data.followerAnalytics.length;
			
			graphData.options = { thickness : '3px' };
			graphData.options.series = [];
    		graphData.options.axes = {x: {key: "graphDate", type: "date", ticks: numTicks}, y: {min: 0}};
    		graphData.options.margin = { top: 10 };
    			
    		var previousFollowerCount = -1;
    		
			angular.forEach(data.followerAnalytics, function(value) {
			
				value.graphDate = new Date(value.date);
			
				if(value.numFollowers >= 0)
				{	  				
					if(value.numFollowers > $rootScope.highlevelAnalyticsMaxFollowers) 
					{
						$rootScope.highlevelAnalyticsMaxFollowers = value.numFollowers;
					}
					
	  				if(previousFollowerCount != -1)
	  				{
	  					var delta = value.numFollowers - previousFollowerCount;
	  					
	  					if(delta > 0)
	  					{
	  						graphData.newFollowerCount += delta;
	  						$rootScope.highlevelAnalytics.newFollowerCount += delta;
	  						$rootScope.highlevelAnalytics.totalEngagement += delta;
	  					}
	  					else
	  					{
	  						graphData.lostFollowerCount += delta;
	  						$rootScope.highlevelAnalytics.lostFollowerCount += delta;
	  					}
	  					
	  					var deltaInfo = {};
	  					deltaInfo.graphDate = value.graphDate;
	  					deltaInfo.date = value.date;
	  					deltaInfo.numFollowersDelta = delta;
	  					
	  					graphData.platformAnalyticsDeltas.push(deltaInfo);
	  				}
	  				
	  				graphData.followerAnalytics.push(value);
	  				previousFollowerCount = value.numFollowers;
	  				
	  				$scope.joinHighLevelFollowers(value, data.accountId);
	  				
	  				hasFollowerData = true;
  				}
  				
  				if($scope.isNotEmpty(value.annotation))
	  			{
	  				var annotationInfo = {};
	  				annotationInfo.graphDate = value.graphDate;
	  				annotationInfo.value = 1;
		  			annotationInfo.text = value.annotation;
		  						  					
	  				graphData.annotations.push(annotationInfo);
	  			}
			});
			
			if(previousFollowerCount >= 0)
			{
				graphData.totalFollowers = previousFollowerCount;
				graphData.totalFollowersFormatted = $scope.formatNumFollowers(Number(previousFollowerCount));
			}
				
			var deltaGraphOptions = {
					margin: {top: 5},
	                axis: "y2",
	                dataset: "platformAnalyticsDeltas",
	                key: "numFollowersDelta",
	                label: "Delta Followers",
	                color: "#1f77b4",
	                type: ['column'],
	                id: 'followerDeltaSeries-' + data.accountId,
	                visible: false
	        }
	        
	        graphData.options.series.push(deltaGraphOptions);
	        
			var graphOptions = {
					margin: {top: 5},
	                axis: "y",
	                dataset: "followerAnalytics",
	                key: "numFollowers",
	                label: "Followers",
	                color: "#1f77b4",
	                type: ['area'],
	                id: 'followerSeries-' + data.accountId
	        }
	        
	       graphData.options.series.push(graphOptions);
	       
	       	var followeeGraphOptions = {
	       			margin: {top: 5},
	                axis: "y",
	                dataset: "followerAnalytics",
	                key: "numFollowees",
	                label: "Following",
	                color: "#17c4d1",
	                type: ['area'],
	                id: 'followeeSeries-' + data.accountId,
	                visible: false
	        }
	        
	       graphData.options.series.push(followeeGraphOptions);
	       
	       if(graphData.annotations.length > 0)
	       {
		       var annotationsGraphOptions = {
		                axis: "y",
		                dataset: "annotations",
		                key: "text",
		                label: "Annotations",
		                color: "#0ba56a",
		                type: ['dot'],
		                id: 'followerAnnotations-' + data.accountId
		        }
		        
		       graphData.options.series.push(annotationsGraphOptions);
	       }
	       
	       graphData.deltaFollowerCount = graphData.newFollowerCount + graphData.lostFollowerCount;
	       
	       if(hasFollowerData)
	       {
		       var highLevelOptions = {
		                axis: "y",
		                thickness : "3px",
		                dataset: "followerAnalytics",
		                key: "numFollowers-" + data.accountId,
		                label: data.accountName + " (" + data.platformType.toLowerCase().capitalize() + ")",
		                color: "rgb(" + followerRed + "," +  followerGreen + "," + followerBlue + ")",
		                type: ['line'],
		                id: 'highlevel-followerSeries-' + data.accountId
		        }
		        
		       $rootScope.highlevelAnalytics.followersGraph.options.series.push(highLevelOptions);
		       
		       // add a top padding to the graph
		       $rootScope.highlevelAnalytics.followersGraph.options.axes.y.max = $rootScope.highlevelAnalyticsMaxFollowers * 1.2;
		       
		       if(oddRun)
		       {
		       		followerGreen += 45;
					followerGreen = followerGreen % 235;
			   }
			   else
			   {
			   		followerBlue += 45;
					followerBlue = followerBlue % 235;
			   }
			   
			   oddRun = !oddRun;
	       }
	       
	       $rootScope.highlevelAnalytics.numFollowers += previousFollowerCount;
	       $rootScope.highlevelAnalytics.deltaFollowerCount += graphData.deltaFollowerCount;
	        
	       previousFollowerCount = previousFollowerCount - graphData.deltaFollowerCount;
	       
	       $rootScope.highlevelAnalytics.previousNumFollowers += previousFollowerCount;
	       
	       if(previousFollowerCount == 0)
	       {
	       		graphData.deltaFollowerPercent = graphData.deltaFollowerCount > 0 ? 1000 : 0;
	       }
	       else
	       {
	       		graphData.deltaFollowerPercent = ((graphData.deltaFollowerCount / previousFollowerCount) * 100).toFixed(1);
	       }
	       
	       // calculate highlevel stats
	       if($rootScope.highlevelAnalytics.previousNumFollowers == 0)
	       {
	       		$rootScope.highlevelAnalytics.deltaFollowerPercent = $rootScope.highlevelAnalytics.deltaFollowerCount > 0 ? 1000 : 0;
	       }
	       else
	       {
	       		$rootScope.highlevelAnalytics.deltaFollowerPercent = (($rootScope.highlevelAnalytics.deltaFollowerCount / $rootScope.highlevelAnalytics.previousNumFollowers) * 100).toFixed(1);
	       }
	       
	       var highLeveNumFollowers = Number($rootScope.highlevelAnalytics.numFollowers);
			
			if(highLeveNumFollowers / 1000000 >= 1)
			{
				var millionFollowers = highLeveNumFollowers / 1000000;
				$rootScope.highlevelAnalytics.numFollowersFormatted = parseFloat(millionFollowers).toFixed(1) + "M";
			}
			else if(highLeveNumFollowers / 1000 >= 1)
			{
				var thousandFollowers = highLeveNumFollowers / 1000;
				$rootScope.highlevelAnalytics.numFollowersFormatted = parseFloat(thousandFollowers).toFixed(1) + "k";
			}
			else
			{
				$rootScope.highlevelAnalytics.numFollowersFormatted = highLeveNumFollowers;
			}
			
			
			// calculate cost per follower
			if($rootScope.highlevelAnalytics.newFollowerCount <= 0)
	        {
	        	$rootScope.clientReport.costPerFollower = "N/A";
	        }
	        else
	        {
	        	$rootScope.clientReport.costPerFollower = $rootScope.clientReport.totalSpent / $rootScope.highlevelAnalytics.newFollowerCount;
	        	$rootScope.clientReport.costPerFollower = $rootScope.clientReport.costPerFollower > .1 ? $rootScope.clientReport.costPerFollower.toFixed(2) : ( $rootScope.clientReport.costPerFollower < .01 ? $rootScope.clientReport.costPerFollower.toFixed(4) : $rootScope.clientReport.costPerFollower.toFixed(3));
	        }
	        
	        // calculate cost per impression and engagement
	        $scope.formatCostPerImpression();
	        
	        $scope.formatCostPerEngagement();
	        
        }
       
        var accountId = data.accountId;
        
        $scope.updateAnalyticsData(accountId, "followersGraph", graphData);
	}
	
	$scope.fillInMissingFollowerData = function(accountIds, existingEntries)
	{ 	
		if($scope.isEmpty(accountIds) || $scope.isEmpty(existingEntries))
		{
			return;		
		}
		
	  	var previousAccountEntries = {};
	  	
	  	
	  	angular.forEach(existingEntries, function(entry) {
	  		angular.forEach(accountIds, function(accountId) {
	  			if($scope.isUndefined(entry["numFollowers-" + accountId]))
	  			{
	  				// no entry for this account on this day
	  				entry["numFollowers-" + accountId] = $scope.isDefined(previousAccountEntries[accountId]) ? previousAccountEntries[accountId] : 0;
	  			}
	  			else
	  			{
	  				previousAccountEntries[accountId] = entry["numFollowers-" + accountId];
	  			}
	  		});
	  	});
	}
	
	$scope.joinHighLevelFollowers = function(value, accountId)
	{
		// see if we already have an entry with a matching date.  If so, join them
	  				var foundMatch = false;
	  				
	  				var existingEntries = $rootScope.highlevelAnalytics.followersGraph.followerAnalytics;
	  				var tenMinutes = 10 * 1000 * 60;
	  				var index = 0;
	  				
	  				for(var k = 0; k < existingEntries.length; k++)
	  				{
	  					var entry = existingEntries[k];
	  					
	  					if(entry.date + tenMinutes > value.date && entry.date - tenMinutes <= value.date)
	  					{
	  						entry["numFollowers-" + accountId] = value.numFollowers;
	  						entry.totalFollowers += value.numFollowers
	  						foundMatch = true;
	  						break;
	  					}
	  					else if(entry.date > value.date)
	  					{
	  						// we've gone past this value's date, break from the loop and insert it
	  						break;
	  					}
	  					
	  					index++;
	  				}
	  				
	  				if(!foundMatch)
	  				{
	  					value["numFollowers-" + accountId] = value.numFollowers;
	  					value.totalFollowers = value.numFollowers
	  					$rootScope.highlevelAnalytics.followersGraph.followerAnalytics.splice(index, 0, value);
	  				}
	}
	
	$scope.updateAnalyticsData = function(accountId, key, value)
	{
		var accountAnalytics;
		
		accountAnalytics = $scope.backupAnalyticsMap[accountId];
		
		if (!accountAnalytics)
		{
			accountAnalytics = {};
		}
		
		accountAnalytics[key] = value;

		$scope.backupAnalyticsMap[accountId] = accountAnalytics;
		
		// update the local copy if necessary
    	if(!$scope.isUndefined($rootScope.accountAnalytics.selectedAccount) && $rootScope.accountAnalytics.selectedAccount.accountId == accountId)
    	{
    		$rootScope.accountAnalytics[key] = value;
    	}
    	
    	if($scope.generatingPdfReport)
    	{	
    		var found = false;
    	
    		// store analytics in list so all data can be shown concurently
    		for(var i = 0; i < $rootScope.accountAnalyticsList.length; i++)
    		{
    			var analytics = $rootScope.accountAnalyticsList[i];
    			if(analytics.account.accountId == accountId)
    			{
    				analytics[key] = value;
    				found = true;
    				break;
    			}
    		}
    		
    		if(!found)
	    	{
	    		// get the account for this account ID
	    		var account = null;
	    		for(var i = 0; i < $rootScope.clientReport.accounts.length; i++)
	    		{
	    			var storedAccount = $rootScope.clientReport.accounts[i];
	    			if(storedAccount.accountId == accountId)
	    			{
	    				account = storedAccount;
	    			}
	    		}
    		
	    		var analytics = {};
	    		analytics.account = account;
	    		analytics[key] = value;
	    		$rootScope.accountAnalyticsList.push(analytics);
	    	}
    	}
	}
	
	$scope.updateAdAnalyticsData = function(accountId, key, value)
	{
		var accountAnalytics;
		
		// No Web Storage support, use backupMap
		accountAnalytics = $scope.backupAnalyticsMap[accountId];
		
		if (!accountAnalytics)
		{
			accountAnalytics = {};
		}
		
		accountAnalytics[key] = value;

		$scope.backupAnalyticsMap[accountId] = accountAnalytics;
		
		// update the local copy if necessary
    	if(!$scope.isUndefined($rootScope.adAccountAnalytics.selectedAccount) && $rootScope.adAccountAnalytics.selectedAccount.accountId == accountId)
    	{
    		$rootScope.adAccountAnalytics[key] = value;
    	}
    	
    	if($scope.generatingPdfReport)
    	{	
    		var found = false;
    	
    		// store analytics in list so all data can be shown concurently
    		for(var i = 0; i < $rootScope.adAccountAnalyticsList.length; i++)
    		{
    			var analytics = $rootScope.adAccountAnalyticsList[i];
    			if(analytics.account.accountId == accountId)
    			{
    				analytics[key] = value;
    				found = true;
    				break;
    			}
    		}
    		
    		if(!found)
	    	{
	    		// get the account for this account ID
	    		var account = null;
	    		for(var i = 0; i < $rootScope.clientReport.adAccounts.length; i++)
	    		{
	    			var storedAccount = $rootScope.clientReport.adAccounts[i];
	    			if(storedAccount.accountId == accountId)
	    			{
	    				account = storedAccount;
	    			}
	    		}
    		
	    		var analytics = {};
	    		analytics.account = account;
	    		analytics[key] = value;
	    		$rootScope.adAccountAnalyticsList.push(analytics);
	    	}
    	}
	}
	
	$rootScope.pdfReportInit = function()
	{
		$scope.loadWhiteLabelInfo();
		$scope.generatingPdfReport = true;
		let maxLoadTimeParam = parseInt(getParameterByName("pdf_max_load_time"));
		maxLoadTime = maxLoadTimeParam && typeof maxLoadTimeParam === 'number' ? maxLoadTimeParam : 50
	}
	
	$rootScope.accountAnalyticsList = [];
	$rootScope.adAccountAnalyticsList = [];
	
	$scope.backupAnalyticsMap = {};
	
	$rootScope.showAccountAnalytics = function(account)
	{	
		var accountId = account.accountId;
		
		$rootScope.accountAnalytics = $scope.backupAnalyticsMap[accountId];
    		
		if (!$rootScope.accountAnalytics)
		{
			$rootScope.accountAnalytics = {};
		} else
		{
			var postAnalyticsGraph = $rootScope.accountAnalytics.postAnalyticsGraph;
			
			if(!$scope.isUndefined(postAnalyticsGraph))
			{
				if(!$scope.isEmpty(postAnalyticsGraph.postAnalytics))
				{
					angular.forEach(postAnalyticsGraph.postAnalytics, function(value) {
						value.date = new Date(value.postDate);
					});
				}
				
				if(!$scope.isEmpty(postAnalyticsGraph.reachData))
				{
					angular.forEach(postAnalyticsGraph.reachData, function(value) {
						value.date = new Date(value.postDate);
					});
				}
			}
			
			var historicalPostAnalyticsGraph = $rootScope.accountAnalytics.historicalPostAnalyticsGraph;
			
			if(!$scope.isUndefined(historicalPostAnalyticsGraph))
			{
				historicalPostAnalyticsGraph.options.tooltipHook = historicalTooltipHook;
				
				if(!$scope.isEmpty(historicalPostAnalyticsGraph.postAnalytics))
				{
					angular.forEach(historicalPostAnalyticsGraph.postAnalytics, function(value) {
						value.date = new Date(value.postDate);
					});
				}
				
				if(!$scope.isEmpty(historicalPostAnalyticsGraph.reachData))
				{
					angular.forEach(historicalPostAnalyticsGraph.reachData, function(value) {
						value.date = new Date(value.postDate);
					});
				}
			}
			
			var followersGraph = $rootScope.accountAnalytics.followersGraph;
			
			if(!$scope.isUndefined(followersGraph))
			{
				if(!$scope.isEmpty(followersGraph.followerAnalytics))
				{
					angular.forEach(followersGraph.followerAnalytics, function(value) {
						value.graphDate = new Date(value.date);
					});
				}
				
				if(!$scope.isEmpty(followersGraph.platformAnalyticsDeltas))
				{
					angular.forEach(followersGraph.platformAnalyticsDeltas, function(value) {
						value.graphDate = new Date(value.date);
					});						
				}
				
				if(!$scope.isEmpty(followersGraph.annotations))
				{
					angular.forEach(followersGraph.annotations, function(value) {
						value.graphDate = new Date(value.date);
					});						
				}
			}
			
			let individualHashtagAnalyticsGraph = $rootScope.accountAnalytics.individualHashtagAnalyticsGraph;
			let bucketHashtagAnalyticsGraph = $rootScope.accountAnalytics.bucketHashtagAnalyticsGraph;
			if (individualHashtagAnalyticsGraph && individualHashtagAnalyticsGraph.individualHashtagGraphData.length) {
				$scope.accountIndividualHashtagMaxPostCount = 0;
				$scope.accountIndividualHashtagMaxAvgImpressionsCount = 0;
				$scope.accountIndividualHashtagMaxAvgEngagementCount = 0;
				
				if (!$scope.accountIndividualHashtagMaxPostCounts){
					$scope.accountIndividualHashtagMaxPostCounts = {}	
				}
				$scope.accountIndividualHashtagMaxPostCounts[accountId] = 0;
				
				if (!$scope.accountIndividualHashtagMaxAvgImpressionsCounts){
					$scope.accountIndividualHashtagMaxAvgImpressionsCounts = {};
				}
				$scope.accountIndividualHashtagMaxAvgImpressionsCounts[accountId] = 0;
				
				if (!$scope.accountIndividualHashtagMaxAvgEngagementCounts){
					$scope.accountIndividualHashtagMaxAvgEngagementCounts = {};
				}
				$scope.accountIndividualHashtagMaxAvgEngagementCounts[accountId] = 0;
				
				individualHashtagAnalyticsGraph.individualHashtagGraphData.forEach((hashtag) => 
				{
					if ($scope.accountIndividualHashtagMaxPostCount < hashtag.postCount) {
						$scope.accountIndividualHashtagMaxPostCount = hashtag.postCount;
					}
					
					if ($scope.accountIndividualHashtagMaxPostCounts[accountId] < hashtag.postCount) {
						$scope.accountIndividualHashtagMaxPostCounts[accountId] = hashtag.postCount;
					}
					
					if ($scope.accountIndividualHashtagMaxAvgImpressionsCount < hashtag.avgImpressions) {
						$scope.accountIndividualHashtagMaxAvgImpressionsCount = hashtag.avgImpressions;
					}
					
					if ($scope.accountIndividualHashtagMaxAvgImpressionsCounts[accountId] < hashtag.avgImpressions) {
						$scope.accountIndividualHashtagMaxAvgImpressionsCounts[accountId] = hashtag.avgImpressions;
					}
					
					if ($scope.accountIndividualHashtagMaxAvgEngagementCount < hashtag.avgEngagement) {
						$scope.accountIndividualHashtagMaxAvgEngagementCount = hashtag.avgEngagement;
					}
					
					if ($scope.accountIndividualHashtagMaxAvgEngagementCounts[accountId] < hashtag.avgEngagement) {
						$scope.accountIndividualHashtagMaxAvgEngagementCounts[accountId] = hashtag.avgEngagement;
					}
				});

				$rootScope.orderHashtagGraphBy($rootScope.accountAnalytics, 'postCount', 'desc');
				$rootScope.orderHashtagGraphBy($rootScope.accountAnalytics, 'avgImpressions', 'desc');
				$rootScope.orderHashtagGraphBy($rootScope.accountAnalytics, 'avgEngagement', 'desc');
			}
			
			if (bucketHashtagAnalyticsGraph && bucketHashtagAnalyticsGraph.bucketHashtagGraphData.length) {
				$scope.accountBucketHashtagMaxPostCount = 0;
				$scope.accountBucketHashtagMaxAvgImpressionsCount = 0;
				$scope.accountBucketHashtagMaxAvgEngagementCount = 0;
				
				if (!$scope.accountBucketHashtagMaxPostCounts){
					$scope.accountBucketHashtagMaxPostCounts = {}	
				}
				$scope.accountBucketHashtagMaxPostCounts[accountId] = 0;
				
				if (!$scope.accountBucketHashtagMaxAvgImpressionsCounts){
					$scope.accountBucketHashtagMaxPostCounts = {};
				}
				$scope.accountBucketHashtagMaxPostCounts[accountId] = 0;
				
				if (!$scope.accountBucketHashtagMaxAvgEngagementCounts){
					$scope.accountBucketHashtagMaxPostCounts = {};
				}
				$scope.accountBucketHashtagMaxPostCounts[accountId] = 0;
				
				bucketHashtagAnalyticsGraph.bucketHashtagGraphData.forEach((hashtag) => 
				{
					if ($scope.accountBucketHashtagMaxPostCount < hashtag.postCount) {
						$scope.accountBucketHashtagMaxPostCount = hashtag.postCount;
					}
					
					if ($scope.accountBucketHashtagMaxPostCounts[accountId] < hashtag.postCount) {
						$scope.accountBucketHashtagMaxPostCounts[accountId] = hashtag.postCount;
					}
					
					if ($scope.accountBucketHashtagMaxAvgImpressionsCount < hashtag.avgImpressions) {
						$scope.accountBucketHashtagMaxAvgImpressionsCount = hashtag.avgImpressions;
					}
					
					if ($scope.accountBucketHashtagMaxAvgImpressionsCounts[accountId] < hashtag.avgImpressions) {
						$scope.accountBucketHashtagMaxAvgImpressionsCounts[accountId] = hashtag.avgImpressions;
					}
					
					if ($scope.accountBucketHashtagMaxAvgEngagementCount < hashtag.avgEngagement) {
						$scope.accountBucketHashtagMaxAvgEngagementCount = hashtag.avgEngagement;
					}		
					
					if ($scope.accountBucketHashtagMaxAvgEngagementCounts[accountId] < hashtag.avgEngagement) {
						$scope.accountBucketHashtagMaxAvgEngagementCounts[accountId] = hashtag.avgEngagement;
					}
				});
			}
			
			let individualCategoryAnalyticsGraph = $rootScope.accountAnalytics.individualCategoryAnalyticsGraph;
			
			if (individualCategoryAnalyticsGraph && individualCategoryAnalyticsGraph.individualCategoryGraphData.length) {
				$scope.accountIndividualCategoryMaxPostCount = 0;
				$scope.accountIndividualCategoryMaxAvgImpressionsCount = 0;
				$scope.accountIndividualCategoryMaxAvgEngagementCount = 0;
				$scope.accountIndividualCategoryMaxAvgLikesCount = 0;
				$scope.accountIndividualCategoryMaxAvgCommentsCount = 0;
				$scope.accountIndividualCategoryMaxAvgSharesCount = 0;
				if (!$scope.accountIndividualCategoryMaxPostCounts){
					$scope.accountIndividualCategoryMaxPostCounts = {}	
				}
				$scope.accountIndividualCategoryMaxPostCounts[accountId] = 0;
				
				if (!$scope.accountIndividualCategoryMaxAvgImpressionsCounts){
					$scope.accountIndividualCategoryMaxAvgImpressionsCounts = {};
				}
				$scope.accountIndividualCategoryMaxAvgImpressionsCounts[accountId] = 0;
				
				if (!$scope.accountIndividualCategoryMaxAvgEngagementCounts){
					$scope.accountIndividualCategoryMaxAvgEngagementCounts = {};
				}
				$scope.accountIndividualCategoryMaxAvgEngagementCounts[accountId] = 0;
				
				individualCategoryAnalyticsGraph.individualCategoryGraphData.forEach((category) => 
				{
					if ($scope.accountIndividualCategoryMaxPostCount < category.postCount) {
						$scope.accountIndividualCategoryMaxPostCount = category.postCount;
					}
					
					if ($scope.accountIndividualCategoryMaxPostCounts[accountId] < category.postCount) {
						$scope.accountIndividualCategoryMaxPostCounts[accountId] = category.postCount;
					}
					
					if ($scope.accountIndividualCategoryMaxAvgImpressionsCount < category.avgImpressions) {
						$scope.accountIndividualCategoryMaxAvgImpressionsCount = category.avgImpressions;
					}
					
					if ($scope.accountIndividualCategoryMaxAvgImpressionsCounts[accountId] < category.avgImpressions) {
						$scope.accountIndividualCategoryMaxAvgImpressionsCounts[accountId] = category.avgImpressions;
					}
					
					if ($scope.accountIndividualCategoryMaxAvgEngagementCount < category.avgEngagement) {
						$scope.accountIndividualCategoryMaxAvgEngagementCount = category.avgEngagement;
					}
					
					if ($scope.accountIndividualCategoryMaxAvgEngagementCounts[accountId] < category.avgEngagement) {
						$scope.accountIndividualCategoryMaxAvgEngagementCounts[accountId] = category.avgEngagement;
					}
					
					if ($scope.accountIndividualCategoryMaxAvgLikesCount < category.avgLikes) {
						$scope.accountIndividualCategoryMaxAvgLikesCount = category.avgLikes;
					}
					
					if ($scope.accountIndividualCategoryMaxAvgCommentsCount < category.avgComments) {
						$scope.accountIndividualCategoryMaxAvgCommentsCount = category.avgComments;
					}
					
					if ($scope.accountIndividualCategoryMaxAvgSharesCount < category.avgShares) {
						$scope.accountIndividualCategoryMaxAvgSharesCount = category.avgShares;
					}
				});

				$rootScope.orderCategoryGraphBy($rootScope.accountAnalytics, 'postCount', 'desc');
				$rootScope.orderCategoryGraphBy($rootScope.accountAnalytics, 'avgImpressions', 'desc');
				$rootScope.orderCategoryGraphBy($rootScope.accountAnalytics, 'avgEngagement', 'desc');
				$rootScope.orderCategoryGraphBy($rootScope.accountAnalytics, 'avgLikes', 'desc');
				$rootScope.orderCategoryGraphBy($rootScope.accountAnalytics, 'avgComments', 'desc');
				$rootScope.orderCategoryGraphBy($rootScope.accountAnalytics, 'avgShares', 'desc');
			}
		}
		
		$rootScope.accountAnalytics.selectedAccount = account;
		
		console.log("Selected account " + accountId, $rootScope.accountAnalytics);
	}

	const ACCOUNT_LEVEL_ANALYTICS_VIEW = 1;
	let accountLevelAnalyticsOnlyPlatforms = ["PINTEREST", "TIKTOK", "YOUTUBE"]
	$rootScope.selectAnalyticsAccount = function() {
		 if ($scope.analyticsView!== ACCOUNT_LEVEL_ANALYTICS_VIEW) {
			 //default to an account that supports post, insights, or hashtag analytics
			 if (accountLevelAnalyticsOnlyPlatforms.includes($rootScope.accountAnalytics?.selectedAccount?.platformType)) {
				 let account = $rootScope.clientReport.accounts?.find(account => !accountLevelAnalyticsOnlyPlatforms.includes(account.platformType));
				 if (account?.accountId) {
					 $rootScope.accountAnalytics.selectedAccount = account;
					 $rootScope.showAccountAnalytics(account);
				 }
			 }
		 } else {
			 $rootScope.accountAnalytics.selectedAccount = $rootScope.clientReport.accounts[0];
		 }
	}

	$rootScope.filterAccountsSupportedByActiveView = function(accounts) {
		let filteredAccounts = accounts?.filter(account => {
			if ($scope.analyticsView !== ACCOUNT_LEVEL_ANALYTICS_VIEW) {
				return !accountLevelAnalyticsOnlyPlatforms.includes(account.platformType);
			}
			return true;
		})
		return filteredAccounts;
	}
	$rootScope.allLevelsSelected = function(parentData, childData)
	{
		let showAll = true;
		
		angular.forEach(childData, function(value) {
			showAll = showAll && value.selected;
		});
		
		if (childData && childData.length > 1){
			showAll = showAll && parentData.selected;
		}
	
		return showAll;
	}
	
	$rootScope.toggleAllLevels = function(parentData, childData)
	{
		let show = $rootScope.allLevelsSelected(parentData, childData) == false;
		
		angular.forEach(childData, function(value) {
			value.selected = show;
			$rootScope.currentLevel.selections[value.levelId] = show;
		});
		
		if (childData && childData.length > 1){
			parentData.selected = show;
			$rootScope.currentLevel.selections[parentData.levelId] = show;
		}
	}
	
	$rootScope.toggleLevel = function(level, parentData)
	{
		level.selected = (level.selected == false)
		$rootScope.currentLevel.selections[level.levelId] = level.selected;
	}
	
	$rootScope.scrollToLevel = function(event, level, parentData)
	{
		level.selected = true;
		$rootScope.currentLevel.selections[level.levelId] = level.selected;
		
		//has not yet rendered not sure when the dom will update may need to call this after a small timeout
		setTimeout(function () {
			var levelDiv = $("#" + level.levelId); 
			if(levelDiv.length > 0)
			{
				var levelDivTop = levelDiv.offset().top;
				console.log("Scrolling to: " + levelDivTop);		
				$('html,body').animate({scrollTop: levelDivTop}, 500);
			}
		}, 10);
	}
	
	$rootScope.isTallTable = function()
	{
		return $('#ad_analytics_datatable').height() > 410;
	}
	
	$rootScope.toggleTableCollapse = function(){
		$rootScope.tableCollapsed = !$rootScope.tableCollapsed;
		
		var table = document.getElementById("ad_analytics_datatable");
		if($rootScope.tableCollapsed){
			table.scrollIntoView({behavior: "smooth"});
		}
	}
	
	$rootScope.getHeaderTabCount = function(){
		let count = 0;
		if($rootScope.clientReport.showAccounts){
			count++;
		}
		if($rootScope.clientReport.showAdAccounts){
			count++;
		}
		if($rootScope.clientReport.showWebAnalytics){
			count++;
		}
		
		
		return count;
	}
	
	$rootScope.tableSettings = {};
	$rootScope.tableSettings.expanded = false;
	$rootScope.adLevelStack = [];
	$rootScope.currentLevel = {};
	$rootScope.currentLevel.id = undefined;
	$rootScope.currentLevel.name = undefined;
	$rootScope.currentLevel.type = undefined;
	$rootScope.currentLevel.selections = {};
	$rootScope.tableCollapsed = true;
	
	$rootScope.showAdAccountAnalytics = function(account)
	{	
		let accountTimeZone = account.accountTimeZone
		let accountId = account.accountId;
		//reset level history
		let prevLevel = $rootScope.currentLevel;
		$rootScope.adLevelStack = [];
		$rootScope.currentLevel = {};
		$rootScope.currentLevel.id = accountId;
		$rootScope.currentLevel.name = account.accountName;
		$rootScope.currentLevel.type = 'account';
		$rootScope.currentLevel.selections = prevLevel.selections;
		
			let adAccountAnalytics = $scope.backupAnalyticsMap[accountId];
    		
    		if (!adAccountAnalytics)
    		{
    			$rootScope.adAccountAnalytics = {};
    		}
    		else
    		{
    			$rootScope.adAccountAnalytics.adAnalyticsGraph = adAccountAnalytics['adAnalyticsGraph'];
    			var adAnalyticsGraph = $rootScope.adAccountAnalytics.adAnalyticsGraph;
    			// might have to update child graphs as well.if(!$scope.isUndefined(adAnalyticsGraph))
   				if(!$scope.isEmpty(adAnalyticsGraph.adAnalytics))
   				{
    				angular.forEach(adAnalyticsGraph.adAnalytics, function(value) {
    					//get Account TimeZone offset
    					let actZoneOffset = moment.tz.zone(accountTimeZone).utcOffset(value.dateStart); 
    					let dateStart = new Date(value.dateStart);
    					value.graphDate = new Date(dateStart.getTime() + ((dateStart.getTimezoneOffset()-actZoneOffset) * 60 * 1000));
					});
    				
    				 var mainGraphOptions = adAnalyticsGraph.mainGraphOptions;
    				 mainGraphOptions.tooltipHook = dailyDateTooltipHook;
                     angular.forEach(mainGraphOptions.series, function(series) {
                  	   series.defined = function(value) {
                  		   return (value.y1 !== undefined && value.y1 !== null);
                        };  
                     });
                     
                     mainGraphOptions.axes.y.tickFormat = function(value, index) {
                    	 return $scope.formatLargeNumberWithDecimals(value);
					    }
                     mainGraphOptions.axes.y2.tickFormat = function(value, index) {
					        return $rootScope.getCurrencySymbol(adAnalyticsGraph.currency) + $scope.formatCurrency(value, true);
					    }
				}	
   				if(!$scope.isEmpty(adAnalyticsGraph.childGraphData))
   				{
    				angular.forEach(adAnalyticsGraph.childGraphData, function(childGraph) {
    					angular.forEach(childGraph.adAnalytics, function(value) {
    						//get Account TimeZone offset
        					let actZoneOffset = moment.tz.zone(accountTimeZone).utcOffset(value.dateStart); 
        					let dateStart = new Date(value.dateStart);
        					value.graphDate = new Date(dateStart.getTime() + ((dateStart.getTimezoneOffset()-actZoneOffset) * 60 * 1000));    
    					});
    					
    					if ($rootScope.currentLevel.selections[childGraph.levelId] === false)
    					{
    						childGraph.selected = $rootScope.currentLevel.selections[childGraph.levelId];
    					}
    					
                       var childGraphOptions = childGraph.mainGraphOptions;
                       childGraphOptions.tooltipHook = dailyDateTooltipHook;
                       angular.forEach(childGraphOptions.series, function(series) {
                    	   series.defined = function(value) {
                    		   return (value.y1 !== undefined && value.y1 !== null);
                          };  
                       });
                       childGraphOptions.axes.y.tickFormat = function(value, index) {
                      	 	return $scope.formatLargeNumberWithDecimals(value);
  					    }
                       childGraphOptions.axes.y2.tickFormat = function(value, index) {
					        return $rootScope.getCurrencySymbol(adAnalyticsGraph.currency) + $scope.formatCurrency(value, true);
					    }
					});
				}	
   				if($rootScope.currentLevel.selections[adAnalyticsGraph.levelId] === false)
   				{
   					adAnalyticsGraph.selected = $rootScope.currentLevel.selections[adAnalyticsGraph.levelId];
   				}
			}		

		$rootScope.adAccountAnalytics.selectedAccount = account;
	
		console.log("Selected account " + accountId, $rootScope.adAccountAnalytics);
	}
	
	$rootScope.backAdAnalytics = function()
	{	
		let prevHistory = {};
		let adAnalyticsView = 0;
		if(!$scope.isEmpty($rootScope.adLevelStack)){
			prevHistory = $rootScope.adLevelStack.pop();
			$rootScope.currentLevel.selections = prevHistory.selections;
			switch(prevHistory.type){
			case 'account':
				$rootScope.backAdAnalyticsAccount(prevHistory);
				adAnalyticsView = 0;
				break;
			case 'objective':
				$rootScope.backAdAnalyticsObjective(prevHistory);
				adAnalyticsView = 1;
				break;
			case 'campagin':
				adAnalyticsView = 2;
				break;
			default:
				adAnalyticsView = 0;
			}
		} else {
			//get first available account 
			if($scope.isNotEmpty($rootScope.clientReport.adAccounts))
			{
				$rootScope.adAccountAnalytics.selectedAccount = $rootScope.clientReport.adAccounts[0];
				$rootScope.showAdAccountAnalytics($rootScope.adAccountAnalytics.selectedAccount);
			}
		}
		
		$rootScope.setAdAnalyticsView(adAnalyticsView);
	}
	
	$rootScope.backAdAnalyticsAccount = function(parentLevel)
	{	
		let accountId;
		let account = {};
		
			accountId = parentLevel.id
			//loop through accounts and find the one with the same id
			if($scope.isNotEmpty($rootScope.clientReport.adAccounts))
			{
				angular.forEach($rootScope.clientReport.adAccounts, function(value) {
					if(value.accountId === accountId){
						account = value;
					}
                });
				if(account.accountId){
					$rootScope.adAccountAnalytics.selectedAccount = account
				} else {
					$rootScope.adAccountAnalytics.selectedAccount = $rootScope.clientReport.adAccounts[0];
				}
				$rootScope.showAdAccountAnalytics($rootScope.adAccountAnalytics.selectedAccount);
			}
	}
	
	$rootScope.backAdAnalyticsObjective = function(parentLevel)
	{
		$rootScope.showAdAnalyticsObjective(parentLevel.id, parentLevel.name, true);
	}
	
	$rootScope.compareValues = function(key, order) {
		order = order == undefined ? 'asc' : order;  
		return function innerSort(a, b) {
			// eslint-disable-next-line
		    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
		      // property doesn't exist on either object
		      return 0;
		    }
		    
		    const varA = (typeof a[key] === 'string')
		      ? a[key].toUpperCase() : a[key];
		    const varB = (typeof b[key] === 'string')
		      ? b[key].toUpperCase() : b[key];

		    let comparison = 0;
		    if (varA > varB) {
		      comparison = 1;
		    } else if (varA < varB) {
		      comparison = -1;
		    }
		    return (
		      (order === 'desc') ? (comparison * -1) : comparison
		    );
		  };
		}
	
	$rootScope.formatKeyMetricDesc = function(oldDesc, newDesc)
	{
		if(!oldDesc){
			return newDesc;
		} else if(oldDesc === newDesc){
			return newDesc;
		}else{
			return 'Key Metric Varies';
		}
	}
	
	$rootScope.showAdAnalyticsObjective = function(objectiveId, objectiveName, ignoreHistory)
	{	
		//update level history
		if(!ignoreHistory){
			let currLevel = {};
			currLevel.id = $rootScope.currentLevel.id;
			currLevel.name = $rootScope.currentLevel.name;
			currLevel.type = $rootScope.currentLevel.type;
			currLevel.selections = $rootScope.currentLevel.selections;
			$rootScope.adLevelStack.push(currLevel);
			$rootScope.currentLevel.selections = {};
		} 
		let accountId = $rootScope.adAccountAnalytics.selectedAccount.accountId;
		let accountTimeZone = $rootScope.adAccountAnalytics.selectedAccount.accountTimeZone;
		if(!objectiveId || objectiveId === accountId){
			$rootScope.currentLevel.id = accountId;
			$rootScope.currentLevel.name = "All Objectives";
			$rootScope.currentLevel.type = "objective";
		} else {
			$rootScope.currentLevel.id = objectiveId;
			$rootScope.currentLevel.name = objectiveName;
			$rootScope.currentLevel.type = "objective";
		}
		
		let key = "adAnalyticsGraph-objective-" + objectiveId;
		
		let adAccountAnalytics = $scope.backupAnalyticsMap[accountId];
		
		if (!adAccountAnalytics)
		{
			$rootScope.adAccountAnalytics = {};
		} else
		{
			var adAnalyticsGraph = {};
			//if objectiveid = undefined or objectiveid = accountid
			if (objectiveId === undefined || objectiveId === accountId){
				adAnalyticsGraph = adAccountAnalytics["adAnalyticsGraph"];
				let oldDesc;
				let totalNumOfChildren = 0;
				if(!$scope.isEmpty(adAnalyticsGraph.childGraphData)){
					delete adAnalyticsGraph.childGraphData;
					adAnalyticsGraph.childGraphData = [];
					//loop ad analytics parent = account level and child = all children with objective- prefix but not -campaign prefix
					const keys = Object.keys(adAccountAnalytics);
					keys.forEach(function(key, index) {
							let keyParts =  key.split("-");
							if (keyParts[1] === 'objective' && keyParts[2] && keyParts[3] !== 'campaign' ){
								if (!$scope.isEmpty(adAccountAnalytics[key].childGraphData)){
									angular.forEach(adAccountAnalytics[key].childGraphData, function(value) {
										oldDesc = $rootScope.formatKeyMetricDesc(oldDesc, value.keyMetricDesc);
											adAnalyticsGraph.childGraphData.push(value);
											totalNumOfChildren += value.numOfChildren;
									});
								}
							}		 
					});
				}
				
				adAnalyticsGraph.level = 'All Campaigns';
				adAnalyticsGraph.keyMetricDesc = oldDesc;
				adAnalyticsGraph.numOfChildren = totalNumOfChildren;
				adAnalyticsGraph.childGraphData.sort($rootScope.compareValues('level'));
				$rootScope.adAccountAnalytics.adAnalyticsGraph = adAnalyticsGraph;
			} else {
				$rootScope.adAccountAnalytics.adAnalyticsGraph = adAccountAnalytics[key];
				adAnalyticsGraph = $rootScope.adAccountAnalytics.adAnalyticsGraph;
			}
			
			if(!$scope.isEmpty(adAnalyticsGraph.adAnalytics))
			{
				angular.forEach(adAnalyticsGraph.adAnalytics, function(value) {
					//get Account TimeZone offset
					let actZoneOffset = moment.tz.zone(accountTimeZone).utcOffset(value.dateStart); 
					let dateStart = new Date(value.dateStart);
					value.graphDate = new Date(dateStart.getTime() + ((dateStart.getTimezoneOffset()-actZoneOffset) * 60 * 1000));
				});
				
					var mainGraphOptions = adAnalyticsGraph.mainGraphOptions;
					mainGraphOptions.tooltipHook = dailyDateTooltipHook;
					angular.forEach(mainGraphOptions.series, function(series) {
					series.defined = function(value) {
						return (value.y1 !== undefined && value.y1 !== null);
					};  
					});  
					mainGraphOptions.axes.y.tickFormat = function(value, index) {
						return $scope.formatLargeNumberWithDecimals(value);
					}
					mainGraphOptions.axes.y2.tickFormat = function(value, index) {
						return $rootScope.getCurrencySymbol(adAnalyticsGraph.currency) + $scope.formatCurrency(value, true);
					}    
			}	
			if(!$scope.isEmpty(adAnalyticsGraph.childGraphData))
			{
				angular.forEach(adAnalyticsGraph.childGraphData, function(childGraph) {
					angular.forEach(childGraph.adAnalytics, function(value) {
						//get Account TimeZone offset
						let actZoneOffset = moment.tz.zone(accountTimeZone).utcOffset(value.dateStart); 
						let dateStart = new Date(value.dateStart);
						value.graphDate = new Date(dateStart.getTime() + ((dateStart.getTimezoneOffset()-actZoneOffset) * 60 * 1000));     
					});
					
					if($rootScope.currentLevel.selections[childGraph.levelId] === false){
						childGraph.selected = $rootScope.currentLevel.selections[childGraph.levelId];
					}
					var childGraphOptions = childGraph.mainGraphOptions;
					childGraphOptions.tooltipHook = dailyDateTooltipHook;
					angular.forEach(childGraphOptions.series, function(series) {
						series.defined = function(value) {
							return (value.y1 !== undefined && value.y1 !== null);
						};  
					});
					childGraphOptions.axes.y.tickFormat = function(value, index) {
						return $scope.formatLargeNumberWithDecimals(value);
					}
					childGraphOptions.axes.y2.tickFormat = function(value, index) {
						return $rootScope.getCurrencySymbol(adAnalyticsGraph.currency) + $scope.formatCurrency(value, true);
					}
				});
			}
			if($rootScope.currentLevel.selections[adAnalyticsGraph.levelId] === false){
				adAnalyticsGraph.selected = $rootScope.currentLevel.selections[adAnalyticsGraph.levelId];
			}
		}		

		console.log("Selected account " + accountId, $rootScope.adAccountAnalytics);
	}

	$rootScope.showAdAnalyticsCampaign = function(campaignId, campaignName)
	{	
		//update level history
		
		let objectiveId = $rootScope.currentLevel.id;
		let dataKey = "adAnalyticsGraph-objective-" + objectiveId + '-campaign-' + campaignId;
		
		let currLevel = {};
		currLevel.id = $rootScope.currentLevel.id;
		currLevel.name = $rootScope.currentLevel.name;
		currLevel.type = $rootScope.currentLevel.type;
		currLevel.selections = $rootScope.currentLevel.selections;
		$rootScope.adLevelStack.push(currLevel);
		
		let accountId = $rootScope.adAccountAnalytics.selectedAccount.accountId;
		let accountTimeZone = $rootScope.adAccountAnalytics.selectedAccount.accountTimeZone;
		if(!campaignId || campaignId === accountId){
			$rootScope.currentLevel.id = accountId;
			$rootScope.currentLevel.name = "All Campaigns";
			$rootScope.currentLevel.type = "campaign";
			$rootScope.currentLevel.selections = {};
		} else {
			$rootScope.currentLevel.id = campaignId;
			$rootScope.currentLevel.name = campaignName;
			$rootScope.currentLevel.type = "campaign";
			$rootScope.currentLevel.selections = {};
		}
		
		let adAccountAnalytics = $scope.backupAnalyticsMap[accountId];

		if (!adAccountAnalytics)
		{
			$rootScope.adAccountAnalytics = {};
		}

		else
		{
			var adAnalyticsGraph = {};
			//if objectiveid = undefined or objectiveid = accountid
			if (campaignId === undefined || campaignId === accountId){
				let oldDesc;
				if(objectiveId === undefined || objectiveId === accountId){
					adAnalyticsGraph = adAccountAnalytics["adAnalyticsGraph"];
					if(!$scope.isEmpty(adAnalyticsGraph.childGraphData)){
						delete adAnalyticsGraph.childGraphData;
						adAnalyticsGraph.childGraphData = [];
						//loop ad analytics parent = account level and child = all children with objective- prefix but not -campaign prefix
						const keys = Object.keys(adAccountAnalytics);
						keys.forEach(function(key, index) {
								let keyParts =  key.split("-");
								if (keyParts[1] === 'objective' && $rootScope.checkKeyVal(keyParts[2]) &&  keyParts[3] === 'campaign' && $rootScope.checkKeyVal(keyParts[4])){
									if (!$scope.isEmpty(adAccountAnalytics[key].childGraphData)){
										angular.forEach(adAccountAnalytics[key].childGraphData, function(value) {
											oldDesc = $rootScope.formatKeyMetricDesc(oldDesc, value.keyMetricDesc);
												adAnalyticsGraph.childGraphData.push(value);
									});
									}
								}		 
						});
					}
				} else {
					adAnalyticsGraph = adAccountAnalytics["adAnalyticsGraph-objective-" + objectiveId];
					//TODO update level and key metric description
					if(!$scope.isEmpty(adAnalyticsGraph.childGraphData)){
						delete adAnalyticsGraph.childGraphData;
						adAnalyticsGraph.childGraphData = [];
						//loop ad analytics parent = account level and child = all children with objective- prefix but not -campaign prefix
						const keys = Object.keys(adAccountAnalytics);
						keys.forEach(function(key, index) {
								let keyParts =  key.split("-");
								if (keyParts[1] === 'objective' && keyParts[2] === objectiveId && keyParts[3] === 'campaign' && $rootScope.checkKeyVal(keyParts[4]) ){
									if (!$scope.isEmpty(adAccountAnalytics[key].childGraphData)){
										angular.forEach(adAccountAnalytics[key].childGraphData, function(value) {
											oldDesc = $rootScope.formatKeyMetricDesc(oldDesc, value.keyMetricDesc);
												adAnalyticsGraph.childGraphData.push(value);
									});
									}
								}		 
						});
					}
				}
				
				adAnalyticsGraph.level = 'All Ads';
				adAnalyticsGraph.keyMetricDesc = oldDesc;
				adAnalyticsGraph.numOfChildren = adAnalyticsGraph.childGraphData.length;
				adAnalyticsGraph.childGraphData.sort($rootScope.compareValues('level'));
				$rootScope.adAccountAnalytics.adAnalyticsGraph = adAnalyticsGraph;
			} else {
				if (objectiveId === undefined || objectiveId === accountId){
					const keys = Object.keys(adAccountAnalytics);
					keys.forEach(function(key, index) {
							let keyParts =  key.split("-");
							if (keyParts[3] === 'campaign' && keyParts[4] === campaignId){
								$rootScope.adAccountAnalytics.adAnalyticsGraph = adAccountAnalytics[key];
							adAnalyticsGraph = $rootScope.adAccountAnalytics.adAnalyticsGraph;
							}		 
					});
				}
				else{
					$rootScope.adAccountAnalytics.adAnalyticsGraph = adAccountAnalytics[dataKey];
					adAnalyticsGraph = $rootScope.adAccountAnalytics.adAnalyticsGraph;
				}
			}
			
			
			// might have to update child graphs as well.if(!$scope.isUndefined(adAnalyticsGraph))
			if(!$scope.isEmpty(adAnalyticsGraph.adAnalytics))
			{
				angular.forEach(adAnalyticsGraph.adAnalytics, function(value) {
					//get Account TimeZone offset
					let actZoneOffset = moment.tz.zone(accountTimeZone).utcOffset(value.dateStart); 
					let dateStart = new Date(value.dateStart);
					value.graphDate = new Date(dateStart.getTime() + ((dateStart.getTimezoneOffset()-actZoneOffset) * 60 * 1000));
				});
				
					var mainGraphOptions = adAnalyticsGraph.mainGraphOptions;
					mainGraphOptions.tooltipHook = dailyDateTooltipHook;
					angular.forEach(mainGraphOptions.series, function(series) {
					series.defined = function(value) {
						return (value.y1 !== undefined && value.y1 !== null);
					};  
					});   
					mainGraphOptions.axes.y.tickFormat = function(value, index) {
						return $scope.formatLargeNumberWithDecimals(value);
					}
					mainGraphOptions.axes.y2.tickFormat = function(value, index) {
						return $rootScope.getCurrencySymbol(adAnalyticsGraph.currency) + $scope.formatCurrency(value, true);
					}
			}	
			if(!$scope.isEmpty(adAnalyticsGraph.childGraphData))
			{
				angular.forEach(adAnalyticsGraph.childGraphData, function(childGraph) {
					angular.forEach(childGraph.adAnalytics, function(value) {
						//get Account TimeZone offset
						let actZoneOffset = moment.tz.zone(accountTimeZone).utcOffset(value.dateStart); 
						let dateStart = new Date(value.dateStart);
						value.graphDate = new Date(dateStart.getTime() + ((dateStart.getTimezoneOffset()-actZoneOffset) * 60 * 1000));    
					});
					var childGraphOptions = childGraph.mainGraphOptions;
					childGraphOptions.tooltipHook = dailyDateTooltipHook;
					angular.forEach(childGraphOptions.series, function(series) {
						series.defined = function(value) {
							return (value.y1 !== undefined && value.y1 !== null);
						};  
					});
					childGraphOptions.axes.y.tickFormat = function(value, index) {
						return $scope.formatLargeNumberWithDecimals(value);
					}
					childGraphOptions.axes.y2.tickFormat = function(value, index) {
						return $rootScope.getCurrencySymbol(adAnalyticsGraph.currency) + $scope.formatCurrency(value, true);
					}
				});
			}	
		}
	
		console.log("Selected account " + accountId, $rootScope.adAccountAnalytics);
	}
	
	$rootScope.checkKeyVal = function(keyVal)
	{
		switch (keyVal){
		case "undefined":
		case "null":
		case " ":
		case false:
			return false;
		default:
			return true;
		}
	}
	
	/* Variables */
	$rootScope.clientReport = {};
	$rootScope.clientReport.totalSpentFormatted = 0;
	$rootScope.clientReport.costPerEngagement = 0;
	$rootScope.clientReport.costPerImpression = 0;
	$rootScope.clientReport.costPerFollower = 0;
	$rootScope.clientReport.title = "Loading Report...";
	$rootScope.clientReport.accounts = [];
	
	$rootScope.webTraffic = {};
	$rootScope.webAcquisition = {};
	
	$rootScope.highlevelAnalytics = {};
	$rootScope.highlevelAnalytics.numFollowers = 0;
	$rootScope.highlevelAnalytics.numFollowersFormatted = 0;
	$rootScope.highlevelAnalytics.deltaFollowerCount = 0;
	$rootScope.highlevelAnalytics.newFollowerCount = 0;
	$rootScope.highlevelAnalytics.lostFollowerCount = 0;
	$rootScope.highlevelAnalytics.previousNumFollowers = 0;
	$rootScope.highlevelAnalytics.numLikes = 0;
	$rootScope.highlevelAnalytics.numComments = 0;
	$rootScope.highlevelAnalytics.numShares = 0;
	$rootScope.highlevelAnalytics.numClicks = 0;
	$rootScope.highlevelAnalytics.totalPosts = 0;
	$rootScope.highlevelAnalytics.totalEngagement = 0;
	$rootScope.highlevelAnalytics.totalImpressions = 0;
	
	$rootScope.highlevelAnalytics.numHistoricalLikes = 0;
	$rootScope.highlevelAnalytics.numHistoricalComments = 0;
	$rootScope.highlevelAnalytics.numHistoricalShares = 0;
	$rootScope.highlevelAnalytics.numHistoricalClicks = 0;
	$rootScope.highlevelAnalytics.totalHistoricalPosts = 0;
	$rootScope.highlevelAnalytics.totalHistoricalEngagement = 0;
	$rootScope.highlevelAnalytics.totalHistoricalImpressions = 0;
	
	$rootScope.highlevelAnalytics.followersGraph = {};
	$rootScope.highlevelAnalytics.followersGraph.options = {};
	$rootScope.highlevelAnalytics.followersGraph.options.series = [];
   	$rootScope.highlevelAnalytics.followersGraph.options.axes = {x: {key: "graphDate", type: "date"}, y: {min: 0}};
   	$rootScope.highlevelAnalytics.followersGraph.options.margin = { top: 10 };
   	$rootScope.highlevelAnalyticsMaxFollowers = 1;
   	
   	$rootScope.highlevelAnalytics.postAnalyticsGraph = {};
   	$rootScope.highlevelAnalytics.postAnalyticsGraph.postAnalytics = [];
   	$rootScope.highlevelAnalytics.postAnalyticsGraph.options = {};
   	$rootScope.highlevelAnalytics.postAnalyticsGraph.options.columnsHGap = 1;
   	$rootScope.highlevelAnalytics.postAnalyticsGraph.options.series = [];
   	$rootScope.highlevelAnalytics.postAnalyticsGraph.options.axes = {x: {key: "date", type: "date"}, y: {min: 0}};
   	$rootScope.highlevelAnalytics.postAnalyticsGraph.options.margin = { top: 10 };
  
   	var engagementOptions = {
   		margin: {top: 5},
		axis: "y2",
		dataset: "postAnalytics",
		key: "engagement",
		label: "Engagement",
		color: "#1f77b4",
		type: ['column'],
		id: 'engagementSeries',
		columnsHGap: 1
	}
	        
	$rootScope.highlevelAnalytics.postAnalyticsGraph.options.series.push(engagementOptions);
	
	var reachOptions = {
		margin: {top: 5},
		axis: "y",
		dataset: "postAnalytics",
		key: "reach",
		label: "Impressions",
		color: "#f5a038",
		type: ['area'],
		id: 'impressionsSeries',
		interpolation: {mode: "bundle", tension: 0.95}
	}
	        
	$rootScope.highlevelAnalytics.postAnalyticsGraph.options.series.push(reachOptions);
	
	$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalPostAnalytics = [];
	$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalOptions = {};
		      
	$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalOptions.tooltipHook = historicalTooltipHook;
		    
   	$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalOptions.columnsHGap = 1;
   	$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalOptions.series = [];
   	$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalOptions.axes = {x: {key: "date", type: "date"}, y: {min: 0}};
   	$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalOptions.margin = { top: 10 };
  
   	var historicalEngagementOptions = {
   		margin: {top: 5},
		axis: "y2",
		dataset: "historicalPostAnalytics",
		key: "engagement",
		label: "Engagement",
		color: "#1f77b4",
		type: ['column'],
		id: 'engagementSeries',
		columnsHGap: 1
	}
	        
	$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalOptions.series.push(historicalEngagementOptions);
	
	var historicalReachOptions = {
		margin: {top: 5},
		axis: "y",
		dataset: "historicalPostAnalytics",
		key: "reach",
		label: "Impressions",
		color: "#f5a038",
		type: ['area'],
		id: 'impressionsSeries',
		interpolation: {mode: "bundle", tension: 0.95}
	}
	        
	$rootScope.highlevelAnalytics.postAnalyticsGraph.historicalOptions.series.push(historicalReachOptions);

	$scope.loadReport = function(workspaceId, reportId) {
		$scope.getRequest(
			"/rest/analytics/v2/report/" + workspaceId + "/" + reportId, 
			$scope.loadReportCallback, 
			$scope.loadReportErrorCallback
		);
	}
	
	$scope.loadReportCallback = function(data)
	{
		$rootScope.hasLoadedPostAnalytics = true; 
		$rootScope.isLoadingPostAnalytics = false;
		
		$("#report_title").removeClass("loading-text");
		$rootScope.clientReport = data;
		$rootScope.disableCompareData = true;
		let analyticsStartDate = new Date(data.dateStart);
		let analyticsEndDate = new Date(data.dateEnd);
		
		if($scope.isDefined($rootScope.clientReport.websiteAnalytics))
		{
			$rootScope.webTraffic = $rootScope.clientReport.websiteAnalytics.trafficData;
			$rootScope.webAcquisition = $rootScope.clientReport.websiteAnalytics.acquisitionData;
			var socialTrafficScore = $rootScope.clientReport.websiteAnalytics.socialTrafficScore;
			
			// $rootScope.highlevelAnalytics.totalImpressions = $rootScope.webTraffic.thisPeriod.sessions;
			
			try {
				$scope.graphTrafficChannels($rootScope.webAcquisition);
				$scope.graphSocialChannels($rootScope.webAcquisition);
				$scope.graphNewUsers($rootScope.webTraffic);
				$scope.graphSocialHealth(socialTrafficScore);
			
			
				var historicalWebTraffic = $rootScope.clientReport.websiteAnalytics.historicalWebTraffic;
				
				if($scope.isDefined(historicalWebTraffic))
				{
					$scope.graphHistoricalWebAnalytics(historicalWebTraffic);
				}
			}
			catch(err) {
				console.log("Failed to graph web analytics information", err);
				$rootScope.clientReport.hasWebsiteAnalytics = false;
			}
		}
		else
		{
			$rootScope.clientReport.hasWebsiteAnalytics = false;
		}
		

		
		if($scope.isNotEmpty($rootScope.clientReport.campaigns))
		{
			var campaign  = $rootScope.clientReport.campaigns[0];
			$rootScope.showCampaign(campaign);
			
			angular.forEach($rootScope.clientReport.campaigns, function(campaign) {
				if(!campaign.boosted && $scope.isNotEmpty(campaign.results))
				{
					angular.forEach(campaign.results, function(result) {
						if(result.countTowardsImpressions)
						{
							$rootScope.highlevelAnalytics.totalImpressions += result.value;
						}
						
						if(result.countTowardsEngagement)
						{
							$rootScope.highlevelAnalytics.totalEngagement += result.value;
						}
					});
				}
			});
		}
		
		if($scope.isNotEmpty($rootScope.clientReport.historicalRoiData))
		{
			$scope.graphHistoricalRoiData($rootScope.clientReport.historicalRoiData);
		}
		
		$rootScope.analyticsStartDateFormatted = $scope.isEmpty(data.startDateString) ? prettyLocalDate(analyticsStartDate) : data.startDateString;
		$rootScope.analyticsEndDateFormatted = $scope.isEmpty(data.endDateString) ? prettyLocalDate(analyticsEndDate) : data.endDateString;

		if($scope.isNotEmpty(data.compareStartDateString) && $scope.isNotEmpty(data.compareEndDateString))
		{
			$rootScope.disableCompareData = false;
			$rootScope.analyticsCompareStartDate = data.compareStartDateString;
			$rootScope.analyticsCompareEndDate = data.compareEndDateString;
		}
		
		if($scope.isNotEmpty(data.coverPage))
		{
			$rootScope.updateCoverPage(data.coverPage);
		}
	
		//Graph Ad data
		if($scope.isNotEmpty(data.adAccountAnalytics))
		{
			if(!$scope.generatingPdfReport){
				//for each account graph
				angular.forEach($rootScope.clientReport.adAccountAnalytics, function(value, key)
						{
							if($scope.isDefined(value.adAnalytics)){
								let accountTimeZone = "UTC";
								angular.forEach($rootScope.clientReport.adAccounts, function(adAccount)
								{
									if (key === adAccount.accountId){
										accountTimeZone = adAccount.accountTimeZone
									}
								});
								let storageKey = "adAnalyticsReport-" + value.accountId;
								$scope.graphAdAccountAnalytics(value.adAnalytics, value.accountId, accountTimeZone, "adAnalyticsGraph")
							}
						}
				);
				
				if($scope.isNotEmpty($rootScope.clientReport.adAccounts))
				{
					$rootScope.adAccountAnalytics.selectedAccount = $rootScope.clientReport.adAccounts[0];
					$rootScope.showAdAccountAnalytics($rootScope.adAccountAnalytics.selectedAccount);
				}
			} else {
				//PDF specific Logic
				
				
				angular.forEach($rootScope.clientReport.adAccountAnalytics, function(value, key)
						{
							if($scope.isDefined(value.adAnalytics)){
								let accountTimeZone = "UTC";
								angular.forEach($rootScope.clientReport.adAccounts, function(adAccount)
								{
									if (key === adAccount.accountId){
										accountTimeZone = adAccount.accountTimeZone
									}
								});
								let storageKey = "adAnalyticsReport-" + value.accountId;
								$scope.graphAdAccountAnalyticsPDF(value.adAnalytics, value.accountId, accountTimeZone, "adAnalyticsGraphPDF")
							}
						}
				);
			}
			
		}
		//Graph Organic Data
		var accountsWithFollowerData = [];
		
		if($scope.isNotEmpty(data.accountAnalytics))
		{
			angular.forEach($rootScope.clientReport.accountAnalytics, function(value, key)
					{
						let accountId = value.accountId;
						// build follower graphs
						$scope.graphFollowerData(value);
						
						if(value.followerAnalytics.length > 0)
						{
							accountsWithFollowerData.push(accountId);
						}
						
						try
						{
							// build post engagement graphs
							$scope.graphPostAnalytics(value);
						}
						catch(error)
						{
							console.log("Failed to graph analytics", error);
						}
					
						try
						{
							// build histtorical post engagement graphs
							$scope.graphHistoricalPostAnalytics(value);
						}
						catch(error)
						{
							console.log("Failed to graph analytics", error);
						}
						
						try
						{
							// build post insights graphs
							$scope.graphPostInsights(value);
						}
						catch(error)
						{
							console.log("Failed to graph analytics", error);
						}
						
						try
							{
								// build post hashtag graphs
								let accountIndividualHashtagGraphData = $scope.graphIndividualHashtagAnalytics(value, 'account');
								$scope.updateAnalyticsData(accountId, "individualHashtagAnalyticsGraph", accountIndividualHashtagGraphData);
								
								let accountBucketHashtagGraphData = $scope.graphBucketHashtagAnalytics(value, 'account');
								$scope.updateAnalyticsData(accountId, "bucketHashtagAnalyticsGraph", accountBucketHashtagGraphData);
								
								// build post category graphs
								let accountIndividualCategoryGraphData = $scope.graphIndividualCategoryAnalytics(value, 'account');
								$scope.updateAnalyticsData(accountId, "individualCategoryAnalyticsGraph", accountIndividualCategoryGraphData);
								 
								if (value.categoryMap && value.categoryMap.categoryInsights && value.categoryMap.categoryInsights.categoryStats && Object.keys(value.categoryMap.categoryInsights.categoryStats).length > 0){
									$scope.updateAnalyticsData(accountId, "categoryInsights", value.categoryMap.categoryInsights);
								}
								else{
									$scope.updateAnalyticsData(accountId, "categoryInsights", $scope.getMockCategoryInsightsData());
								}
								
								if (value.hashtagMap && value.hashtagMap.hashtagInsights && value.hashtagMap.hashtagInsights.hashtagStats && Object.keys(value.hashtagMap.hashtagInsights.hashtagStats).length > 0){
									$scope.updateAnalyticsData(accountId, "hashtagInsights", value.hashtagMap.hashtagInsights);
								}
								else{
									$scope.updateAnalyticsData(accountId, "hashtagInsights", $scope.getMockHashtagInsightsData());
								}
							}
							catch(error)
							{
								console.log("Failed to graph analytics", error);
							}
						
						// build community graphs
						// $scope.graphCommunityInsights(value);
					});
					
			try
			{
				// fill in any days with missing follower data
				$scope.fillInMissingFollowerData(accountsWithFollowerData, $rootScope.highlevelAnalytics.followersGraph.followerAnalytics);
			}
			catch(error)
			{
				console.log("Failed to fill in missing follower data.");
			}
			
			if($scope.isNotEmpty($rootScope.clientReport.accounts))
			{
				$rootScope.accountAnalytics.selectedAccount = $rootScope.clientReport.accounts[0];
				$rootScope.showAccountAnalytics($rootScope.accountAnalytics.selectedAccount);
			}
		}
		else if($scope.isDefined($rootScope.adAccountAnalytics.selectedAccount))
		{
			//No Organic Analytics detected
			//Disable Organic and defualt to Paid Analytics View
			$rootScope.clientReport.showOrganicAnalytics = false;
		}
		else {
			//Disable 
			$rootScope.clientReport.showOrganicAnalytics = false;
			$rootScope.clientReport.showAdAnalytics = false;
		}
		
		// format amount spent
		$scope.formatAmountSpent();
		
		$rootScope.viewsChanged();
		$rootScope.webViewsChanged();
		
		setTimeout(function(){
			$scope.$apply(function() {
				$rootScope.isDoneLoading = true;
				console.log("is done: " + $rootScope.isDoneLoading);				
			});
		}, 50);
		
		//only run for PDF
		if ($scope.generatingPdfReport){
			//increment loadTime every second
			setInterval( function() {
				loadTime++;
			}, 1000);
			
			setTimeout(function(){
				
				//replace emojis 
				$('.fb-emoji').Emoji({path:'/lib/jqueryemoji/img/apple40/'});	

				totalImages = $('img').length;
				totalVideos = $('video').length;
				
				// Step through each image in the DOM, clone it, attach an onload event
				// listener, then set its source to the source of the original image. When
				// that new image has loaded, fire the imageLoaded() callback.
				$('img').each(function(idx, img) {
					if($(img).attr('src')){
						$('<img>').on('load', imageLoaded).attr('src', $(img).attr('src'));
						$('<img>').on('error', imageLoaded).attr('src', $(img).attr('src'));
					} else {
						imageLoaded();
					}
				});
				
				$('video').each(function(idx, video) {
					if($(video).attr('src')){
						$('<video>').on('loadeddata', videoLoaded).attr('src', $(video).attr('src'));
						$('<video>').on('error', videoLoaded).attr('src', $(video).attr('src'));
					} else {
						videoLoaded();
					}
				});
				

				function imageLoaded() {
					imagesLoaded++;
				}
				
				function videoLoaded() {
					videosLoaded++;
				}
				
				isPdfReportReady = true;
			}, 2000);
		}

		if (data.showOverview) {
			let overviewIndividualHashtagGraphData = $scope.graphIndividualHashtagAnalytics(data.overviewAnalytics, 'overview');
			$scope.highlevelAnalytics.individualHashtagAnalyticsGraph = overviewIndividualHashtagGraphData;
			
			let overviewBucketHashtagGraphData = $scope.graphBucketHashtagAnalytics(data.overviewAnalytics, 'overview');
			$scope.highlevelAnalytics.bucketHashtagAnalyticsGraph = overviewBucketHashtagGraphData;
			
			let overviewIndividualCategoryGraphData = $scope.graphIndividualCategoryAnalytics(data.overviewAnalytics, 'overview');
			$scope.highlevelAnalytics.individualCategoryAnalyticsGraph = overviewIndividualCategoryGraphData;
			
			if (data.overviewAnalytics.categoryMap && data.overviewAnalytics.categoryMap.categoryInsights && data.overviewAnalytics.categoryMap.categoryInsights.categoryStats && Object.keys(data.overviewAnalytics.categoryMap.categoryInsights.categoryStats).length > 0){
				$scope.highlevelAnalytics.categoryInsights = data.overviewAnalytics.categoryMap.categoryInsights;
			}
			else{
				$scope.highlevelAnalytics.categoryInsights = $scope.getMockCategoryInsightsData();
			}
			
			if (data.overviewAnalytics.hashtagMap && data.overviewAnalytics.hashtagMap.hashtagInsights && data.overviewAnalytics.hashtagMap.hashtagInsights.hashtagStats && Object.keys(data.overviewAnalytics.hashtagMap.hashtagInsights.hashtagStats).length > 0){
				$scope.highlevelAnalytics.hashtagInsights = data.overviewAnalytics.hashtagMap.hashtagInsights;
			}
			else{
				$scope.highlevelAnalytics.hashtagInsights = $scope.getMockHashtagInsightsData();
			}
		}
	}
	
	$scope.loadReportErrorCallback = function(error)
	{
		$rootScope.hasLoadedPostAnalytics = true; 
		$rootScope.isLoadingPostAnalytics = false;
		
		console.log("Error loading report", error);
		$scope.genericAlert("Failed to Load Report", "There was an error processing your request.  Please try again later.");
	}
	
	$rootScope.updateCoverPage = function(text)
	{	
		$("#report_cover_page_text").text(text);
	}
	
	$scope.formatAmountSpent = function()
	{
		var totalSpent = $rootScope.clientReport.totalSpent;
		$rootScope.clientReport.totalSpentFormatted = totalSpent;
		
		/* if(totalSpent / 1000000 >= 1)
		{
			var millionSpent = totalSpent / 1000000;
			$rootScope.clientReport.totalSpentFormatted = parseFloat(millionSpent).toFixed(1) + "M";
		}
		else if(totalSpent / 1000 >= 1)
		{
			var thousandSpent = totalSpent / 1000;
			$rootScope.clientReport.totalSpentFormatted = parseFloat(thousandSpent).toFixed(1) + "k";
		}
		else
		{
			$rootScope.clientReport.totalSpentFormatted = totalSpent;
		} */
	}
	
	$rootScope.loadWhiteLabelInfo = function()
	{
		// get subdomain
		var full = window.location.host;
		var subdomain = full.split('.')[0];
		$rootScope.showCCLogoForPDF = false;
		
		if(full === "app.cloudcampaign.com" || full === "app.qa.cloudcampaign.com")
		{
			// not white-labeled, show cloud campaign logo
			$rootScope.showCCLogoForPDF = true;
		}
		else if(full.indexOf("cldportal.com") >= 0 || full.indexOf("localhost") >= 0)
		{
			// cloud portal domain
			if(subdomain != "qa" && subdomain != "cldportal")
			{ 
				$scope.getWhiteLabelInfo(subdomain);
			}
		}
		else
		{
			// custom domain
			$scope.getWhiteLabelInfo(full);
		}
	}
	
	$scope.getWhiteLabelInfo = function(subdomain) {
		$scope.getRequest("/rest/wl/info?subdomain=" + subdomain, 
			$scope.getWhiteLabelInfoCallback, 
			$scope.getWhiteLabelInfoErrorCallback
		);
	}
	
	$scope.getWhiteLabelInfoCallback = function(data)
	{
		$rootScope.whiteLabel = data.whiteLabel;

		if ($rootScope.whiteLabel.logo || $rootScope.whiteLabel.lightLogo) {
			$rootScope.showWhiteLabelLogoForPDF = true;
		}
	}
	
	$scope.getWhiteLabelInfoErrorCallback = function(error)
	{
		$rootScope.whiteLabel = {};
		$rootScope.whiteLabel.logo = "/res/cc-cloud-logo-gray-full.png";
		$rootScope.whiteLabel.lightLogo = "/res/cc-cloud-logo-white-full.png";
		
		console.log("Error loading whitelabel info.", error);

		$rootScope.showWhiteLabelLogoForPDF = false;
	}
	
	$rootScope.removeEntry = function(list, entry)
	{
		var index = list.indexOf(entry);
		
		if(index >= 0)
		{
			list.splice(index, 1);
		}
	}
	
	$rootScope.addObjToArray = function(array)
	{
		if($scope.isUndefined(array))
		{
			array = [];
		}
		array.push({});
	}
	
	$rootScope.addNewCampaign = function(reportParams)
	{
		var campaign = {};
		campaign.results = [];
		
		if($scope.isUndefined(reportParams.campaigns))
		{
			reportParams.campaigns = [];
		}
		
		reportParams.campaigns.push(campaign);
		
		$rootScope.campaignBeingEdited = campaign;
		showCampaignResultsModal();
	}
	
	$rootScope.editCampaign = function(campaign)
	{
		$rootScope.campaignBeingEdited = campaign;
		showCampaignResultsModal();
	}
	
	function stripTrailingSlash(site)     
	{     
    	return site.replace(/\/$/, "");
	} 
	
	$scope.init = function()
	{
		var windowLocation = stripTrailingSlash(window.location.pathname);
		var path = windowLocation.split("report/");
		
		// get brandId and reportId 
		var workspaceId;
		var reportId;
		
		if(path.length > 1)
		{
			path = path[1].split("/");
		
			if(path.length >= 2)
			{
				var workspaceId = path[path.length - 2];
				var reportId = path[path.length - 1];
			}
			else
			{
				$scope.genericAlert("Missing Information", "The URL is not complete.  Please double check the link you clicked on.");
				return;
			}
		}
		else
		{
			$scope.genericAlert("Missing Information", "The URL is not complete.  Please double check the link you clicked on.");
			return;
		}
		
		$scope.loadReport(workspaceId, reportId);
	}
	
	// only for individual hashtag graphs at the moment
	$rootScope.individualHashtagAllGraphsLimit = 10;
	$rootScope.individualHashtagPostCountGraphLimit = 10;
	$rootScope.individualHashtagAvgImpressionsGraphLimit = 10;
	$rootScope.individualHashtagAvgEngagementGraphLimit = 10;
	
	// only for individual category graphs at the moment
	$rootScope.individualCategoryAllTopGraphsLimit = 10;
	$rootScope.individualCategoryAllBottomGraphsLimit = 10;
	$rootScope.individualCategoryPostCountGraphLimit = 10;
	$rootScope.individualCategoryAvgImpressionsGraphLimit = 10;
	$rootScope.individualCategoryAvgEngagementGraphLimit = 10;
	$rootScope.individualCategoryAvgLikesGraphLimit = 10;
	$rootScope.individualCategoryAvgCommentsGraphLimit = 10;
	$rootScope.individualCategoryAvgSharesGraphLimit = 10;
	
	$rootScope.expandHashtagGraphLimit = function(data, graph, increment) {
		let individualHashtagMaxLimit = data.individualHashtagAnalyticsGraph.individualHashtagGraphData.length;
		switch (graph) {
			case 'all':
				if ($rootScope.individualHashtagAllGraphsLimit  <= (individualHashtagMaxLimit - increment)) {
					$rootScope.individualHashtagAllGraphsLimit  += increment;			
				} else if ((individualHashtagMaxLimit - $rootScope.individualHashtagAllGraphsLimit) < increment) {
					$rootScope.individualHashtagAllGraphsLimit  += (individualHashtagMaxLimit - $rootScope.individualHashtagAllGraphsLimit);
				}	
				break;
			case 'postCount':
				if ($rootScope.individualHashtagPostCountGraphLimit  <= (individualHashtagMaxLimit - increment)) {
					$rootScope.individualHashtagPostCountGraphLimit  += increment;			
				} else if ((individualHashtagMaxLimit - $rootScope.individualHashtagPostCountGraphLimit) < increment) {
					$rootScope.individualHashtagPostCountGraphLimit  += (individualHashtagMaxLimit - $rootScope.individualHashtagPostCountGraphLimit);
				}	
				break;
			case 'avgImpressions':
				if ($rootScope.individualHashtagAvgImpressionsGraphLimit  <= (individualHashtagMaxLimit - increment)) {
					$rootScope.individualHashtagAvgImpressionsGraphLimit  += increment;			
				} else if ((individualHashtagMaxLimit - $rootScope.individualHashtagAvgImpressionsGraphLimit) < increment) {
					$rootScope.individualHashtagAvgImpressionsGraphLimit  += (individualHashtagMaxLimit - $rootScope.individualHashtagAvgImpressionsGraphLimit);
				}	
				break;
			case 'avgEngagement':
				if ($rootScope.individualHashtagAvgEngagementGraphLimit  <= (individualHashtagMaxLimit - increment)) {
					$rootScope.individualHashtagAvgEngagementGraphLimit  += increment;			
				} else if ((individualHashtagMaxLimit - $rootScope.individualHashtagAvgEngagementGraphLimit) < increment) {
					$rootScope.individualHashtagAvgEngagementGraphLimit  += (individualHashtagMaxLimit - $rootScope.individualHashtagAvgEngagementGraphLimit);
				}	
				break;
			default:
				if ($rootScope.individualHashtagAllGraphsLimit  <= (individualHashtagMaxLimit - increment)) {
					$rootScope.individualHashtagAllGraphsLimit  += increment;			
				} else if ((individualHashtagMaxLimit - $rootScope.individualHashtagAllGraphsLimit) < increment) {
					$rootScope.individualHashtagAllGraphsLimit  += (individualHashtagMaxLimit - $rootScope.individualHashtagAllGraphsLimit);
				}
		}
	}
	
	$rootScope.collapseHashtagGraphLimit = function(graph) {
		switch (graph) {
			case 'all':
				$rootScope.individualHashtagAllGraphsLimit = 10;
				break;
			case 'postCount':
				$rootScope.individualHashtagPostCountGraphLimit = 10;
				break;
			case 'avgImpressions':
				$rootScope.individualHashtagAvgImpressionsGraphLimit = 10;
				break;
			case 'avgEngagement':
				$rootScope.individualHashtagAvgEngagementGraphLimit = 10;
				break;
			default:
				$rootScope.individualHashtagAllGraphsLimit = 10;
		}
	}

	$rootScope.orderHashtagGraphBy = function(data, graphType, propertyName, order) {
		if (graphType === 'individualHashtag') {			
			if (order === 'desc') {
				switch (propertyName) {
				case 'postCount':
					data.individualHashtagAnalyticsGraph.postCountGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName]) 
					break;
				case 'avgImpressions':
					data.individualHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName])
					break;
				case 'avgEngagement':
					data.individualHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName])
					break;
				}
			} else {
				switch (propertyName) {
				case 'postCount':
					data.individualHashtagAnalyticsGraph.postCountGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName]);
					break;
				case 'avgImpressions':
					data.individualHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName])
					break;
				case 'avgEngagement':
					data.individualHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName])
					break;
				}
			}
		} else if (graphType === 'hashtagBucket') {
			if (order === 'desc') {
				switch (propertyName) {
				case 'postCount':
					data.bucketHashtagAnalyticsGraph.postCountGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(b.name) - parseInt(a.name) : b[propertyName] - a[propertyName]
					});
					break;
				case 'avgImpressions':
					data.bucketHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(b.name) - parseInt(a.name) : b[propertyName] - a[propertyName]
					});
					break;
				case 'avgEngagement':
					data.bucketHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(b.name) - parseInt(a.name) : b[propertyName] - a[propertyName]
					});
					break;
				}
			} else {
				switch (propertyName) {
				case 'postCount':
					data.bucketHashtagAnalyticsGraph.postCountGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(a.name) - parseInt(b.name) : a[propertyName] - b[propertyName]
					});
					break;
				case 'avgImpressions':
					data.bucketHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(a.name) - parseInt(b.name) : a[propertyName] - b[propertyName]
					});
					break;
				case 'avgEngagement':
					data.bucketHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(a.name) - parseInt(b.name) : a[propertyName] - b[propertyName]
					});
					break;
				}
			}
		}
	}
	
	$rootScope.expandCategoryGraphLimit = function(data, graph, increment) {
		let individualCategoryMaxLimit = data.length;
		switch (graph) {
			case 'allTop':
				if ($rootScope.individualCategoryAllTopGraphsLimit  <= (individualCategoryMaxLimit - increment)) {
					$rootScope.individualCategoryAllTopGraphsLimit  += increment;			
				} else if ((individualCategoryMaxLimit - $rootScope.individualCategoryAllTopGraphsLimit) < increment) {
					$rootScope.individualCategoryAllTopGraphsLimit  += (individualCategoryMaxLimit - $rootScope.individualCategoryAllTopGraphsLimit);
				}	
				break;
			case 'allBottom':
				if ($rootScope.individualCategoryAllBottomGraphsLimit  <= (individualCategoryMaxLimit - increment)) {
					$rootScope.individualCategoryAllBottomGraphsLimit  += increment;			
				} else if ((individualCategoryMaxLimit - $rootScope.individualCategoryAllBottomGraphsLimit) < increment) {
					$rootScope.individualCategoryAllBottomGraphsLimit  += (individualCategoryMaxLimit - $rootScope.individualCategoryAllBottomGraphsLimit);
				}		
				break;
			case 'postCount':
				if ($rootScope.individualCategoryPostCountGraphLimit  <= (individualCategoryMaxLimit - increment)) {
					$rootScope.individualCategoryPostCountGraphLimit  += increment;			
				} else if ((individualCategoryMaxLimit - $rootScope.individualCategoryPostCountGraphLimit) < increment) {
					$rootScope.individualCategoryPostCountGraphLimit  += (individualCategoryMaxLimit - $rootScope.individualCategoryPostCountGraphLimit);
				}	
				break;
			case 'avgImpressions':
				if ($rootScope.individualCategoryAvgImpressionsGraphLimit  <= (individualCategoryMaxLimit - increment)) {
					$rootScope.individualCategoryAvgImpressionsGraphLimit  += increment;			
				} else if ((individualCategoryMaxLimit - $rootScope.individualCategoryAvgImpressionsGraphLimit) < increment) {
					$rootScope.individualCategoryAvgImpressionsGraphLimit  += (individualCategoryMaxLimit - $rootScope.individualCategoryAvgImpressionsGraphLimit);
				}	
				break;
			case 'avgEngagement':
				if ($rootScope.individualCategoryAvgEngagementGraphLimit  <= (individualCategoryMaxLimit - increment)) {
					$rootScope.individualCategoryAvgEngagementGraphLimit  += increment;			
				} else if ((individualCategoryMaxLimit - $rootScope.individualCategoryAvgEngagementGraphLimit) < increment) {
					$rootScope.individualCategoryAvgEngagementGraphLimit  += (individualCategoryMaxLimit - $rootScope.individualCategoryAvgEngagementGraphLimit);
				}	
				break;
			case 'avgLikes':
				if ($rootScope.individualCategoryAvgLikesGraphLimit  <= (individualCategoryMaxLimit - increment)) {
					$rootScope.individualCategoryAvgLikesGraphLimit  += increment;			
				} else if ((individualCategoryMaxLimit - $rootScope.individualCategoryAvgLikesGraphLimit) < increment) {
					$rootScope.individualCategoryAvgLikesGraphLimit  += (individualCategoryMaxLimit - $rootScope.individualCategoryAvgLikesGraphLimit);
				}	
				break;
			case 'avgComments':
				if ($rootScope.individualCategoryAvgCommentsGraphLimit  <= (individualCategoryMaxLimit - increment)) {
					$rootScope.individualCategoryAvgCommentsGraphLimit  += increment;			
				} else if ((individualCategoryMaxLimit - $rootScope.individualCategoryAvgCommentsGraphLimit) < increment) {
					$rootScope.individualCategoryAvgCommentsGraphLimit  += (individualCategoryMaxLimit - $rootScope.individualCategoryAvgCommentsGraphLimit);
				}	
				break;
			case 'avgShares':
				if ($rootScope.individualCategoryAvgSharesGraphLimit  <= (individualCategoryMaxLimit - increment)) {
					$rootScope.individualCategoryAvgSharesGraphLimit  += increment;			
				} else if ((individualCategoryMaxLimit - $rootScope.individualCategoryAvgSharesGraphLimit) < increment) {
					$rootScope.individualCategoryAvgSharesGraphLimit  += (individualCategoryMaxLimit - $rootScope.individualCategoryAvgSharesGraphLimit);
				}	
				break;
		}
	}
	
	$rootScope.collapseCategoryGraphLimit = function(graph) {
		switch (graph) {
			case 'allTop':
				$rootScope.individualCategoryAllTopGraphsLimit = 10;
				break;
			case 'allBottom':
				$rootScope.individualCategoryAllBottomGraphsLimit = 10;
				break;
			case 'postCount':
				$rootScope.individualCategoryPostCountGraphLimit = 10;
				break;
			case 'avgImpressions':
				$rootScope.individualCategoryAvgImpressionsGraphLimit = 10;
				break;
			case 'avgEngagement':
				$rootScope.individualCategoryAvgEngagementGraphLimit = 10;
				break;
			case 'avgLikes':
				$rootScope.individualCategoryAvgLikesGraphLimit = 10;
				break;
			case 'avgComments':
				$rootScope.individualCategoryAvgCommentsGraphLimit = 10;
				break;
			case 'avgShares':
				$rootScope.individualCategoryAvgSharesGraphLimit = 10;
				break;
		}
	}

	$rootScope.orderHashtagGraphBy = function(data, graphType, propertyName, order) {
		if (graphType === 'individualHashtag') {			
			if (order === 'desc') {
				switch (propertyName) {
				case 'postCount':
					data.individualHashtagAnalyticsGraph.postCountGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName]) 
					break;
				case 'avgImpressions':
					data.individualHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName])
					break;
				case 'avgEngagement':
					data.individualHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName])
					break;
				}
			} else {
				switch (propertyName) {
				case 'postCount':
					data.individualHashtagAnalyticsGraph.postCountGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName]);
					break;
				case 'avgImpressions':
					data.individualHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName])
					break;
				case 'avgEngagement':
					data.individualHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName])
					break;
				}
			}
		} else if (graphType === 'hashtagBucket') {
			if (order === 'desc') {
				switch (propertyName) {
				case 'postCount':
					data.bucketHashtagAnalyticsGraph.postCountGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(b.name) - parseInt(a.name) : b[propertyName] - a[propertyName]
					});
					break;
				case 'avgImpressions':
					data.bucketHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(b.name) - parseInt(a.name) : b[propertyName] - a[propertyName]
					});
					break;
				case 'avgEngagement':
					data.bucketHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(b.name) - parseInt(a.name) : b[propertyName] - a[propertyName]
					});
					break;
				}
			} else {
				switch (propertyName) {
				case 'postCount':
					data.bucketHashtagAnalyticsGraph.postCountGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(a.name) - parseInt(b.name) : a[propertyName] - b[propertyName]
					});
					break;
				case 'avgImpressions':
					data.bucketHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(a.name) - parseInt(b.name) : a[propertyName] - b[propertyName]
					});
					break;
				case 'avgEngagement':
					data.bucketHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => {
						return b[propertyName] == a[propertyName] ? parseInt(a.name) - parseInt(b.name) : a[propertyName] - b[propertyName]
					});
					break;
				}
			}
		}
	}
	
	$rootScope.alphabetizeHashtagGraphBy = function(data, graphType, propertyName, order) {
		if (graphType === 'individualHashtag') {			
			if (order === 'desc') {
				switch (propertyName) {
				case 'postCount':
					data.individualHashtagAnalyticsGraph.postCountGraph.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? -1 : 1)
					break;
				case 'avgImpressions':
					data.individualHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? -1 : 1)
					break;
				case 'avgEngagement':
					data.individualHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? -1 : 1)
					break;
				}
			} else {
				switch (propertyName) {
				case 'postCount':
					data.individualHashtagAnalyticsGraph.postCountGraph.sort((a, b) => b.name.toUpperCase() > a.name.toUpperCase() ? -1 : 1)
					break;
				case 'avgImpressions':
					data.individualHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => b.name.toUpperCase() > a.name.toUpperCase() ? -1 : 1)
					break;
				case 'avgEngagement':
					data.individualHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => b.name.toUpperCase() > a.name.toUpperCase() ? -1 : 1)
					break;
				}
			}
		}  else if (graphType === 'hashtagBucket') {
			if (order === 'desc') {
				switch (propertyName) {
					case 'postCount':
						data.bucketHashtagAnalyticsGraph.postCountGraph.sort((a, b) => {
							// note: parseInt('31+') returns 31. parseInt('6-10') returns 6.
							return parseInt(b.name) - parseInt(a.name);
						});
						break;
					case 'avgImpressions':
						data.bucketHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => {
							return parseInt(b.name) - parseInt(a.name);
						});
						break;
					case 'avgEngagement':
						data.bucketHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => {
							return parseInt(b.name) - parseInt(a.name);
						});
						break;
				}
			} else {
				switch (propertyName) {
					case 'postCount':
						data.bucketHashtagAnalyticsGraph.postCountGraph.sort((a, b) => {
							return parseInt(a.name) - parseInt(b.name);
						});
						break;
					case 'avgImpressions':
						data.bucketHashtagAnalyticsGraph.avgImpressionsGraph.sort((a, b) => {
							return parseInt(a.name) - parseInt(b.name);
						})
						break;
					case 'avgEngagement':
						data.bucketHashtagAnalyticsGraph.avgEngagementGraph.sort((a, b) => {
							return parseInt(a.name) - parseInt(b.name);
						})
						break;
				}
			}
		}
	}
	
	$rootScope.orderCategoryGraphBy = function(data, propertyName, order) {		
		if (order === 'desc') {
			switch (propertyName) {
			case 'postCount':
				data.individualCategoryAnalyticsGraph.postCountGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName]) 
				break;
			case 'avgImpressions':
				data.individualCategoryAnalyticsGraph.avgImpressionsGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName])
				break;
			case 'avgEngagement':
				data.individualCategoryAnalyticsGraph.avgEngagementGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName])
				break;
			case 'avgLikes':
				data.individualCategoryAnalyticsGraph.avgLikesGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName]) 
				break;
			case 'avgComments':
				data.individualCategoryAnalyticsGraph.avgCommentsGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName])
				break;
			case 'avgShares':
				data.individualCategoryAnalyticsGraph.avgSharesGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName])
				break;
			}
		} else {
			switch (propertyName) {
			case 'postCount':
				data.individualCategoryAnalyticsGraph.postCountGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName]);
				break;
			case 'avgImpressions':
				data.individualCategoryAnalyticsGraph.avgImpressionsGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName])
				break;
			case 'avgEngagement':
				data.individualCategoryAnalyticsGraph.avgEngagementGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName])
				break;
			case 'avgLikes':
				data.individualCategoryAnalyticsGraph.avgLikesGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName]);
				break;
			case 'avgComments':
				data.individualCategoryAnalyticsGraph.avgCommentsGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName])
				break;
			case 'avgShares':
				data.individualCategoryAnalyticsGraph.avgSharesGraph.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName])
				break;
			}
		}
	}
	
	$rootScope.orderCategoryGraphBy2 = function(data, propertyName, order) {		
		if (order === 'desc') {
			data.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : b[propertyName] - a[propertyName]); 
		} else {
			data.sort((a, b) => b[propertyName] == a[propertyName] ? (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1) : a[propertyName] - b[propertyName]);
		}
	}
	
	$rootScope.alphabetizeCategoryGraphBy = function(data, order) {		
		if (order === 'desc') {
			data.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? -1 : 1)
		} else {
			data.sort((a, b) => b.name.toUpperCase() > a.name.toUpperCase() ? -1 : 1)
		}
	}
	
	$scope.init();
}]);
    
function initAnalyticsChart()
{
	setTimeout(function(){
	var chart = d3.select("#postAnalyticsGraph svg");
  	
  /*	d3.select("#postAnalyticsGraph svg").selectAll("circle")
  		.each(function(d) {
      		 d.onclick = function(){ console.log("Clicked", d); };
      		 console.log("for ea", d);
   		 }); */
  	
  	d3.select("#postAnalyticsGraph svg").selectAll("circle")
   		.each(function(d) {
        	 var circle = d3.select(d);
        	 circle.onclick = function(){ console.log("Clicked", d); };
   		 });

  }, 1000);
}

angular.element(document).ready(function () {
	var element = angular.element(document.querySelector('#mainControllerContext'));

    //This will be truthy if initialized and falsey otherwise.
    var isInitialized = element.injector();
    if (!isInitialized) {
		angular.bootstrap(document, ["demo-analytics-app"]);
    }
});

export default app;